import {
  defineStore
} from 'pinia';
import { ref } from 'vue';
// import LZString from 'lz-string'
import { debounce } from 'lodash';

import { userStore } from "@/stores/userStore";
import md5 from 'md5';

import opentype from 'opentype.js'; //עבור קריאת קובץ גופן והמרתו לתגית אסויגי
// import { calculateSize } from '@iconify/vue';


const baseURL = eval('embServerURL'); //"http://embapi.ideali.club"; //
const baseIconsURL = eval('embBaseIconsURL'); //"https://embgift.myshopify.com/cdn/shop/t/5/assets"; //
// const baseURL="http://localhost:8080/"


// const changeLayerBySeconds = 4; //מספר שניות לכל החלפת צבע/שכבה
// const sumStichesToSeconds = 4; //מספר מתיחות לשניה
// const priceTillOneM = 10; //מספר מתיחות לשניה
// const priceTillOneHalfM = 15; //מספר מתיחות לשניה
// const priceTillTwoM = 20; //מספר מתיחות לשניה



// export const uStore = defineStore('userStore', {
//   state: () => {
//     return {

//     }
//   });
export const designerStore = defineStore('designerStore', {
  state: () => {
    return {
      keysArray: ['allColors', 'allArts', 'allFonts', 'allMonograms', 'allMaterials', 'allColorsSVG', 'allArtsSVG', 'allArtCategories', 'allSvgArtCategories', 'allFontsFiles'], //, 'allProducts'
      conflictArray: {},
      isConflict: false,
      // uStore,
      testArt: {
        "imageName": "Black_Duffle_on_Wheels",
        "artID": 12,
        "artSizeID": 13,
        "artArc": 0,
        "colors": [
          32
        ],

        'dragTransform': {
          // 'transformString': transformString,
          'x': 183,
          'y': 149,
          'width': 334,
          'height': 256,
          'scale': {
            'scaleX': 1.5,
            'scaleY': 1.5
          },
          'rotate': 18,
          'topX': 0,
          'topY': 0,
        },


        "dragLocation": {
          "x": 0,
          "y": 0
          // "x": 455.22171616250716,
          // "y": 130.06334747500208
        },
        "location": {
          "x": 0,
          "y": 0
          // "x": 455.22171616250716,
          // "y": 130.06334747500208
        },
        "dragSize": {
          "w": 334,
          "h": 256
        }
      },
      pageTotal: 0,
      countFilter: 0,
      countTotal: 0,
      allColors: {},
      allArts: {},
      allUserArts: {},
      allUserArtsSvg: {},
      allFonts: {},
      allMonograms: {},
      allStoresHashs: {},
      allProducts: {},
      allMaterials: {},
      allArtCategories: {},
      allSvgArtCategories: {},
      // userDesigns: {},
      lastCopyBox: {},
      blackColorIdDst: 59,
      blackColorIdSvg: 7,
      blackForWoodAndGlassId: 1,

  allColorsSVG: {},
  allArtsSVG: ref({}),
      allFontsFiles: {},
      currentEditingProps: {
        // "productId": "8838828589352",
        // "variantId": "47403201626408",
        // "isDesignDst": false,
        // "dpi": "56",
        // "textPreview": "abc",
        // "imageToPreview": "Black_Duffle_on_Wheels", //"Black Duffle on Wheels",
        "currentPreviewIndex": -1,
        "currentPreview": "text",
        "showEditingTexts": true,
        "showEditingArts": true,
        "changeSelectedArt": false,
        "changeSelectedMonogram": false,
        "newArt": null,
       "newArtsvg": null,

        "newMonogram": null,
        // "currentImgPath": "url(https://cdn.shopify.com/s/files/1/0692/2043/4216/products/bag3.jpg?v=1671543058)",
      },
      // currentEditingProps: {
      //   "productId": "8838828589352",
      //   "variantId": "47403201626408",
      //   "isDesignDst": false,
      //   // "productId": "8048603627816",
      //   // "variantId": "44219817165096",
      //   "dpi": "56",
      //   "textPreview": "abc",
      //   "imageToPreview": "Black_Duffle_on_Wheels", //"Black Duffle on Wheels",
      //   "currentPreviewIndex": -1,
      //   "currentPreview": "text",
      //   "showEditingTexts": true,
      //   "showEditingArts": true,
      //   "changeSelectedArt": false,
      //   "changeSelectedMonogram": false,
      //   "newArt": null,
      //   "newMonogram": null,
      //   "currentImgPath": "url(https://cdn.shopify.com/s/files/1/0692/2043/4216/products/bag3.jpg?v=1671543058)",
      // },
      baseURL: baseURL,
      baseIconsURL: baseIconsURL,
      isLoadingComplete: false,
      movInd: 0
    }
  },
  actions: {

    persistData() {
      localStorage.setItem('storeData', JSON.stringify(this.$state));
    },

    resetCurrentEditingProps() {
      this.currentEditingProps = {
        "productId": "8048603627816",
        "variantId": "44219817165096",
        "isDesignDst": false,
        "dpi": "56",
        "textPreview": "abc",
        "imageToPreview": "front_bag",
        "currentPreviewIndex": -1,
        "currentPreview": "text",
        "changeSelectedArt": false,
        "changeSelectedMonogram": false,
        "newArt": null,
        "newMonogram": null,
        "cuurentImage": this.getCurrentProduct(),
        "currentImgPath": "url(https://cdn.shopify.com/s/files/1/0692/2043/4216/products/bag3.jpg?v=1671543058)",
      };
    },
    getUserDesignsTextsContentful() {
      const uStore = userStore();
      // console.log("getUserDesignsTextsContentful");
      return Object.values(
        uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId]
          .imgVariants[this.currentEditingProps.imageToPreview].texts
      ).filter((x) => x.text != "");
    },
    getImgPath(image) {
      return "url(" + image.file.relativePath.replaceAll("\\", "\\\\") + ")";
    },
    getCurrentProduct() {
      // console.log('getCurrentProduct');
      return this.allProducts[this.currentEditingProps.productId].variants[this.currentEditingProps.variantId]
        .images[this.currentEditingProps.imageToPreview];
    },
    addArtCategory(categoryName) {
      const categoryID = this.getNextKey(this.allArtCategories.value || {});
      this.allArtCategories.value[categoryID] = {
        categoryID: categoryID,
        categoryName: categoryName,
        isAvailable: true,
      };
    },
    addSvgArtCategory(categoryName) {
      const categoryID = this.getNextKey(this.allSvgArtCategories.value || {});
      this.allSvgArtCategories.value[categoryID] = {
        categoryID: categoryID,
        categoryName: categoryName,
        isAvailable: true,
      };
    },
    removeArtCategory(categoryID) {
      this.allArtCategories.value[categoryID].isAvailable = false;
      //מחפש את כל הארטים שיש להם כזו קטגוריה ושם להם את הקוד של קגוריית עוד
      var moreCategoryObj = Object.values(this.allArtCategories.value || {}).find(f => f.categoryName == 'More');
      var moreCategoryId = -1;
      if (moreCategoryObj != null) {
        moreCategoryId = moreCategoryObj.categoryID;
      }
      Object.values(this.allArts).filter(f => f.artCategoryID == categoryID).forEach(f =>
        f.artCategoryID = moreCategoryId
      );
    },
    removeSvgArtCategory(categoryID) {
      this.allSvgArtCategories.value[categoryID].isAvailable = false;
      //מחפש את כל הארטים שיש להם כזו קטגוריה ושם להם את הקוד של קגוריית עוד
      var moreCategoryObj = Object.values(this.allSvgArtCategories.value || {}).find(f => f.categoryName == 'More');
      var moreCategoryId = -1;
      if (moreCategoryObj != null) {
        moreCategoryId = moreCategoryObj.categoryID;
      }
      Object.values(this.allArtsSVG.value || {}).filter(f => f.artCategoryID == categoryID).forEach(f =>
        f.artCategoryID = moreCategoryId
      );
    },
    addColor(colorName, color, threadCode) {
      const colorID = this.getNextKey(this.allColors.value || {});
      this.allColors.value[colorID] = {
        colorID: colorID,
        colorName: colorName,
        color: color,
        threadCode: threadCode,
        isAvailable: true,
      };
    },
      updateSvgArt(artID, updatedFields) {
      // עדכון שדות בארט SVG
  const svgArt = this.allArtsSVG.value[artID];
  if (!svgArt) return;
  // עדכן שם
  if (updatedFields.artName !== undefined) svgArt.artName = updatedFields.artName;
  // עדכן קטגוריה
  if (updatedFields.artCategoryID !== undefined) svgArt.artCategoryID = updatedFields.artCategoryID;
  // עדכן צבעים
  if (updatedFields.defaultColors !== undefined) svgArt.defaultColors = updatedFields.defaultColors;
  // עדכן תמונה
  // if (updatedFields.svgFile !== undefined) svgArt.svgFile = updatedFields.svgFile;
  // אפשר להוסיף עוד שדות לפי הצורך
  this.persistData();
  // טריגר ריאקטיביות
  this.allArtsSVG.value = { ...this.allArtsSVG.value };
    },
  

    addColorSVG(colorName, color, threadCode) {
      if(this.allColorsSVG.value == undefined) {
        this.allColorsSVG.value = {};
      }
      const colorID = this.getNextKey(this.allColorsSVG.value || {});
      this.allColorsSVG.value[colorID] = {
        colorID: colorID,
        colorName: colorName,
        color: color,
        threadCode: threadCode,
        isAvailable: true,
      };
    },
    getAllArtCategories() {
      if (this.allArtCategories.value && !Object.values(this.allArtCategories.value).find(f => f.categoryName == 'More' && f.isAvailable == true)) {
        var i = this.getNextKey(this.allArtCategories.value || {}); //Math.max(0, ...Object.keys(this.allArtCategories.value || {}).map(Number)) + 1;
        this.allArtCategories.value[i.toString()] = {
          "categoryID": i,
          "categoryName": "More",
          "isAvailable": true
        };
      } if (this.allArtCategories.value && !Object.values(this.allArtCategories.value).find(f => f.categoryName == 'My Arts' && f.isAvailable == true)) {
        i = this.getNextKey(this.allArtCategories.value || {});
        this.allArtCategories.value[i.toString()] = {
          "categoryID": i,
          "categoryName": "My Arts",
          "isAvailable": true
        };
      }
      return Object.values(this.allArtCategories.value || {}).filter(cat => cat.isAvailable == true);
    },
    getAllSvgArtCategories() {
      if (this.allSvgArtCategories.value && !Object.values(this.allSvgArtCategories.value).find(f => f.categoryName == 'More' && f.isAvailable == true)) {
        var i = this.getNextKey(this.allSvgArtCategories.value || {});
        this.allSvgArtCategories.value[i.toString()] = {
          "categoryID": i,
          "categoryName": "More",
          "isAvailable": true
        };
      } if (this.allSvgArtCategories.value && !Object.values(this.allSvgArtCategories.value).find(f => f.categoryName == 'My Arts' && f.isAvailable == true)) {
        i = this.getNextKey(this.allSvgArtCategories.value || {});
        this.allSvgArtCategories.value[i.toString()] = {
          "categoryID": i,
          "categoryName": "My Arts",
          "isAvailable": true
        };
      }
      return Object.values(this.allSvgArtCategories.value || {}).filter(cat => cat.isAvailable == true);
    },
    removeColor(colorID) {
      this.allColors.value[colorID].isAvailable = false;
    },
    removeColorSVG(colorID) {
      this.allColorsSVG.value[colorID].isAvailable = false;
    },
    getColor(colorID) {
      return this.allColors.value[colorID];
    },
    // getAllFontSizes(fontID) {
    //   return Object.values(this.allFonts.value[fontID].sizes).filter(fontSize => fontSize.isAvailable == true)
    //     .sort((a, b) => a.FontHeight - b.FontHeight);
    // },
    getAllFontSizesContainsText(fontID, text) {
      const textChars = Array.from(new Set(text.split(''))); // case-sensitive unique chars
    
      const sorted = Object.values(this.allFonts.value[fontID].sizes)
        .filter(fontSize => {
          if (!fontSize.isAvailable) return false;
    
          const dic = fontSize.DictCharacters || {};
          // Check if every char from text exists as a key in DictCharacters
          return textChars.every(char => Object.prototype.hasOwnProperty.call(dic, char));
        })
        .sort((a, b) => a.FontHeight - b.FontHeight);
    
      const result = {};
      for (const fontSize of sorted) {
        result[fontSize.sizeID] = fontSize;
      }
    
      return result;
    },    
    getAllFontSizes(fontID) {
      const sorted = Object.values(this.allFonts.value[fontID].sizes)
        //.filter(fontSize => fontSize.isAvailable)
        .sort((a, b) => a.FontHeight - b.FontHeight);
    
      const result = {};
      for (const fontSize of sorted) {
        result[fontSize.sizeID] = fontSize;
      }
    
      return result;
    },
    getAllFontSizesToSelect(fontID) {
      const sorted = Object.values(this.allFonts.value[fontID].sizes)
        .filter(fontSize => fontSize.isAvailable)
        .sort((a, b) => a.FontHeight - b.FontHeight);
    
      const result = [];
      for (const fontSize of sorted) {
        let sizeObj = {'sizeID': fontSize.sizeID, 'sizeName': fontSize.sizeName};
        result.push(sizeObj);
        //result[fontSize.sizeID] = fontSize.sizeName;
      }
    
      return result;
    },
    getTextWidthByAllSizes(fontID, text) {
      return Object.values(this.allFonts.value[fontID].sizes).filter(fontSize => fontSize.isAvailable == true)
        .map(m => this.getTextLength(text, fontID, m.sizeID))
        .sort((a, b) => a - b);
    },
    getAllUserArts() {
      var res = Object.values(this.allUserArts.value || {});
      return res;
    },
    getAllSvgUserArts() {
      var res = Object.values(this.allUserArtsSvg.value || {});
      return res;
    },
    getAllUserDesignArtsNotEmpty() {
      const uStore = userStore();
      var res = Object.values(uStore.userDesigns[
                          this.currentEditingProps.productId
                        ].designs[this.currentEditingProps.variantId]
                          .imgVariants[
                          this.currentEditingProps.imageToPreview
                        ].userArts).filter(f => f.userUploadedArtID != null);
      return res;
    },
    getAllUserArtSizes(userArtID) {
      return Object.values(this.allUserArts.value[userArtID]?.dstSizesJson?.sizes || {})
        .filter(artSize => artSize.isAvailable === true);
    },
    getAllArts() {
      return Object.values(this.allArts.value || {}).filter(art => art.isAvailable == true);
    },
    getAllSvgArts() {
  return Object.values(this.allArtsSVG.value || {}).filter(art => art.isAvailable == true);
    },
    getArtCategoreiesList() {
      var filteredCategories = Object.values(this.allArtCategories.value || {}).filter(category => category.isAvailable == true && category.categoryName !== 'More');
      var category2 = Object.values(this.allArtCategories.value || {}).find(category => category.categoryName === 'More');
      filteredCategories.push(category2);
      return filteredCategories;
      //return Object.values(this.allArtCategories).filter(artCategory => artCategory.isAvailable == true);
    },
    getAllArtsBySearchText(searchText) {
      var allArtsLocal = this.currentEditingProps.isDesignDst == true ? JSON.parse(JSON.stringify(this.allArts.value || {})) : JSON.parse(JSON.stringify(this.allArtsSVG.value || {}));
      var artsList = Object.values(allArtsLocal).filter(art => art.artID >= 100000 || (art.isAvailable == true && art.artName.includes(searchText)));

      return artsList;
    },
    getAllArtSizes(artID) {
      return Object.values(this.allArts.value[artID].sizes).filter(artSize => artSize.isAvailable == true);
    },
    getAllArtSizesNameID(artID) {
      var allArtsLocal = JSON.parse(JSON.stringify(this.allArts.value[artID].sizes));
      var artSizesList = Object.values(allArtsLocal).filter(artSize => artSize.isAvailable == true)
        .sort((a, b) => parseFloat(a.sizeName.split("'")) < parseFloat(b.sizeName.split("'")));

      return artSizesList;
    },
    getAllColors() {
      return Object.values(this.allColors?.value || {}).filter(color => color.isAvailable == true);
    },
    getAllSvgColors() {
      return Object.values(this.allColorsSVG?.value || {}).filter(color => color.isAvailable == true);
    },
    getAllColorsDict() {
      const allColors = this.allColors?.value || {};
      return Object.fromEntries(
        Object.entries(allColors).filter(([, color]) => color.isAvailable === true)
      );
    },
    getAllSvgColorsDict() {
      const allSvgColors = this.allColorsSVG?.value || {};
      return Object.fromEntries(
        Object.entries(allSvgColors).filter(([, color]) => color.isAvailable === true)
      );
    },
    getAllSVGColors() {
      return Object.values(this.allColorsSVG?.value || {}).filter(color => color.isAvailable == true && color.colorID != this.blackForWoodAndGlassId);
    },
    getAllFontsWithoutMaterials() {
      var materials = this.allProducts[this.currentEditingProps.productId].productMaterial;
      var fontsInMaterials = [];
      materials.forEach(f => {
        if (this.allMaterials.value[f] && this.allMaterials.value[f].fontsToExcludeID) {
          fontsInMaterials = fontsInMaterials.concat(this.allMaterials.value[f].fontsToExcludeID);
        }
      });
      // הסרת כפילויות
      fontsInMaterials = [...new Set(fontsInMaterials)];
      
      return Object.values(this.allFonts.value || {}).filter(font => font.isAvailable == true && font.onlyForMonogram == false && !fontsInMaterials.includes(font.fontID));
    },
    getAllFonts() {
      return Object.values(this.allFonts.value || {}).filter(font => font.isAvailable == true && font.onlyForMonogram == false);
    },
    getAllFontsToMonogram() {
      return Object.values(this.allFonts.value || {})
      .filter(font => 
        font.isAvailable == true
        );
    },
    getAllFontsToMonogramDict() {
      const allFonts = this.allFonts?.value || {};
      return Object.fromEntries(
        Object.entries(allFonts)
        .filter(([, font]) => font.isAvailable === true)
      );
    },
    getAllFontsFiles(){
      return Object.values(this.allFontsFiles.value || {}).filter(font => font.isAvailable == true);
    },
    getAllProducts() {
      return Object.values(this.allProducts).filter(product => product.isAvailable == true);
    },
    getAllProductSkus(productID) {
      return Object.values(this.allProducts[productID].variants).map((x) => x.sku).join(", ");
    },
    // getAllProductsWithFilters(searchSku, searchProductName) {
    //   return Object.values(this.allProducts).filter(product => product.isAvailable == true &&
    //     this.getAllProductSkus(product.productID).toLocaleLowerCase().includes(searchSku.toLocaleLowerCase()) &&
    //     product.productName.toLocaleLowerCase().includes(searchProductName.toLocaleLowerCase()));
    // },
    getAllProductVariants(productID) {
      return Object.values(this.allProducts[productID].variants);//.filter(variant => variant.isAvailable == true);
    },
    getAllProductVariantImages(productID, variantID) {
      return Object.values(this.allProducts[productID].variants[variantID].images);
    },
    getAllProductVariantUsefulImages(productID, variantID) {
      return Object.values(this.allProducts[productID]?.variants[variantID]?.images).filter(image => image.isUseful == true);
    },
    getAllProductVariantUsefulImagesWithoutImg(productID, variantID, imageName) {
      return Object.values(this.allProducts[productID]?.variants[variantID]?.images).filter(image => image.isUseful == true && image.imageName != imageName);
    },
    getAllImagesFromList(productID, variantID, imagesNames, currentImageName) {
      var allImages = Object.values(this.allProducts[productID].variants[variantID].images).filter(image => image.isUseful == true && image.imageName != currentImageName);
      return allImages.filter(f => imagesNames.find(i => i == f.imageName) != null);
    },

    getAllMonograms() {
      return Object.values(this.allMonograms.value || {}).filter(monogram => monogram.isAvailable == true);
    },
    getAllMonogramsWithoutMaterials() {
    var materials = this.allProducts[this.currentEditingProps.productId].productMaterial;
    var fontsInMaterials = [];
    
    materials.forEach(f => {
        if (this.allMaterials.value[f] && this.allMaterials.value[f].fontsToExcludeID) {
            fontsInMaterials = fontsInMaterials.concat(this.allMaterials.value[f].fontsToExcludeID);
        }
    });

    // הסרת כפילויות
    fontsInMaterials = [...new Set(fontsInMaterials)];

    return Object.values(this.allMonograms.value || {})
    .filter(monogram => {
        // מערך ה-IDs של הפונטים במונוגרמה הנוכחית (מסונן מ-null/undefined)
        const currentFonts = [
            monogram.leftChar.fontID,
            monogram.middleChar?.fontID,
            monogram.rightChar.fontID
        ].filter(id => id != null);

        // 1. בדיקה: האם אחד מהפונטים נשלל ע"י המטריאל?
        const hasBlockedFont = currentFonts.some(id => fontsInMaterials.includes(id));

        // 2. בדיקה: האם כל הפונטים קיימים ב-allFonts וגם מסומנים כזמינים (isAvailable == true)?
        const allFontsValid = currentFonts.every(id => {
            return this.allFonts.value[id] && this.allFonts.value[id].isAvailable === true;
        });

        // החזרת מונוגרמה רק אם היא זמינה בעצמה, אין לה פונט חסום, וכל הפונטים שלה זמינים במערכת
        return monogram.isAvailable === true && !hasBlockedFont && allFontsValid;
    });
},
getAllMonogramsAvailableFonts() {
    return Object.values(this.allMonograms.value || {})
    .filter(monogram => {
        // מערך ה-IDs של הפונטים במונוגרמה הנוכחית (מסונן מ-null/undefined)
        const currentFonts = [
            monogram.leftChar.fontID,
            monogram.middleChar?.fontID,
            monogram.rightChar.fontID
        ].filter(id => id != null);

        // 2. בדיקה: האם כל הפונטים קיימים ב-allFonts וגם מסומנים כזמינים (isAvailable == true)?
        const allFontsValid = currentFonts.every(id => {
            return this.allFonts.value[id] && this.allFonts.value[id].isAvailable === true;
        });

        // החזרת מונוגרמה רק אם היא זמינה בעצמה, אין לה פונט חסום, וכל הפונטים שלה זמינים במערכת
        return monogram.isAvailable === true && allFontsValid;
    });
},
    getAllMaterials() {
      return Object.values(this.allMaterials.value || {}).filter(material => material.isAvailable == true);
    },
    getAllTextFonts() {
      const uStore = userStore();
      var texts = uStore.userDesigns[this.currentEditingProps.productId].designs[
          this.currentEditingProps.variantId
        ].imgVariants[this.currentEditingProps.imageToPreview].texts;
        console.log('texts = ', texts);
      return Object.values(this.allFonts.value || {}).filter(font => font.onlyForMonogram == false && font.isAvailable == true);
    },
    getAllTextFontFiles() {
      var allFontsFiles = Object.values(this.allFontsFiles.value || {}).filter(font => font.onlyForMonogram == false && font.isAvailable == true);
      var result = [];
      allFontsFiles.forEach(m => {
        m.svgContent = this.loadText(0, m.fontName, 20, this.blackColorIdSvg, m.fontID).svg;
        result.push({fontID: m.fontID, fontName: m.fontName, svgContent: m.svgContent});
      }
      );
      // result = allFontsFiles.map(m => {m.fontID, m.fontName, m.svgContent});

      // allFontsFiles.forEach(async m => 
      //   await this.loadText(m.relativeFontPath, m.fontName, this.blackColorIdSvg)
      //   .then(({ svg, width, height }) => {
      //     console.log('Generated SVG:', svg);
      //     console.log('Width:', width, 'Height:', height);
      //     m.svgContent = svg;
      //     // Insert the SVG into your app
      //     // document.getElementById('svg-container').innerHTML = svgTag;
      //   })
      //   .catch(err => {
      //     console.error('Error loading text:', err);
      //   })
      // );
      return result;
    },
    // getAllTextFontFilesToSelect() {
    //   var allFontsFiles = Object.values(this.allFontsFiles.value || {}).filter(font => font.onlyForMonogram == false && font.isAvailable == true);
    //   var result = [];
    //   allFontsFiles.forEach(m => 
    //     m.svgContent = this.loadText(0, m.fontName, 20, this.blackColorIdSvg, m.fontID)
    //     result.push({fontID: m.fontID, 
    //   );
    //   return allFontsFiles;
    // },
    getDefaultColorArray(num) {
      return Object.keys(this.getAllColorsDict()).splice(0, num);
      // return Object.keys(this.allColors.value || {}).splice(0, num);
    },
    getNextKey(dict) {
      console.log(dict);
      return (Math.max(...(Object.keys(dict || {})).map(x => +x)) | 0) + 1;
      //return (Math.max(...Object.keys(dict).map(x => +x)) | 0) + 1;
    },
getOrCreateUserID () {
  if (!localStorage.getItem('visitor_id')) {
    const id = crypto.randomUUID(); // Generate unique ID
    localStorage.setItem('visitor_id', id);
  }
  return localStorage.getItem('visitor_id');
  },
  async userUploadArt(fileContent, designUserArtIndex) {
    const uStore = userStore();
    let userId = this.getOrCreateUserID();

    const rawResponse = await fetch(baseURL + '/api/UserUploadArt/UploadUserArtImg', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        FileContent: fileContent,
        UserID: userId
      })
    });

    const userArt = await rawResponse.json();

    // const userArtID = this.getNextKey(this.allUserArts.value || {});
      const defaultColorsInit = [];
      const allColorKeys = Object.keys(this.getAllColorsDict()); //Object.keys(this.allColors.value || {});
      defaultColorsInit.push(parseInt(allColorKeys[0 % allColorKeys.length]));

      // const sizeID = 1;
      if(!this.allUserArts.value){
        this.allUserArts.value = {};
      }

// artStatus: 0
// dstSizesJson:null
// imgB64Content:"/9j/4AAQSkZJRgABAQEAlgCWAAD/2wBDAAEBAQEBAQEBAQEBA
// isDeleted:false
// pixelHeight:0
// pixelWidth:0
// relativePath:"C:\\Users\\PC\\source\\repos\\Abensicsu\\Embroid\\Presentation\\Embroid\\wwwroot\\UploadFiles\\UsersUploadedArts\\2ad8b997"
// userUploadedArtID:100002
// userVisitedID:"e57c05f5-ac1a-40da-b9fc-16ef89cd8090"

      userArt.dstSizesJson = userArt.dstSizesJson == null || userArt.dstSizesJson == "" ? 
                            {} : JSON.parse(userArt.dstSizesJson);
      this.allUserArts.value[userArt.userUploadedArtID] = userArt;
      // const currentDesign =
      uStore.userDesigns[this.currentEditingProps.productId]
        .designs[this.currentEditingProps.variantId]
        .imgVariants[this.currentEditingProps.imageToPreview]
        .userArts[designUserArtIndex].userUploadedArtID = userArt.userUploadedArtID;
  },

  async userUploadArtSvg(fileContent, designUserArtIndex) {
    const uStore = userStore();
    let userId = this.getOrCreateUserID();

    const rawResponse = await fetch(baseURL + '/api/UserUploadArt/UploadUserArtSvg', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        FileContent: fileContent,
        UserID: userId
      })
    });

    const userArt = await rawResponse.json();

    // const userArtID = this.getNextKey(this.allUserArts.value || {});
      const defaultColorsInit = [];
      const allColorKeys = Object.keys(this.getAllSvgColorsDict()); //Object.keys(this.allColors.value || {});
      defaultColorsInit.push(parseInt(allColorKeys[0 % allColorKeys.length]));

      // const sizeID = 1;
      if(!this.allUserArtsSvg.value){
        this.allUserArtsSvg.value = {};
      }
      this.allUserArtsSvg.value[userArt.userUploadedArtID] = userArt;
      // const currentDesign =
      uStore.userDesigns[this.currentEditingProps.productId]
        .designs[this.currentEditingProps.variantId]
        .imgVariants[this.currentEditingProps.imageToPreview]
        .userArts[designUserArtIndex].userUploadedArtID = userArt.userUploadedArtID;
  },
async getUserArtsDst(userArts) {
  var userArtsListRes = await fetch(`${baseURL}/api/UserUploadArt/GetDstFromUserArts`, {
    method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    body: JSON.stringify(userArts.map(item => item.userUploadedArtID))
  });
  var userArtsList = await userArtsListRes.json();
  return userArtsList;
//GetDstFromUserArts
},
    async newArt(artName, contentDstFile, artSizeName, artCategoryID) {
      const artID = this.getNextKey(this.allArts.value || {});
      const content = contentDstFile;
      const dstFile = await this.uploadDstFile(content, artName, 'arts')
      const defaultColorsInit = [];
      const allColorKeys = Object.keys(this.getAllColorsDict()); //Object.keys(this.allColors.value || {});
      for (let i = 0; i < dstFile.layerCount; i++) {
        defaultColorsInit.push(parseInt(allColorKeys[i % allColorKeys.length]));
      }
      const sizeID = 1;

      if(!this.allArts.value){
        this.allArts.value = {};
      }

      this.allArts.value[artID] = {
        artID: artID,
        artName: artName,
        artCategoryID: artCategoryID,
        sizes: {},
        defaultColors: defaultColorsInit,
        isAvailable: true,
      };
      this.allArts.value[artID].sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: artSizeName,
        dstfile: dstFile,
        isAvailable: true,
      };
    },

    async newArtSvg(artName, contentDstFile, artCategoryID) {
      const artID = this.getNextKey(this.allArtsSVG.value || {});
      const content = contentDstFile;
      const svgFile = await this.uploadDstFileSvg(content, artName, 'svgArts')
      const defaultColorsInit = [];
      const allColorKeys = Object.keys(this.getAllSvgColorsDict()); // Object.keys(this.allColors.value || {});
      defaultColorsInit.push(parseInt(allColorKeys[0 % allColorKeys.length]));
      if(!this.allArtsSVG.value){
        this.allArtsSVG.value = { ...this.allArtsSVG.value, [artID]: {}  };
      }
      this.allArtsSVG.value[artID] = {
        artID: artID,
        artName: artName,
        artCategoryID: artCategoryID,
        sizes: {},
        defaultColors: defaultColorsInit,
        svgFile: svgFile,
        isAvailable: true,
      };
    },
async addUserArtSizeToStore(userUploadedArtID, contentDstFile, artSizeName) {
  const content = contentDstFile;
      const dstFile = await this.uploadDstFile(content, userUploadedArtID.toString(), 'arts')
      const sizeID = this.getNextKey(this.allUserArts.value[userUploadedArtID].dstSizesJson.sizes || {});
      
      // Initialize defaultColors if it doesn't exist -> if its first size
      if(this.allUserArts.value[userUploadedArtID].dstSizesJson.defaultColors == undefined || this.allUserArts.value[userUploadedArtID].dstSizesJson.defaultColors.length == 0) {
        const defaultColorsInit = [];
        const allColorKeys = Object.keys(this.getAllColorsDict()); //this.allColors.value || {}); // this.getAllColorsDict(); // 
        for (let i = 0; i < dstFile.layerCount; i++) {
          defaultColorsInit.push(parseInt(allColorKeys[i % allColorKeys.length]));
        }
        this.allUserArts.value[userUploadedArtID].dstSizesJson.defaultColors = defaultColorsInit;
      }
      if(this.allUserArts.value[userUploadedArtID].dstSizesJson.sizes == undefined) {
        this.allUserArts.value[userUploadedArtID].dstSizesJson.sizes = {}
      }
      this.allUserArts.value[userUploadedArtID].dstSizesJson.sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: artSizeName,
        dstfile: dstFile,
        isAvailable: true,
      };
      await this.updateJsonToUserArtDst(userUploadedArtID);
},
async updateJsonToUserArtDst(userUploadedArtID) {
  // let userId = this.getOrCreateUserID();
      const updateDstJsonResponse = await fetch(baseURL + `/api/UserUploadArt/UpdateUserDstArt?UserArtId=${parseInt(userUploadedArtID)}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(JSON.stringify(this.allUserArts.value[userUploadedArtID].dstSizesJson))
      }).catch(err => console.log('Fetch error:', err));

      console.log('updateDstJsonResponse = ', updateDstJsonResponse);
      //const content = await rawResponse.json();
    },
    async manageUpdateUserDesign(orderNumber, cartLineIndex, design) {
      await fetch(baseURL + `/api/UserUploadArt/UpdateManageDesignInOrder`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          OrderNumber: orderNumber,
          cartItemIndex: cartLineIndex,
          NewDesign: JSON.stringify(design)
        })
      }).catch(err => console.log('Fetch error:', err));

      },
    async addArtSizeToStore(artID, contentDstFile, artSizeName) {
      const content = contentDstFile
      const dstFile = await this.uploadDstFile(content, this.allArts.value[artID].artName, 'arts')
      const sizeID = this.getNextKey(this.allArts.value[artID].sizes || {});
      this.allArts.value[artID].sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: artSizeName,
        dstfile: dstFile,
        isAvailable: true,
      };
    },
    removeArt(artID) {
      this.allArts.value[artID].isAvailable = false;
    },
      removeSvgArt(artID) {
      this.allArtsSVG.value[artID].isAvailable = false;
    }, 
  //   removeSvgArt(artID) {
  //     console.log('removeSvgArt artID = ', artID);
  // if (this.allArtsSVG[artID]) {
  //         console.log('ifremoveSvgArt artID = ', artID);

  //   this.allArtsSVG[artID].isAvailable = false; // מסמן שלא זמין
  // }
  //   },
    removeSize(artID, sizeID) {
      this.allArts.value[artID].sizes[sizeID].isAvailable = false;
    },
    removeUserArtSize(userUploadedArtID, sizeID) {
      this.allUserArts.value[userUploadedArtID].dstSizesJson.sizes[sizeID].isAvailable = false;
    },

    async deleteUserArtImg(userArt) {
      const uStore = userStore();
      // this.allUserArts.value.splice(userArtIndex, 1);
      
      if(this.currentEditingProps.isDesignDst == true) {
        delete this.allUserArts.value[userArt.userUploadedArtID];
      } else {
        delete this.allUserArtsSvg.value[userArt.userUploadedArtID];
      }
      const userArts = uStore.userDesigns[this.currentEditingProps.productId]
        .designs[this.currentEditingProps.variantId]
        .imgVariants[this.currentEditingProps.imageToPreview]
        .userArts;

      for (const key in userArts) {
        if (userArts[key].userUploadedArtID === userArt.userUploadedArtID) {
          uStore.userDesigns[this.currentEditingProps.productId]
            .designs[this.currentEditingProps.variantId]
            .imgVariants[this.currentEditingProps.imageToPreview]
            .userArts.splice(key,1);
        }
      }

      
      await fetch(`${baseURL}/api/UserUploadArt/DeleteUserArt?UserUploadedArtId=${userArt.userUploadedArtID}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });
    },
    async newFontMultiFiles(fileNameTemplates, filesList, fontName, fileType, fontSizeName, fontSizeInches, fontSumColors, onlyForMonogram) {
      console.log('filesList = ', filesList);
      console.log('fontName = ', fontName);
      console.log('fileType = ', fileType);
      console.log('fontSizeName = ', fontSizeName);
      console.log('fontSizeInches = ', fontSizeInches);
      console.log('onlyForMonogram = ', onlyForMonogram);

      const fontID = this.getNextKey(this.allFonts.value || {});
      const sizeID = 1;
      const sizeNameFolder = `${fontSizeName}_${sizeID}`;
      const fontObject = await this.uploadFontMultiFiles(fileNameTemplates, fileType, filesList, `${fontName}_${fontID}`, sizeNameFolder, 'fonts');
      this.allFonts.value[fontID] = {
        fontID: fontID,
        fontName: fontName,
        onlyForMonogram: onlyForMonogram,
        isAvailable: true,
        sizes: {},
        kerning: [],
        // fontSumLayers: fontSumColors,
        layerCount: fontSumColors || 1,
        defaultFontColors: this.getDefaultColorArray(fontSumColors)
      };
      this.allFonts.value[fontID].sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: fontSizeName,
        isAvailable: true,
        sizeInches: parseFloat(fontSizeInches),
        DictCharacters: fontObject.dicCharacters,
        FontHeight: fontObject.maxHeight,
      };
    },
    async newFontSizeMultiFiles(fileNameTemplates, filesList, fontID, fileType, fontSizeName, fontSizeInches) { //, fontSumColors) {
      const fontName = this.allFonts.value[fontID].fontName;
      const sizeID = this.getNextKey(this.allFonts.value[fontID].sizes || {});
      const sizeNameFolder = `${fontSizeName}_${sizeID}`;
      const fontObject = await this.uploadFontMultiFiles(fileNameTemplates, fileType, filesList, `${fontName}_${fontID}`, sizeNameFolder, 'fonts');
      // this.allFonts.value[fontID].layerCount = Math.max(this.allFonts.value[fontID].layerCount || 1, fontObject.layerCount || 1);
      this.allFonts.value[fontID].FontHeight = this.allFonts.value[fontID].FontHeight > fontObject.maxHeight ?
        this.allFonts.value[fontID].FontHeight : fontObject.maxHeight; //אם הגובה החדש גבוהה יותר - מעדכן את גובה הפונט הכללי
      this.allFonts.value[fontID].sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: fontSizeName,
        isAvailable: true,
        sizeInches: parseFloat(fontSizeInches),
        DictCharacters: fontObject.dicCharacters,
        FontHeight: fontObject.maxHeight,
      }
      console.log();
    },
    async newFont(charSet, fileNameTemplates, fontName, fileType, contentDstFontFile, fontSizeName, fontSizeInches, fontSumColors, onlyForMonogram, isRtl) {
      const fontID = this.getNextKey(this.allFonts.value || {});
      const sizeID = 1;
      const sizeNameFolder = `${fontSizeName}_${sizeID}`;
      const content = contentDstFontFile
      const fontObject = await this.uploadFontFile(fileNameTemplates, fileType, charSet, content, `${fontName}_${fontID}`, sizeNameFolder, 'fonts');
      this.allFonts.value[fontID] = {
        fontID: fontID,
        fontName: fontName,
        isRtl: isRtl,
        onlyForMonogram: onlyForMonogram,
        isAvailable: true,
        sizes: {},
        kerning: [],
        layerCount: fontSumColors || 1,
        defaultFontColors: this.getDefaultColorArray(fontSumColors)
      };
      this.allFonts.value[fontID].sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: fontSizeName,
        isAvailable: true,
        sizeInches: parseFloat(fontSizeInches),
        DictCharacters: fontObject.dicCharacters,
        FontHeight: fontObject.maxHeight,
      };

    },
    // Load text on an arc path
// loadText(path, text, colorId, arcDegrees = 180, radius = 100, fontSize = 12) {
//   var exThis = this;

//   function getArcBBox(radius, startAngle, endAngle) {
//     const points = [];

//     // נקודת התחלה
//     points.push({
//       x: radius * Math.cos(startAngle),
//       y: radius * Math.sin(startAngle)
//     });

//     // נקודת סיום
//     points.push({
//       x: radius * Math.cos(endAngle),
//       y: radius * Math.sin(endAngle)
//     });

//     // בדיקה של רבעים מלאים בין ההתחלה לסיום
//     for (let angle = 0; angle < Math.PI * 2; angle += Math.PI / 2) {
//       if (startAngle < endAngle
//           ? angle >= startAngle && angle <= endAngle
//           : angle >= startAngle || angle <= endAngle) {
//         points.push({
//           x: radius * Math.cos(angle),
//           y: radius * Math.sin(angle)
//         });
//       }
//     }

//     const minX = Math.min(...points.map(p => p.x));
//     const maxX = Math.max(...points.map(p => p.x));
//     const minY = Math.min(...points.map(p => p.y));
//     const maxY = Math.max(...points.map(p => p.y));

//     return {
//       x: minX,
//       y: minY,
//       width: maxX - minX,
//       height: maxY - minY
//     };
//   }

//   return new Promise((resolve, reject) => {
//     opentype.load(this.baseURL + '/' + path, function(err) {
//       if (err) {
//         console.error('Font could not be loaded: ' + err + text);
//         reject(err);
//       } else {
//         // יצירת נתיב קשת (כיוון למעלה)
//         const arcRadians = (arcDegrees * Math.PI) / 180;
//         const startX = radius * Math.cos(-arcRadians / 2);
//         const startY = radius * Math.sin(-arcRadians / 2);
//         const endX = radius * Math.cos(arcRadians / 2);
//         const endY = radius * Math.sin(arcRadians / 2);
//         const arcPath = `M ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${endY}`;

//         // חישוב גבולות ה־viewBox לפי הקשת
//         const startAngle = -arcRadians / 2;
//         const endAngle = arcRadians / 2;
//         const bbox = getArcBBox(radius + fontSize / 2, startAngle, endAngle);

//         const svgTag = `
//           <svg xmlns="http://www.w3.org/2000/svg" style="display:block"
//                viewBox="${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}">
//             <defs>
//               <path id="arcPath" d="${arcPath}" />
//             </defs>
//             <text font-size="${fontSize}" text-anchor="middle" dominant-baseline="middle"
//                   filter="url(#${exThis.blackForWoodAndGlassId == colorId ? "engravingPreview" : "ColorFilter-" + colorId})">
//               <textPath href="#arcPath" startOffset="50%">
//                 ${text}
//               </textPath>
//             </text>
//           </svg>
//         `;

//         resolve({ svgTag, width: bbox.width, height: bbox.height });
//       }
//     });
//   });
// },
    // loadText(path, text, colorId) {
    //   var exThis = this;
    //   return new Promise((resolve, reject) => {
    //     opentype.load(this.baseURL + '/' + path, function(err, font) {
    //       if (err) {
    //         console.error('Font could not be loaded: ' + err + text);
    //         reject(err);
    //       } else {
    //         // const pathData = font.getPath(text, 20, 20, 26); // x, y, font size
    //         // const pathTag = pathData.toSVG();

    //         const pathData = font.getPath(text, 0, 0, 26); // x, y, font size
        
    //         // Get the bounding box of the text
    //         const bbox = pathData.getBoundingBox();
    //         const width = bbox.x2 - bbox.x1;
    //         const height = bbox.y2 - bbox.y1;
    
    //         // Create the SVG with calculated size
    //         var pathTag = pathData.toSVG();
    //         pathTag = pathTag.replace('<path', '<path fill="white"');
    //         var svgTag = '';

    //         if(exThis.blackForWoodAndGlassId == colorId) {
    //           svgTag = `
    //           <svg xmlns="http://www.w3.org/2000/svg" style="display: block;"
    //                width="${width}" 
    //                height="${height}" 
    //                viewBox="${bbox.x1} ${bbox.y1} ${width} ${height}">
    //                <defs>
    //                 <filter id="engravingPreview" x="0" y="0" width="100%" height="100%">
    //                   <feColorMatrix type="matrix"
    //                     values="0 0 0 0 0
    //                             0 0 0 0 0
    //                             0 0 0 0 0
    //                             0 0 0 0.55 0" />
    //                 </filter>
    //               </defs>
    //                ${pathTag}
    //                </svg>`;
    //         } else {
    //         svgTag = `
    //           <svg filter="url(#ColorFilter-${colorId})" xmlns="http://www.w3.org/2000/svg" style="display: block;"
    //                width="${width}" 
    //                height="${height}" 
    //                viewBox="${bbox.x1} ${bbox.y1} ${width} ${height}">
    //                ${pathTag}
    //                </svg>`;
    //         }
    //               //  width="${width}" 
    //               //  height="${height}" 
    //               //  viewBox="0 0 ${width} ${height}">


    //         // Create the SVG tag with dynamic viewBox

    //         // height="47" style="max-width: 200px; width: 100%;
    //         // const svgTag = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" filter="url(#ColorFilter-19)">
    //         //                     ${pathTag}
    //         //                 </svg>`;

    //         // resolve(svgTag); // Resolve the promise when the SVG is ready
    //         resolve({ svgTag, width, height });
    //       }
    //     });
    //   });
    // },

// loadText(path, text, colorId, arcDegrees = 0, radius = 0, fontSize = 16) {
//   // const exThis = this;

//   // פונקציה לחישוב תיבת גבול ל-viewBox לפי קשת עגולה
//   function getArcBBox(radius, startAngle, endAngle) {
//     const points = [];

//     // נקודת התחלה
//     points.push({
//       x: radius * Math.cos(startAngle),
//       y: radius * Math.sin(startAngle)
//     });

//     // נקודת סיום
//     points.push({
//       x: radius * Math.cos(endAngle),
//       y: radius * Math.sin(endAngle)
//     });

//     // נקודות ברבעים כדי לכלול את הקשת כראוי
//     for (let angle = 0; angle <= Math.PI * 2; angle += Math.PI / 2) {
//       const inRange = startAngle < endAngle
//         ? angle >= startAngle && angle <= endAngle
//         : angle >= startAngle || angle <= endAngle;
//       if (inRange) {
//         points.push({
//           x: radius * Math.cos(angle),
//           y: radius * Math.sin(angle)
//         });
//       }
//     }

//     const xs = points.map(p => p.x);
//     const ys = points.map(p => p.y);

//     const minX = Math.min(...xs);
//     const maxX = Math.max(...xs);
//     const minY = Math.min(...ys);
//     const maxY = Math.max(...ys);

//     return {
//       x: minX,
//       y: minY,
//       width: maxX - minX,
//       height: maxY - minY
//     };
//   }

//   return new Promise((resolve, reject) => {
//     opentype.load(this.baseURL + '/' + path, function(err) {
//       if (err) {
//         console.error('Font could not be loaded:', err);
//         reject(err);
//       } else {
//         // לחשב את זווית הקשת ברדיאנים
//         const arcRadians = (arcDegrees * Math.PI) / 180;
//         const startAngle = -arcRadians / 2;
//         const endAngle = arcRadians / 2;

//         // ליצור נתיב קשת - כיוון "למעלה"
//         // const start rcFlag = arcDegrees > 180 ? 1 : 0;
//         // const arcPath = `M ${startX.toFixed(2)} ${startY.toFixed(2)} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX.toFixed(2)} ${endY.toFixed(2)}`;

//         // לחשב viewBox בהתאם לקשת
//         const bbox = getArcBBox(radius + fontSize / 2, startAngle, endAngle);

//         // ליצור את תגית ה-SVG עם הטקסט על הקשת
//         // const filterId = exThis.blackForWoodAndGlassId === colorId ? "engravingPreview" : `ColorFilter-${colorId}`;

//         // const svgTag = `
//         //   <svg xmlns="http://www.w3.org/2000/svg" style="display:block"
//         //        viewBox="${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}">
//         //     <defs>
//         //       <path id="arcPath" d="${arcPath}" fill="none" />
//         //       <!-- הגדרות פילטרים יכולות להיות מחוץ לפונקציה או כאן -->
//         //     </defs>
//         //     <text font-size="${fontSize}" text-anchor="middle" dominant-baseline="middle" filter="url(#${filterId})" >
//         //       <textPath href="#arcPath" startOffset="50%">
//         //         ${text}
//         //       </textPath>
//         //     </text>
//         //   </svg>
//         // `;
//         // d=M -43.3 25 A 50 50 0 0 1 43.3 25
//         const svgTag = `
//         <svg xmlns="http://www.w3.org/2000/svg" style="display:block" viewBox="-60 -60 120 120">
//           <defs>
//             <!-- הפוך את כיוון הקשת -->
//             <path id="arcPath" d="M -43.3 25 A 50 50 0 0 1 43.3 25" fill="none"></path>
//           </defs>

//           <text font-size="16" text-anchor="middle" dominant-baseline="middle">
//             <textPath href="#arcPath" startOffset="0%">
//               ${text}
//             </textPath>
//           </text>
//         </svg>
//         `;

//         resolve({ svg: svgTag, width: bbox.width, height: bbox.height });
//       }
//     });
//   });
// },

getMatrix(color) { 
      // this.store.currentEditingProps.isDesignDst = true;
      if(this.blackForWoodAndGlassId == color.colorID) {
        return `0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 0.55 0`;
      } else {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        color.color
      );

      let c = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      };

      return `${c.r / 255.0}    0       0      0      0
              0         ${c.g / 255.0}  0      0      0
              0         0       ${c.b / 255.0} 0      0
              0         0       0      1      0`;
    }
  },
loadText(angleDegrees, text = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", fontSize = 20, colorId, fontId) {
  const exThis = this;

  //הפוך את האותיות מהסוף להתחלה
  // text = text.split("").reverse().join("");

  // צבע
  const color = this.getAllSvgColorsDict()[colorId] || this.getAllSvgColorsDict()[exThis.blackForWoodAndGlassId];

  // lettersMap / kerning / letterWidths / unitsPerEm
  const lettersMap = exThis.allFontsFiles.value[fontId].lettersMap || {};
  const kerningPairs = exThis.allFontsFiles.value[fontId].kerning || {};
  const letterWidths = exThis.allFontsFiles.value[fontId].letterWidths || {};
  const unitsPerEm = exThis.allFontsFiles.value[fontId].unitsPerEm || 100;

  // בניית paths לטקסט בקו ישר
  let xPos = 0;
  let textWidth = 0;
  const paths = [];
  const scale = fontSize / unitsPerEm; // scale = 1 עבור fontSize = unitsPerEm

  
  const initialCharsLocations = [];

  // 1. בדיקה האם הטקסט מכיל עברית
const isHebrew = /[\u0590-\u05FF]/.test(text);

// 2. אם זה עברית, נהפוך את סדר האותיות במחרוזת
// חשוב: זה עובד על מילים פשוטות. אם יש שילוב של מספרים/אנגלית (BiDi), נדרש טיפול מורכב יותר.
const processedText = isHebrew ? text.split('').reverse().join('') : text;

for (let i = 0; i < processedText.length; i++) {
    const char = processedText[i];
    const path = lettersMap[char];
    if (!path) continue;

    const charWidth = letterWidths[char] || unitsPerEm * 0.6;
    
    // חישוב Kerning למחרוזת המעובדת
    const pair = i < processedText.length - 1 ? char + processedText[i + 1] : null;
    const kerning = pair && kerningPairs[pair] !== undefined ? kerningPairs[pair] : 0;
    
    const top = fontSize; 

    if (Math.abs(angleDegrees) == 0) {
        paths.push(`<g transform="translate(${xPos},${top}) scale(${scale})">${path}</g>`);
    }

    xPos += (charWidth + kerning) * scale;
    textWidth += (charWidth + kerning) * scale;

    initialCharsLocations.push({
      x: xPos,
      y: top 
    });
}

  // for (let i = 0; i < text.length; i++) {
  //   const char = text[i];
  //   const path = lettersMap[char];
  //   if (!path) continue;

    
  //   const charWidth = letterWidths[char] || unitsPerEm * 0.6;
  //   const pair = i < text.length - 1 ? char + text[i + 1] : null;
  //   const kerning = pair && kerningPairs[pair] !== undefined ? kerningPairs[pair] : 0;
    
  //   const top = fontSize; // baseline
  //   if (Math.abs(angleDegrees) == 0) {
  //     paths.push(`<g transform="translate(${xPos},${top}) scale(${scale})">${path}</g>`);
  //   }
  //   xPos += (charWidth + kerning) * scale;
  //   textWidth += (charWidth + kerning) * scale;

  //   initialCharsLocations.push({
  //     x: xPos,// - (charWidth + kerning) * scale / 2, // מרכז האות
  //     y: top // מרכז האות
  //   });
  // }

  // מידות בקו ישר
  const svgWidth = textWidth > 0 ? textWidth : Math.max(1, xPos + fontSize * 0.6);
  const svgHeight = fontSize * 1.2;

  // --- מקרה קו ישר (ARC≈0) ---
  if (Math.abs(angleDegrees) == 0) {
    if (paths.length === 0) {
      const approxCharWidth = fontSize * 0.6;
      const textWidthFallback = approxCharWidth * text.length;
      const textHeight = fontSize * 1.2;

      const svgTag = `
<svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 ${textWidthFallback} ${textHeight}"
     width="${textWidthFallback}" height="${textHeight}"
     style="display:block;">
  <text x="0" y="${fontSize}" font-family="Arial, sans-serif" font-size="${fontSize}" fill="${color.color}" direction="rtl" text-anchor="end">
    ${text}
  </text>
</svg>`.trim();

      return { svg: svgTag, width: textWidthFallback, height: textHeight };
    }

    const svgTag = `
<svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 ${svgWidth} ${svgHeight}"
     width="${svgWidth}" height="${svgHeight}">
  <g fill="${color.color}" transform="translate(${(svgWidth - textWidth)/2}, ${(svgHeight - fontSize)/2})">
    ${paths.join("\n")}
  </g>
</svg>`.trim();

    return { svg: svgTag, width: svgWidth, height: svgHeight };
  }







  // --- מקרה קשת ---
const charsLocationsList = [];
    const rotatedPoints = []; // לאיסוף כל פינות האותיות לאחר סיבוב לחישוב התיבה התוחמת

    const textLength = textWidth;
    const fontHeight = svgHeight;
    // const fontHeight = fontSize;
    const y = fontSize;
    const x = 0;
    

    // שלב 1: חישוב הרדיוס ומרכז המעגל
    // הנוסחה לחישוב הרדיוס נכונה: אורך קשת = רדיוס * זווית (ברדיאנים)
    const absArc = Math.abs(angleDegrees);
    const arcInRadians = absArc * (Math.PI / 180);
    const radius = textLength / arcInRadians;

    // מרכז המעגל האופקי (ציר X) יהיה תמיד באמצע הטקסט
    const centerX = x + textLength / 2;

    // מרכז המעגל האנכי (ציר Y) תלוי בכיוון העיגול
    // נשתמש בטריגונומטריה כדי למצוא את המרחק האנכי של מרכז המעגל מהטקסט
    const h = radius * Math.cos(arcInRadians / 2);
    let centerY;

    if (angleDegrees > 0) { // קשת כלפי מעלה (קעורה) - מרכז המעגל מתחת לטקסט
        centerY = y + fontHeight + (radius - h);
    } else { // קשת כלפי מטה (קמורה) - מרכז המעגל מעל לטקסט
        centerY = y - (radius - h);
    }

    // שלב 2: לולאה על כל אות לחישוב מיקום וסיבוב
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (lettersMap[char] == null) {
            continue;
        }

        const charWidth = letterWidths[char] * scale || unitsPerEm * 0.6 * scale; 
        const charHeight = fontHeight;
        
        // מיקום מרכז האות בפריסה ישרה
        const charCenterXLinear = initialCharsLocations[i].x + charWidth / 2;
        
        // חישוב מיקום האות לאורך הקשת (בין 0 ל-1)
        const positionRatio = (charCenterXLinear - initialCharsLocations[0].x) / textLength;

        // שלב 3: חישוב הזווית של האות על המעגל והסיבוב העצמי שלה
        // זווית הסיבוב של האות עצמה (0 במרכז, קצוות בזווית מקסימלית)
        const charRotationAngle = (positionRatio - 0.5) * angleDegrees;
        const charRotationAngleRad = charRotationAngle * (Math.PI / 180);

        // הזווית של מרכז האות על היקף המעגל
        // נתחיל מזווית של 270 מעלות (למטה) עבור קשת קעורה, או 90 (למעלה) עבור קמורה
        const baseAngle = (angleDegrees > 0) ? -90 : 90;
        const totalAngle = baseAngle + (positionRatio - 0.5) * angleDegrees;
        const totalAngleRad = totalAngle * (Math.PI / 180);

        // שלב 4: חישוב מיקום ה-X,Y הסופי של האות
        // מיקום מרכז האות על המעגל
        const charCenterXOnArc = centerX + radius * Math.cos(totalAngleRad);
        const charCenterYOnArc = centerY + radius * Math.sin(totalAngleRad);

        // המיקום הסופי הוא של הפינה השמאלית-עליונה
        const locX = charCenterXOnArc - charWidth / 2;
        const locY = charCenterYOnArc - charHeight / 2;

        let path = lettersMap[char];
        if (!path) continue;
        charsLocationsList.push({
            x: locX,
            y: locY,
            arc: charRotationAngle // זווית הסיבוב של האות הבודדת
        });
        paths.push(`<g transform="translate(${locX},${locY}) rotate(${charRotationAngle}) scale(${scale})">${path}</g>`);

    const anchorX = locX;
        const anchorY = locY;

        const cos_t = Math.cos(charRotationAngleRad);
        const sin_t = Math.sin(charRotationAngleRad);

        // ארבע פינות האות לפני הסיבוב, בקואורדינטות גלובליות
        const corners = [
            { x: locX,               y: locY },                // Top-Left (היא בעצמה נקודת העיגון)
            { x: locX + charWidth,   y: locY },                // Top-Right
            { x: locX + charWidth,   y: locY + charHeight },    // Bottom-Right
            { x: locX,               y: locY + charHeight }     // Bottom-Left
        ];

        for (const pt of corners) {
            // אם הנקודה היא נקודת העיגון, אין צורך לסובב אותה
            if (pt.x === anchorX && pt.y === anchorY) {
                rotatedPoints.push({ x: anchorX, y: anchorY });
                continue;
            }

            // חישוב המיקום החדש של הפינה לאחר סיבוב סביב העוגן
            const dx = pt.x - anchorX;
            const dy = pt.y - anchorY;

            const rotatedX = anchorX + dx * cos_t - dy * sin_t;
            const rotatedY = anchorY + dx * sin_t + dy * cos_t;

            rotatedPoints.push({ x: rotatedX, y: rotatedY });
        }
    }

    // שלב 6: חישוב התיבה התוחמת מכלל הנקודות
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;

    if (rotatedPoints.length === 0 && text.length > 0) {
        // מקרה קצה: אם לא נוצרו נקודות (למשל טקסט ללא רוחב)
         return { charsLocationsList, dragSize: { w: 0, h: 0 } };
    }
    
    // for (const pt of rotatedPoints) {
    //     minX = Math.min(minX, pt.x);
    //     maxX = Math.max(maxX, pt.x);
    //     minY = Math.min(minY, pt.y);
    //     maxY = Math.max(maxY, pt.y);
    // }
    // let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const pt of rotatedPoints) {
      if (pt.x < minX) minX = pt.x;
      if (pt.y < minY) minY = pt.y;
      if (pt.x > maxX) maxX = pt.x;
      if (pt.y > maxY) maxY = pt.y;
    }

    // const dragSize = {
    //     w: maxX - minX,
    //     h: maxY - minY
    // };

    // return {
    //     charsLocationsList: charsLocationsList,
    //     dragSize: dragSize
    // };

// חישוב הזזה מרכזית לפי הטקסט
// const offsetX = -minX + (dragSize.w - (maxX - minX)) / 2;
// const offsetY = -minY + (dragSize.h - (maxY - minY)) / 2;

const width = maxX - minX;
const height = maxY - minY;


// const offsetX = -minX + width / 2 - (maxX - minX) / 2; // המרכז האופקי
// const offsetY = -minY + height / 2 - (maxY - minY) / 2; // המרכז האנכי


// מרכז הקשת
// const centerX2 = dragSize.w / 2;
// const centerY2 = dragSize.h / 2;

// // המרת זוויות לד' רדיאנים
// const startAngleRad = (-angleDegrees / 2) * (Math.PI / 180);
// const endAngleRad   = (angleDegrees / 2) * (Math.PI / 180);

// נקודות התחלה וסיום (שוכבות)
// const x1 = centerX2 + radius * Math.sin(startAngleRad);
// const y1 = centerY2 - radius * Math.cos(startAngleRad); // הפוך ל-y כדי שיהיה "למעלה"
// const x2 = centerX2 + radius * Math.sin(endAngleRad);
// const y2 = centerY2 - radius * Math.cos(endAngleRad);

// // דגל חצי קשת
// const arcFlag = angleDegrees > 180 ? 1 : 0;

// נתיב הקשת
// const arcPath = `M ${x1} ${y1} A ${radius} ${radius} 0 ${arcFlag} 1 ${x2} ${y2}`;


const thetaStart = (-angleDegrees / 2) * Math.PI / 180;
const thetaEnd   = ( angleDegrees / 2) * Math.PI / 180;

// נוודא ש-thetaStart <= thetaEnd (נוח לבדיקה); נשמור את הסימן לקשת
let thS = thetaStart, thE = thetaEnd;
if (thS > thE) { const t = thS; thS = thE; thE = t; }

const crit = [0, Math.PI, Math.PI/2, 3*Math.PI/2]; // קיצוני X/Y
function angleInArc(t) {
  // בדיקה אם t נמצא בין thS..thE מודולו 2π
  const TWOPI = 2*Math.PI;
  const norm = (a) => (a % TWOPI + TWOPI) % TWOPI;
  const a = norm(t), s = norm(thS), e = norm(thE);
  return s <= e ? (a >= s && a <= e) : (a >= s || a <= e);
}
function addPtAt(t) {
  const x = centerX + radius * Math.sin(t);
  const y = centerY - radius * Math.cos(t);
  if (x < minX) minX = x;
  if (y < minY) minY = y;
  if (x > maxX) maxX = x;
  if (y > maxY) maxY = y;
}

// קצוות הקשת
addPtAt(thetaStart);
addPtAt(thetaEnd);
// נקודות קיצון אם הן נכללות בתחום הקשת
for (const t of crit) if (angleInArc(t)) addPtAt(t);

const padding = Math.max(fontSize * 0.2, 2); // מעט אוויר סביב
const vbX = minX - padding;
const vbY = minY - padding;
const vbW = width + 2*padding;
const vbH = height + 2*padding;

// 5) תרגום שיטתי של כל התוכן כך שיישב בתוך ה-viewBox החדש שמתחיל ב-(0,0)
const dx = -vbX;   // == -minX + padding
const dy = -vbY;   // == -minY + padding

// --- עדכון הקשת: הזזה פשוטה של נקודות הקצה ---
const sweepFlag   = angleDegrees >= 0 ? 1 : 0;
const largeArcFlag = Math.abs(angleDegrees) > 180 ? 1 : 0;

const x1t = (centerX + radius * Math.sin(thetaStart)) + dx;
const y1t = (centerY - radius * Math.cos(thetaStart)) + dy;
const x2t = (centerX + radius * Math.sin(thetaEnd))   + dx;
const y2t = (centerY - radius * Math.cos(thetaEnd))   + dy;

const arcPath = `M ${x1t} ${y1t} A ${radius} ${radius} 0 ${largeArcFlag} ${sweepFlag} ${x2t} ${y2t}`;



const svgTag = `
<svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 ${vbW} ${vbH}"
     width="${vbW}" height="${vbH}">
  <path d="${arcPath}" stroke="red" stroke-width="1" fill="none" />
  <g fill="${color.color}" transform="translate(${dx}, ${dy})">
  ${paths.join("\n")}
  </g>
  </svg>`.trim();
  
  // יצירת ה-SVG הסופי
  // const svgTag = `
  // <svg xmlns="http://www.w3.org/2000/svg"
  //      viewBox="${minX} ${minY} ${width} ${height}"
  //      width="${width}" height="${height}">
       
  //   <!-- קשת דינאמית -->
  //   <path d="${arcPath}" stroke="red" stroke-width="1" fill="none" />
  
  //   <g fill="${color.color}" transform="translate(${offsetX}, ${offsetY})">
  //     ${paths.join("\n")}
  //   </g>
  // </svg>`.trim();


    // const svgTag = `
    //     <svg xmlns="http://www.w3.org/2000/svg"
    //         viewBox="0 0 ${dragSize.w} ${dragSize.h}"
    //         width="${dragSize.w}" height="${dragSize.h}">
    //       <g fill="${color.color}" transform="translate(${(dragSize.w - textWidth)/2}, ${(dragSize.h - fontSize)/2})">
    //         ${paths.join("\n")}
    //       </g>
    //     </svg>`.trim();
    return { svg: svgTag, width: vbW, height: vbH };


//   // --- מקרה קשת ---
//   const maxBend = 200;
//   const maxAngle = 180;
//   const absAngle = Math.min(Math.abs(angleDegrees), maxAngle);
//   const curvature = absAngle / maxAngle;
//   const curvePower = 2;
//   const bend = maxBend * Math.pow(curvature, curvePower);
//   const arcWidth = Math.max(1, xPos);

//   const r = (bend * bend + (arcWidth / 2) * (arcWidth / 2)) / (2 * bend);

//   const ascent = fontSize * 0.8;
//   const descender = fontSize * 0.25;
//   const baselineOffset = ascent;
//   const sweepFlag = angleDegrees > 0 ? 1 : 0;
//   const startY = (angleDegrees > 0 ? 0 : bend * 2) + baselineOffset;

//   const pathD = `M0,${startY} A${r},${r} 0 0 ${sweepFlag} ${arcWidth},${startY}`;

//   const extraPaddingTop = Math.ceil(fontSize * 0.3);
//   const extraPaddingBottom = Math.ceil(fontSize * 0.3);
//   const minY = startY - bend - ascent - extraPaddingTop;
//   const maxY = startY + bend + descender + extraPaddingBottom;

//   const viewBoxY = Math.floor(minY);
//   const viewBoxHeight = Math.ceil(maxY - minY);

//   const svgTag = `
// <svg xmlns="http://www.w3.org/2000/svg"
//      viewBox="0 ${viewBoxY} ${arcWidth} ${viewBoxHeight}"
//      width="${arcWidth}" height="${viewBoxHeight}">
//   <defs>
//     <path id="arcPath" d="${pathD}" />
//   </defs>
//   <text text-anchor="middle" dominant-baseline="alphabetic" font-size="${fontSize}" fill="${color.color}" method="align">
//     <textPath href="#arcPath" startOffset="50%">${text}</textPath>
//   </text>
// </svg>`.trim();

//   return { svg: svgTag, width: arcWidth, height: viewBoxHeight };
}

,

  // הקוד ההכי מעודכן
// loadText(angleDegrees, text = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", fontSize = 20, colorId) {//, IDFont
//   var exThis = this;
//   const arcWidth = 400; // רוחב הקשת בpx - אפשר לשנות לפי הצורך
//   const maxBend = 200;  // גובה העקמומיות המקסימלי בpx
//   const maxAngle = 180; // זווית מקסימלית בקשת
//   var color = this.getAllSvgColorsDict()[colorId] || this.getAllSvgColorsDict()[exThis.blackForWoodAndGlassId];
//   var matrix = this.getMatrix(color);

//   // טקסט ישר אם הזווית קטנה מדי
//   if (Math.abs(angleDegrees) < 0.1) {
//     const approxCharWidth = fontSize * 0.6;
//     const textWidth = approxCharWidth * text.length;
//     const textHeight = fontSize * 1.2;
//     return `
// <svg xmlns="http://www.w3.org/2000/svg"
//      viewBox="0 0 ${textWidth} ${textHeight}"
//      width="${textWidth}" height="${textHeight}"
//      style="display:block;">
//       <defs>
//         <filter id="${colorId ? 'SvgColorFilter-' + colorId : 'engravingPreview'}" x="0" y="0" width="100%" height="100%">
//           <feColorMatrix type="matrix"
//             values="${matrix}" />
//         </filter>
//       </defs>
//   <text x="0" y="${fontSize}" font-family="Arial, sans-serif" font-size="${fontSize}" fill="${color.color}"
//   filter="url(#${colorId == undefined || exThis.blackForWoodAndGlassId == colorId ? "engravingPreview" : "SvgColorFilter-" + colorId})"
//   >
//     ${text}
//   </text>
// </svg>`;
//   }

//   // חישוב bend - גובה העקמומיות לפי הזווית
//   const absAngle = Math.min(Math.abs(angleDegrees), maxAngle);
//   const curvature = absAngle / maxAngle;
//   const curvePower = 2; // להדגיש עקמומיות בזוויות גבוהות
//   const bend = maxBend * Math.pow(curvature, curvePower);

//   // חישוב רדיוס הקשת לפי נוסחה מעגלית
//   const r = (bend * bend + (arcWidth / 2) * (arcWidth / 2)) / (2 * bend);

//   // נקודת התחלה וסיום של הקשת
//   const startX = 0;
//   const startY = angleDegrees > 0 ? 0 : bend * 2;

//   // קביעת דגל sweepFlag לפי כיוון הקשת (עמק או גבעה)
//   const sweepFlag = angleDegrees > 0 ? 1 : 0;

//   // נתיב הקשת
//   const pathD = `M${startX},${startY} A${r},${r} 0 0 ${sweepFlag} ${arcWidth},${startY}`;

//   // חישוב ה-viewBox כדי לכלול את כל הטקסט והקשת
//   // const viewBoxY = angleDegrees > 0 ? -bend : 0;

//   // -------------
// //   // מחושב viewBoxHeight
// // const textHeight = fontSize * 1.2; // גובה משוער של הטקסט עצמו
// // const viewBoxHeight = bend + textHeight + 5; // ריווח קטן של 5 פיקסלים מעל הטקסט

// // // חישוב viewBoxY: למקרה של עיקול כלפי מעלה (עמק), מתחיל ב -bend, אחרת ב-0
// // const viewBoxY = angleDegrees > 0 ? -bend : 0;
// // ---------------

// const textHeight = fontSize * 1.2;
// const extraPaddingTop = 5;     // רווח קטן מעל הטקסט
// const extraPaddingBottom = 2;  // רווח קטן מתחת לטקסט למניעת חיתוך

// const viewBoxY = angleDegrees > 0 ? -bend - extraPaddingTop : -extraPaddingTop;
// const viewBoxHeight = bend + textHeight + extraPaddingTop + extraPaddingBottom;





//   // const viewBoxHeight = bend * 2 + fontSize * 1.5;

//   return `
// <svg xmlns="http://www.w3.org/2000/svg"
//      viewBox="0 ${viewBoxY} ${arcWidth} ${viewBoxHeight}"
//      width="${arcWidth}" height="${viewBoxHeight}"
//      style="display:block;">
//   <defs>
//         <filter id="${colorId ? 'SvgColorFilter-' + colorId : 'engravingPreview'}" x="0" y="0" width="100%" height="100%">
//           <feColorMatrix type="matrix"
//             values="${matrix}" />
//         </filter>
//       </defs>
//     <defs>
//       <path id="arcPath" class="letter-path" d="${pathD}" />
//     </defs>

//   <text ref="textRef" text-anchor="middle" dominant-baseline="hanging" font-size="${fontSize}" dy="5" fill="${color.color}"
//    filter="url(#${colorId == undefined || exThis.blackForWoodAndGlassId == colorId ? "engravingPreview" : "SvgColorFilter-" + colorId})"
// >
//     <textPath href="#arcPath" startOffset="50%">
//       ${text}
//     </textPath>
//   </text>
// </svg>`.trim();
// },


// -----סוף



// loadText(angleDegrees, text = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", fontSize = 20) {
//  // אם הזווית 0 — טקסט ישר רגיל
//   if (angleDegrees === 0) {
//     const approxCharWidth = fontSize * 0.6;
//     const textWidth = approxCharWidth * text.length;
//     const textHeight = fontSize * 1.2;

//     return `
// <svg xmlns="http://www.w3.org/2000/svg"
//      viewBox="0 0 ${textWidth} ${textHeight}"
//      width="${textWidth * 2}" height="${textHeight * 2}"
//      style="background:#fff; display:block;">
//   <text x="0" y="${fontSize}" font-family="Arial, sans-serif" font-size="${fontSize}" fill="#000">
//     ${text}
//   </text>
// </svg>
//     `.trim();
//   }

//   // מקרים אחרים - קשת עם טקסט על path
//   const rx = 150;
//   const cx = rx;
//   const cy = 200;
//   const dy = 5;
//   const maxRadius = 150;
//   const minRadius = 50;

//   const absAngle = Math.min(Math.abs(angleDegrees), 180);
//   const ry = absAngle < 1 ? 10000 : maxRadius - ((maxRadius - minRadius) * (absAngle / 180));

//   const approxCharWidth = fontSize * 0.6;
//   const textWidth = approxCharWidth * text.length;

//   const baseWidth = rx * 2;
//   const viewBoxWidth = Math.max(baseWidth, textWidth + 20);

//   const fontHeight = fontSize * 1.2;
//   const viewBoxHeight = cy + dy + fontHeight;

//   const sweepFlag = angleDegrees >= 0 ? 1 : 0;

//   const pathD = `M${cx - rx},${cy} A${rx},${ry} 0 0,${sweepFlag} ${cx + rx},${cy}`;

//   return `
// <svg xmlns="http://www.w3.org/2000/svg"
//      viewBox="0 0 ${viewBoxWidth} ${viewBoxHeight}"
//      width="${viewBoxWidth * 2}" height="${viewBoxHeight * 2}"
//      style="background:#fff; display:block;">
//   <defs>
//     <style>
//       .letter-path { fill:none; stroke:#ddd; stroke-width:1; }
//       text { font-family: Arial, sans-serif; font-size: ${fontSize}px; fill:#000; }
//     </style>
//     <path id="arcPath" class="letter-path" d="${pathD}" />
//   </defs>

//   <text text-anchor="middle" dominant-baseline="hanging" dy="${dy}">
//     <textPath href="#arcPath" startOffset="50%">
//       ${text}
//     </textPath>
//   </text>
// </svg>
//   `.trim();
// },


  arcSvgPaths(svgString, arcDegrees, radius = 100) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgString, "image/svg+xml");
  const svg = doc.documentElement;

  const paths = Array.from(svg.querySelectorAll("path"));
  const count = paths.length;

  const arcRadians = (arcDegrees * Math.PI) / 180;
  const startAngle = -arcRadians / 2;

  paths.forEach((path, i) => {
    const angle = isNaN(startAngle + (i / (count - 1)) * arcRadians) ? 1 : startAngle + (i / (count - 1)) * arcRadians;
    const x = radius * Math.cos(angle);
    const y = radius * Math.sin(angle);
    const rotateDeg = (angle * 180) / Math.PI + 90;

    // הוספת טרנספורם להזזה + סיבוב
    path.setAttribute(
      "transform",
      `translate(${x.toFixed(2)}, ${y.toFixed(2)}) rotate(${rotateDeg.toFixed(2)})`
    );
  });

  // עדכון viewBox
  const minX = -radius;
  const maxX = radius;
  const minY = -radius;
  const maxY = radius;
  const width = maxX - minX;
  const height = maxY - minY;
  svg.setAttribute("viewBox", `${minX} ${minY} ${width} ${height}`);

  return {
    svg: new XMLSerializer().serializeToString(svg),
    width,
    height
  };
},




mergeMultipleSVGs(texts, arts) {
  const parser = new DOMParser();
  const svgns = "http://www.w3.org/2000/svg";
  const mergedSvg = document.createElementNS(svgns, "svg");

  const bw = this.getCurrentProduct().box.widthInches * this.currentEditingProps.dpi;
  const bh = this.getCurrentProduct().box.heightInches * this.currentEditingProps.dpi;

  mergedSvg.setAttribute("xmlns", svgns);
  mergedSvg.setAttribute("width", bw);
  mergedSvg.setAttribute("height", bh);

  // יצירת defs לפילטרים אם יש
  const defs = document.createElementNS(svgns, "defs");
  mergedSvg.appendChild(defs);

  const appendSvg = ({ svgContent, dragTransform, layersColors }) => {
    const x = dragTransform.x || 0;
    const y = dragTransform.y || 0;
    const rotate = dragTransform.rotate || 0;
    const scaleX = dragTransform.scaleX !== undefined ? dragTransform.scaleX : 1;
    const scaleY = dragTransform.scaleY !== undefined ? dragTransform.scaleY : 1;
    const width = dragTransform.width || null;
    const height = dragTransform.height || null;
    //const filter = dragTransform.filter || null;
    // const filterId = exThis.blackForWoodAndGlassId === colorId ? "engravingPreview" : `ColorFilter-${colorId}`;
    const colorId = layersColors[0];
    const filterId = colorId
    const filter = `filter="url(#${filterId})"`;

    const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
    const group = document.createElementNS(svgns, "g");

    group.setAttribute("transform", `translate(${x},${y}) rotate(${rotate}) scale(${scaleX},${scaleY})`);

    // אם יש פילטר, מגדירים אותו ב-defs
    if (filter && filterId) {
      const filterEl = document.createElementNS(svgns, "filter");
      filterEl.setAttribute("id", filterId);
      // דוגמה: feColorMatrix (אפשר לשנות לפי הצורך)
      filterEl.innerHTML = `<feColorMatrix type="matrix" values="${filter}"/>`;
      defs.appendChild(filterEl);
    }

    svgDoc.documentElement.childNodes.forEach(node => {
      if (node.nodeType === 1) { // אלמנט
        const cloned = node.cloneNode(true);

        // מוטמע inline style
        const computedStyle = node.getAttribute("style");
        if (computedStyle) cloned.setAttribute("style", computedStyle);

        if (node.getAttribute("fill")) cloned.setAttribute("fill", node.getAttribute("fill"));
        if (node.getAttribute("stroke")) cloned.setAttribute("stroke", node.getAttribute("stroke"));
        if (node.getAttribute("stroke-width")) cloned.setAttribute("stroke-width", node.getAttribute("stroke-width"));

        if (width) cloned.setAttribute("width", width);
        if (height) cloned.setAttribute("height", height);
        if (filterId) cloned.setAttribute("filter", `url(#${filterId})`);

        group.appendChild(cloned);
      }
    });

    mergedSvg.appendChild(group);
  };

  Object.values(texts).forEach(textDesignObj => appendSvg(textDesignObj));
  Object.values(arts).forEach(artObj => appendSvg(artObj));

  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(mergedSvg);

  // יצוא לקובץ
  const blob = new Blob([svgString], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "merged_for_print.svg";
  link.click();
  URL.revokeObjectURL(url);

  return svgString;
},


// async loadFontSVG(fontUrl) {
//   // טען פונט בצורה אסינכרונית
//   const font = await new Promise((resolve, reject) => {
//     opentype.load(fontUrl, function(err, font) {
//       if (err) reject(err);
//       else resolve(font);
//     });
//   });

//   // רשימת כל התווים הנתמכים בפונט
//   const letters = Object.values(font.glyphs.glyphs)
//     .map(g => g.unicode)
//     .filter(u => u !== undefined)
//     .map(u => String.fromCharCode(u));

//   // יצירת lettersMap
//   const lettersMap = {};
//   for (let char of letters) {
//     const glyph = font.charToGlyph(char);
//     const path = glyph.getPath(0, 0, 100); // 0,0 = start, 100 = fontSize
//     lettersMap[char] = `<path d="${path.toPathData()}" />`;
//   }

//   var fontSize =20;
//   // יצירת kerningPairs
//   const scale = fontSize / font.unitsPerEm; // התאמה לגודל פונט בפיקסלים
// const kerningPairs = [];

// for (let c1 of letters) {
//   for (let c2 of letters) {
//     const glyph1 = font.charToGlyph(c1);
//     const glyph2 = font.charToGlyph(c2);

//     // נסיון לקבל kerning מהפונט
//     let k = font.getKerningValue(glyph1, glyph2);

//     // אם kerning לא מוגדר (0), חשב מרווח משוער
//     if (k === 0) {
//       k = (glyph1.advanceWidth + glyph1.leftSideBearing) * scale;
//     } else {
//       k = k * scale; // המרה לפיקסלים
//     }

//     kerningPairs.push({ pair: c1 + c2, value: k });
//   }
// }


//   return { lettersMap, kerningPairs };
// },
async loadFontSVG(fontUrl) {
  // טען פונט בצורה אסינכרונית
  const font = await new Promise((resolve, reject) => {
    opentype.load(fontUrl, function(err, font) {
      if (err) reject(err);
      else resolve(font);
    });
  });

  // רשימת כל התווים הנתמכים בפונט
  const letters = Object.values(font.glyphs.glyphs)
    .map(g => g.unicode)
    .filter(u => u !== undefined)
    .map(u => String.fromCharCode(u));

  // יצירת lettersMap + letterWidths
  const lettersMap = {};
  const letterWidths = {};
  for (let char of letters) {
    const glyph = font.charToGlyph(char);
    // const path = glyph.getPath(0, 0, 100); // fontSize=100 כיחידת בסיס
    
    const path = glyph.getPath(0, 0, font.unitsPerEm); 
    lettersMap[char] = `<path d="${path.toPathData()}" />`;
    letterWidths[char] = glyph.advanceWidth; // יחידות פונט מקוריות


    // advanceWidth בפונט הוא הרוחב המקורי ביחידות unitsPerEm
    // letterWidths[char] = glyph.advanceWidth / font.unitsPerEm; // יחסי, בלי פיקסלים

  }

  // יצירת kerningPairs
  const kerningPairs = {};
  // const scale = 100 / font.unitsPerEm; // kerning בפורמט fontSize=100
  for (let c1 of letters) {
    for (let c2 of letters) {
      const glyph1 = font.charToGlyph(c1);
      const glyph2 = font.charToGlyph(c2);
      // let k = font.getKerningValue(glyph1, glyph2) * scale;
      // נסיון לקבל kerning מהפונט
      let k = font.getKerningValue(glyph1, glyph2);
      // אם kerning לא מוגדר (0), חשב מרווח משוער
      if (k === 0) {
        // k = (glyph1.advanceWidth + glyph1.leftSideBearing);// * scale;
        k = glyph2.leftSideBearing;
      }
      //  else {
      //   k = k * scale; // המרה לפיקסלים
      // }
      kerningPairs[c1 + c2] = k;
    }
  }

  return { lettersMap, letterWidths, kerningPairs, unitsPerEm: font.unitsPerEm };
},

    async newFontSVG(fontName, fontFileName, contentFontFile, onlyForMonogram, isRtl) {
          const fontID = this.getNextKey(this.allFontsFiles.value || {});
          const content = contentFontFile
      const fontRelativePath = await this.uploadFontFileSVG(content, `${fontID}_${fontName}`, fontFileName, 'fontFiles');
      if(!this.allFontsFiles.value) {
        this.allFontsFiles.value = {};
      }

      var fontPath = `${this.baseURL}/${fontRelativePath.relativePath.replaceAll('\\', '\\\\')}`;

//       const font = opentype.loadSync(fontPath);

// // const letters = `A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z
// // a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z
// // 0, 1, 2, 3, 4, 5, 6, 7, 8, 9
// // א, ב, ג, ד, ה, ו, ז, ח, ט, י, כ, ל, מ, נ, ס, ע, פ, צ, ק, ר, ש, ת
// //      ך, ם, ן, ף, ץ
// // ָ, ֶ, ִ, ֹ, ֻ, ֲ, ֳ, ֽ, ֿ, ׀
// // . , : ; ! ? ' " ( ) [ ] { } - – _ / \ + = * & % $ # @ ^ ~ \` | < >
// //     ' '`;


// // רשימת כל התווים הנתמכים בפונט
// const letters = font.glyphs.glyphs
//   .map(g => g.unicode)
//   .filter(u => u !== undefined)
//   .map(u => String.fromCharCode(u));


// const lettersMap = {};
// for (let char of letters) {
//   const glyph = font.charToGlyph(char);
//   const path = glyph.getPath(0, 0, 100); // 0,0 = start, 100 = fontSize
//   lettersMap[char] = `<path d="${path.toPathData()}" />`;
// }

// const kerningPairs = [];
// for (let c1 of letters) {
//   for (let c2 of letters) {
//     const k = font.getKerningValue(font.charToGlyph(c1), font.charToGlyph(c2));
//     if (k !== 0) kerningPairs.push({ pair: c1 + c2, value: k });
//   }
// }
(async () => {
  try {
    const fontData = await this.loadFontSVG(fontPath);
    console.log(fontData.lettersMap);
    console.log(fontData.kerningPairs);
     this.allFontsFiles.value[fontID] = {
        fontID: fontID,
        fontName: fontName,
        isRtl: isRtl,
        onlyForMonogram: onlyForMonogram,
        isAvailable: true,
        lettersMap: fontData.lettersMap,
        letterWidths: fontData.letterWidths, // רוחב כל אות
        unitsPerEm: fontData.unitsPerEm, // יחידות פונט מקוריות
        kerning: fontData.kerningPairs, // kerning דיפולטיבי לכל זוג אותיות
        relativeFontPath: fontRelativePath.relativePath,
        // FontHeight: fontObject.maxHeight,
        defaultFontColors: this.getDefaultColorArray(1)
      };
  } catch (err) {
    console.error("Error loading font:", err);
  }
})();

     
    },
    async newFontSize(charSet, fileNameTemplates, fontID, fileType, contentDstFontFile, fontSizeName, fontSizeInches) { //, fontSumColors) {
      const content = contentDstFontFile;
      const sizeID = this.getNextKey(this.allFonts.value[fontID].sizes || {});
      const fontName = this.allFonts.value[fontID].fontName;
      const sizeNameFolder = `${fontSizeName}_${sizeID}`;
      const fontObject = await this.uploadFontFile(fileNameTemplates, fileType, charSet, content, `${fontName}_${fontID}`, sizeNameFolder, 'fonts')
      this.allFonts.value[fontID].FontHeight = this.allFonts.value[fontID].FontHeight > fontObject.maxHeight ?
        this.allFonts.value[fontID].FontHeight : fontObject.maxHeight; //אם הגובה החדש גבוהה יותר - מעדכן את גובה הפונט הכללי
      // this.allFonts.value[fontID].layerCount = Math.max(this.allFonts.value[fontID].layerCount || 1, fontObject.layerCount || 1);
      this.allFonts.value[fontID].sizes[sizeID] = {
        sizeID: sizeID,
        sizeName: fontSizeName,
        isAvailable: true,
        sizeInches: parseFloat(fontSizeInches),
        DictCharacters: fontObject.dicCharacters,
        FontHeight: fontObject.maxHeight,
      }
    },



    removeFont(fontID) {
      this.allFonts.value[fontID].isAvailable = false;
    },
    removeFontFile(fontFileID) {
      this.allFontsFiles.value[fontFileID].isAvailable = false;
    },
    removeFontSize(fontID, sizeID) {
      this.allFonts.value[fontID].sizes[sizeID].isAvailable = false;
    },

    addFontKerning(fontID, kerningObject) {
      this.allFonts.value[fontID].kerning.push(kerningObject);
    },

    removeFontKerning(fontID, index) {
      this.allFonts.value[fontID].kerning.splice(index, 1);
    },

    addMonogram(monogramObj) {
      const monogramID = this.getNextKey(this.allMonograms.value || {});
      this.allMonograms.value[monogramID] = {
        monogramID: monogramID,
        monogramName: monogramObj.monogramName,
        isAvailable: true,
        numOfCharacters: monogramObj.numOfCharacters,
        multiColor: monogramObj.multiColor,
        leftChar: monogramObj.leftChar,
        middleChar: monogramObj.middleChar,
        rightChar: monogramObj.rightChar,
        distance1: parseFloat(monogramObj.distance1),
        distance2: parseFloat(monogramObj.distance2),
        defaultAlignType: monogramObj.align,
        maxMonogramHeight: monogramObj.maxMonogramHeight,
      };
    },
    getMonogramWidth(monogramObj, char1, char2, char3, distance1, distance2) {
      var width = 0;
      width += this.getCharWidthFromCharObj(monogramObj.leftChar, char1);
      width += this.getCharWidthFromCharObj(monogramObj.rightChar, char3);
      width += distance1;
      if (monogramObj.numOfCharacters == "3") {
        width += this.getCharWidthFromCharObj(monogramObj.rightChar, char2);
        width += distance2;
      }
      return width;
    },
    getMaxMonogramHeight(monogram, leftChar, middleChar, rightChar) {
      return monogram
        .numOfCharacters == "2"
        ? Math.max(
          this.getMonogramDst(
           monogram.leftChar,
            leftChar
          ).pixelHeight,
          this.getMonogramDst(
            monogram.rightChar,
            rightChar
          ).pixelHeight
        )
        : Math.max(
          this.getMonogramDst(
            monogram.leftChar,
            leftChar
          ).pixelHeight,
          this.getMonogramDst(
            monogram.middleChar,
            middleChar
          ) != null ?
            this.getMonogramDst(
              monogram.middleChar,
              middleChar
            ).pixelHeight : 0,
          this.getMonogramDst(
            monogram.rightChar,
            rightChar
          ).pixelHeight
        );
    },
    removeMonogram(monogramID) {
      this.allMonograms.value[monogramID].isAvailable = false;
    },

    async getAllProductsInfo(pageNumber, pageSize, id, sku, productName, isPending) {
      var action = "GetAllProductsInfo"
      if (pageNumber == 0 && pageSize == 0) {
        action = "GetAllProductsInfoDefault"
      }
      const response = await fetch(`${baseURL}/api/ProductsInfo/${action}?pageNumber=${pageNumber}&pageSize=${pageSize}&id=${id}&sku=${sku}&productName=${productName}&isPending=${isPending}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad response from server");
      }

      const productsInfoDetails = await response.json();

      return productsInfoDetails;
    }




    , async addImageToProduct(productID, variantID, imgObj) {
      // לבדוק אם ה-productID וה-variantID קיימים
      if (!this.allProducts?.[productID]?.variants?.[variantID]?.images) {
        throw new Error(`Product or Variant does not exist for productID ${productID} and variantID ${variantID}.`);
      }

      // לבדוק אם יש כבר כזה שם לתמונה
      let imgName = imgObj.imageName; //'a_2'
      const oldImgName = imgObj.imageName; //'a'
      let index = 2;

      while (this.allProducts[productID].variants[variantID].images?.[imgName]) {
        imgName = `${oldImgName}_${index}`;
        index++;
      }

      this.allProducts[productID].variants[variantID].images[imgName] = {
        imageID: imgObj.imageID,
        imageName: imgName,
        isUseful: false,
        file: {
          layerCount: 1,
          pixelWidth: imgObj.imageWidth,
          pixelHeight: imgObj.imageHeight,
          relativePath: imgObj.imagePath,
        },
        box: {
          widthInches: 1,
          heightInches: 1,
          topLeftDmm: { x: 0, y: 0 },
        },
        imgWidthInches: 1,
        imgHeightInches: 1,
      };
    }
    ,

    addVariantToProduct(productID, shopifyVariant) {
      this.allProducts[productID].variants[shopifyVariant.variantID] = shopifyVariant;
    },

    getColorsList(productID, variantID, imageName, images) {
      //שמירת הרשימות בדרך מקוצרת
      var arts = images[imageName].arts;
      var monograms = images[imageName].monograms;
      var texts = images[imageName].texts;
      var boxWidth = (this.allProducts[productID].variants[variantID].images[imageName].box.widthInches * 254.0) / 2;
      var boxHeight = (this.allProducts[productID].variants[variantID].images[imageName].box.heightInches * 254.0) / 2;
      var currentColor = 0;
      var resultColorsList = [];
      var resultToFetch = [];
      var isSameColor = true;
      var i = 0, j = 0;
      var monObj = null, charDst = null;

      for (i = 0; i < arts.length; i++) {
        for (j = 0; j < arts[i].colors.length; j++) {
          //בודק האם התחלף צבע וזה לא הצבע הראשון שנכנס
          if (arts[i].colors[j] != currentColor && currentColor > 0) {
            currentColor = arts[i].colors[j];
            resultColorsList.push({
              colorID: currentColor,
              hexColor: this.allColors.value[currentColor].color,
              colorName: this.allColors.value[currentColor].colorName
            });
            if (j == 0) { isSameColor = false; }
            //אם לא התחלף הצבע או שזה הצבע הראשון - דוחף
          } else {
            //אם זה הצבע הראשון - מכניס את הצבע הראשון
            // if (currentColor <= 0) {
            //   currentColor = arts[i].colors[0];
            currentColor = currentColor <= 0 ? arts[i].colors[0] : currentColor;
            resultColorsList.push({
              colorID: currentColor,
              hexColor: this.allColors.value[currentColor].color,
              colorName: this.allColors.value[currentColor].colorName
            });
            // }
            if (j == 0) { isSameColor = true; }
          }
        }
        resultToFetch.push({
          path: `${this.allArts.value[arts[i].artID].sizes[arts[i].artSizeID].dstfile.relativePath}.dst`,
          x: (arts[i].location.x - boxWidth) +
            (this.allArts.value[arts[i].artID].sizes[arts[i].artSizeID].dstfile.pixelWidth / 2),
          y: (arts[i].location.y - boxHeight) +
            (this.allArts.value[arts[i].artID].sizes[arts[i].artSizeID].dstfile.pixelHeight / 2),
          arc: arts[i].artArc,
          isSameColor: isSameColor
        })
      }
      for (i = 0; i < monograms.length; i++) {
        for (j = 0; j < monograms[i].colorsLeftChar.length; j++) {
          if (monograms[i].colorsLeftChar[j] != currentColor && currentColor > 0) {
            currentColor = monograms[i].colorsLeftChar[j];
            resultColorsList.push({
              colorID: currentColor,
              hexColor: this.allColors.value[currentColor].color,
              colorName: this.allColors.value[currentColor].colorName
            });
            if (j == 0) { isSameColor = false; }
          } else {
            //אם זה הצבע הראשון - מכניס את הצבע הראשון
            if (currentColor <= 0) {
              currentColor = monograms[i].colorsLeftChar[0];
              resultColorsList.push({
                colorID: currentColor,
                hexColor: this.allColors.value[currentColor].color,
                colorName: this.allColors.value[currentColor].colorName
              });
            }
            if (j == 0) { isSameColor = true; }
          }
        }
        monObj = this.allMonograms.value[monograms[i].monogramID];
        charDst = this.getCharDst(monObj.leftChar, monograms[i].leftChar);
        resultToFetch.push({
          path: `${charDst.relativePath}.DST`,
          x: (monograms[i].location[0].x - boxWidth) + (charDst.pixelWidth / 2),
          y: (monograms[i].location[0].y - boxHeight) + (charDst.pixelHeight / 2),
          arc: 0,
          isSameColor: isSameColor
        })
        if (monograms[i].colorsMiddleChar != null) {
          for (j = 0; j < monograms[i].colorsMiddleChar.length; j++) {
            if (monograms[i].colorsMiddleChar[j] != currentColor && currentColor > 0) {
              currentColor = monograms[i].colorsMiddleChar[j];
              resultColorsList.push({
                colorID: currentColor,
                hexColor: this.allColors.value[currentColor].color,
                colorName: this.allColors.value[currentColor].colorName
              });
              if (j == 0) { isSameColor = false; }
            } else {
              //אם זה הצבע הראשון - מכניס את הצבע הראשון
              if (currentColor <= 0) {
                currentColor = monograms[i].colorsMiddleChar[0];
                resultColorsList.push({
                  colorID: currentColor,
                  hexColor: this.allColors.value[currentColor].color,
                  colorName: this.allColors.value[currentColor].colorName
                });
              }
              if (j == 0) { isSameColor = true; }
            }
          }

          charDst = this.getCharDst(monObj.middleChar, monograms[i].middleChar);
          resultToFetch.push({
            path: `${charDst.relativePath}.DST`,
            x: (monograms[i].location[1].x - boxWidth) + (charDst.pixelWidth / 2),
            y: (monograms[i].location[1].y - boxHeight) + (charDst.pixelHeight / 2),
            arc: 0,
            isSameColor: isSameColor
          })
        }
        for (j = 0; j < monograms[i].colorsRightChar.length; j++) {
          if (monograms[i].colorsRightChar[j] != currentColor && currentColor > 0) {
            currentColor = monograms[i].colorsRightChar[j];
            resultColorsList.push({
              colorID: currentColor,
              hexColor: this.allColors.value[currentColor].color,
              colorName: this.allColors.value[currentColor].colorName
            });
            if (j == 0) { isSameColor = false; }
          } else {
            //אם זה הצבע הראשון - מכניס את הצבע הראשון
            if (currentColor <= 0) {
              currentColor = monograms[i].colorsRightChar[0];
              resultColorsList.push({
                colorID: currentColor,
                hexColor: this.allColors.value[currentColor].color,
                colorName: this.allColors.value[currentColor].colorName
              });
            }
            if (j == 0) { isSameColor = true; }
          }
        }

        charDst = this.getCharDst(monObj.rightChar, monograms[i].rightChar);
        resultToFetch.push({
          path: `${charDst.relativePath}.DST`,
          x: (monograms[i].location[monograms[i].location.length - 1].x - boxWidth) + (charDst.pixelWidth / 2),
          y: (monograms[i].location[monograms[i].location.length - 1].y - boxHeight) + (charDst.pixelHeight / 2),
          arc: 0,
          isSameColor: isSameColor
        })
      }

      for (i = 0; i < texts.length; i++) {
        for (j = 0; j < texts[i].layersColors.length; j++) {
          if(texts[i].text != '') {
        if (texts[i].colorID != currentColor && currentColor > 0) {
          currentColor = texts[i].layersColors[j];
          resultColorsList.push({
            colorID: currentColor,
            hexColor: this.allColors.value[currentColor].color,
            colorName: this.allColors.value[currentColor].colorName
          });
          isSameColor = false;
        } else {
          //אם זה הצבע הראשון - מכניס את הצבע הראשון
          if (currentColor <= 0) {
            currentColor = texts[i].layersColors[j];
            resultColorsList.push({
              colorID: currentColor,
              hexColor: this.allColors.value[currentColor].color,
              colorName: this.allColors.value[currentColor].colorName
            });
          }
          isSameColor = true;
        }
      }

        //מכניס לרשימה עבור כל אות בטקסט אם הטקסט לא ריק 
        if(texts[i].text != '') {
          for (j = 0; j < texts[i].text.length; j++) {
            resultToFetch.push({
              path: `${this.allFonts.value[texts[i].fontID].sizes[texts[i].fontSizeID].
                DictCharacters[texts[i].text[j]].dstfile.relativePath}.DST`,
              x: (texts[i].location[j].x - boxWidth) +
                (this.allFonts.value[texts[i].fontID].sizes[texts[i].fontSizeID].DictCharacters[texts[i].text[j]].dstfile.pixelWidth / 2),
              y: (texts[i].location[j].y - boxHeight) +
                (this.allFonts.value[texts[i].fontID].sizes[texts[i].fontSizeID].DictCharacters[texts[i].text[j]].dstfile.pixelHeight / 2),
              arc: texts[i].location[j].arc,
              isSameColor: isSameColor
            })
            isSameColor = true;
          }
        }
      }
          // resultToFetch.push({
        //   path: `${this.allArts.value[arts[i].artID].sizes[arts[i].artSizeID].dstfile.relativePath}.dst`,
        //   x: (arts[i].location.x - boxWidth) +
        //     (this.allArts.value[arts[i].artID].sizes[arts[i].artSizeID].dstfile.pixelWidth / 2),
        //   y: (arts[i].location.y - boxHeight) +
        //     (this.allArts.value[arts[i].artID].sizes[arts[i].artSizeID].dstfile.pixelHeight / 2),
        //   arc: arts[i].artArc,
        //   isSameColor: isSameColor
        // })
      }

      // for (i = 0; i < texts.length; i++) {
      //   if (texts[i].colorID != currentColor && currentColor > 0) {
      //     currentColor = texts[i].colorID;
      //     resultColorsList.push({
      //       colorID: currentColor,
      //       hexColor: this.allColors.value[currentColor].color,
      //       colorName: this.allColors.value[currentColor].colorName
      //     });
      //     isSameColor = false;
      //   } else {
      //     //אם זה הצבע הראשון - מכניס את הצבע הראשון
      //     if (currentColor <= 0) {
      //       currentColor = texts[i].colorID;
      //       resultColorsList.push({
      //         colorID: currentColor,
      //         hexColor: this.allColors.value[currentColor].color,
      //         colorName: this.allColors.value[currentColor].colorName
      //       });
      //     }
      //     isSameColor = true;
      //   }

      //   //מכניס לרשימה עבור כל אות בטקסט 
      //   for (j = 0; j < texts[i].text.length; j++) {
      //     resultToFetch.push({
      //       path: `${this.allFonts.value[texts[i].fontID].sizes[texts[i].fontSizeID].
      //         DictCharacters[texts[i].text[j]].dstfile.relativePath}.DST`,
      //       x: (texts[i].location[j].x - boxWidth) +
      //         (this.allFonts.value[texts[i].fontID].sizes[texts[i].fontSizeID].DictCharacters[texts[i].text[j]].dstfile.pixelWidth / 2),
      //       y: (texts[i].location[j].y - boxHeight) +
      //         (this.allFonts.value[texts[i].fontID].sizes[texts[i].fontSizeID].DictCharacters[texts[i].text[j]].dstfile.pixelHeight / 2),
      //       arc: texts[i].location[j].arc,
      //       isSameColor: isSameColor
      //     })
      //     isSameColor = true;
      //   }
      // }

      return {
        colorsList: resultColorsList,
        listToFetch: resultToFetch
      };
    },

    async getImgDataFromCartDesign(productID, variantID, designsObj) {
      let imagesListResult = [];
      Object.values(designsObj).forEach(image => {
        var list = this.getColorsList(productID, variantID, image.imageName, designsObj);
        var data = list.listToFetch;
        // if(data.length > 0) {
          var colorsToFetch = [];
          list.colorsList.forEach(color => {
            colorsToFetch.push({
              colorId: color.colorID,
              colorName: color.colorName,
              hexColor: color.hexColor
            })
          });
          var width = this.allProducts[productID].variants[variantID].images[image.imageName].box.widthInches * 254;
          var height = this.allProducts[productID].variants[variantID].images[image.imageName].box.heightInches * 254;
          var x = this.allProducts[productID].variants[variantID].images[image.imageName].box.topLeftDmm.x;
          var y = this.allProducts[productID].variants[variantID].images[image.imageName].box.topLeftDmm.y;
          imagesListResult.push({
            data: data,
            colorsList: colorsToFetch,
            width: width,
            height: height,
            x: x,
            y: y,
            imagePath: this.allProducts[productID].variants[variantID].images[image.imageName].file.relativePath,
            imgPixelWidth: this.allProducts[productID].variants[variantID].images[image.imageName].file.pixelWidth,
            imgInchesWidth: this.allProducts[productID].variants[variantID].images[image.imageName].imgWidthInches
          });
        // }
      });
      let response = await fetch(baseURL + '/api/Dst/SaveCartDesign', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(imagesListResult)
      });

      if (response.ok) {
        return await response.json();
      }
    },

    async downloadDstDesign(productID, variantID, imageName, designsObj, orderNumber, index) {

      var list = this.getColorsList(productID, variantID, imageName, designsObj);

      let response = await fetch(baseURL + '/api/Dst/MergeDst', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(list.listToFetch)
      })

      if (response.ok) {
        let blobResponse = await response.blob();
        var objectURL = URL.createObjectURL(blobResponse);

        // create <a> tag dinamically
        var fileLink = document.createElement('a');
        fileLink.href = objectURL;

        // it forces the name of the downloaded file
        fileLink.download = 'des_' + orderNumber + '_' + imageName + '.dst';

        // triggers the click event
        fileLink.click();

        await this.setImageToDownloadDst(orderNumber, imageName, index);
      }

    },

    async setImageToDownloadDst(orderNumber, imageName, index) {
      await fetch(baseURL + '/api/DSTDownloads/SetIsDownloadDstFile?orderId=' +
        orderNumber + '&imageName=' + imageName + '&index=' + index, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });
    },

    async UploadImageToProduct(imgContent, productName, destination) {
      const rawResponse = await fetch(baseURL + '/api/Product/addProduct', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          DestinationDirectory: destination,
          OriginalFileName: productName,
          ImgContent: imgContent,
        })
      });
      const productResult = await rawResponse.json();
      return productResult;
    },


    removeImageFromProduct(productID, imageName) {
      this.allProducts[productID].images[imageName].isAvailable = false;
    },

    deleteAllProducts() {
      this.allProducts = {};
    },


    addMaterial(materialNameNew, fontsToExcludeIDNew) {
      const materialID = this.getNextKey(this.allMaterials.value || {});
      this.allMaterials.value[materialID] = {
        materialID: materialID,
        isAvailable: true,
        materialName: materialNameNew,
        fontsToExcludeID: fontsToExcludeIDNew,
      };
    },

    removeMaterial(materialID) {
      this.allMaterials.value[materialID].isAvailable = false;
    },

    async uploadDstFile(dstFileContent, dstName, destination) {
      const rawResponse = await fetch(baseURL + '/api/Dst/UploadDST', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          FileContent: dstFileContent,
          DestinationDirectory: destination,
          OriginalFileName: dstName
        })
      });

      const content = await rawResponse.json();
      return content;
    },
    async uploadDstFileSvg(dstFileContent, dstName, destination) {
      const rawResponse = await fetch(baseURL + '/api/SVG/UploadSVG', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          FileContent: dstFileContent,
          DestinationDirectory: destination,
          OriginalFileName: dstName
        })
      });

      const content = await rawResponse.json();
      return content;
    },

    async uploadFontFile(fileNameTemplates, fileType, charSet, dstFontFileContent, fontName, sizeNameFolder, fontDestination) {
      const rawResponse = await fetch(baseURL + '/api/Font/AddFont', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          FileType: fileType,
          AllChars: charSet,
          SizeNameFolder: sizeNameFolder,
          DSTContent: dstFontFileContent,
          DestinationDirectory: fontDestination,
          OriginalFileName: fontName,
          TemplateCharsName: fileNameTemplates
        })
      });

      const content = await rawResponse.json();
      return content;
    },

    async uploadFontFileSVG(contentFontFile, fontAndSize, fontName, fontDestination) {
      const rawResponse = await fetch(baseURL + '/api/Svg/UploadFont', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          FileContent: contentFontFile,
          DestinationDirectory: fontDestination,
          OriginalFileName: fontAndSize +'_'+ fontName
          // FileType: fileType,
          // SizeNameFolder: sizeNameFolder,
          // DSTContent: contentFontFile,
          // DestinationDirectory: fontDestination,
          // OriginalFileName: fontName,
          // TemplateCharsName: fileNameTemplates
        })
      });

      const content = await rawResponse.json();
      return content;
    },

    async uploadFontMultiFiles(fileNameTemplates, fileType, filesList, fontName, sizeNameFolder, fontDestination) {
      var files = [];
      filesList.forEach(f => files.push({
        allChars: f.charSet,
        dstContent: f.contentDstFontFile,
      }));
      const rawResponse = await fetch(baseURL + '/api/Font/AddFontMultiFiles', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          FileType: fileType,
          SizeNameFolder: sizeNameFolder,
          DestinationDirectory: fontDestination,
          OriginalFileName: fontName,
          FilesLine: files,
          TemplateCharsName: fileNameTemplates
        })
      });

      const content = await rawResponse.json();
      return content;
    },


    async checkDBStorage() {
      var md5 = require('md5');
      const keysArray = this.keysArray;

      //שליפת כל הדאטה בייס
      const rawResponse = await fetch(baseURL + '/api/Storage/GetAllKeyHash', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then((response) => {

        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response;
      })

        .catch((error) => {
          // Your error is here!
          console.log(error)
        });

      const content = await rawResponse.json();

      // השוואה של הסטור הנוכחי מול הסטור האחרון שנשמר  ועדכון הסטור האחרון אם היה שינוי בסטור הנוכחי
      // יצירת אובייקטים חדשים של מפתח והשקוד לסטור הנוכחי
      var newHashs = []
      keysArray.forEach(element => {
        newHashs[element] = {
          key: element,
          hash: md5(JSON.stringify(this[element]))
        }
      });

      keysArray.forEach(element => {
        //עובר על רשימת המפתחות הנוכחיים ובודק האם יש מפתח שלא קיים בסטור הקודם
        // אם יש כזה- מוסיף אותו לסטור הקודם
        if (!this.allStoresHashs[element]) {
          this.allStoresHashs[element] = {
            key: element,
            hash: newHashs[element].hash,
            lastMod: new Date().toISOString()
          }
        }

        //משווה את ההש קוד הקודם מול הנוכחי
        if (this.allStoresHashs[element].hash != newHashs[element].hash) {
          this.allStoresHashs[element].hash = newHashs[element].hash;
          this.allStoresHashs[element].lastMod = new Date().toISOString();
        }
      });

      //בודק האם יש מפתח ששמור בסטור ולא שמור בדאטה בייס ואם כן - מוסיף אותו לדאטה
      //עובר על כל רשימת ההשים ששמורים בסטור
      for (var i = 0; i < Object.keys(this.allStoresHashs).length; i++) {
        if (!Object.values(content).find(item => item.key == keysArray[i])) {
          //שולח לקריאת שרת שמוסיפה מפתח חדש לדאטה בייס
          await fetch(baseURL + '/api/Storage/AddStorage', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              Key: this.allStoresHashs[keysArray[i]].key,
              Value: JSON.stringify(this[keysArray[i]]),
              Hash: md5(JSON.stringify(this[keysArray[i]])),
              LastModified: new Date().toISOString()
            })
          }).then((response) => {
            if (response.status >= 400 && response.status < 600) {
              throw new Error("Bad response from server");
            }
            return response;
          })
            // .then((returnedResponse) => {
            //   // Your response to manipulate
            //   this.setState({
            //     complete: true
            //   });
            // })
            .catch((error) => {
              // Your error is here!
              console.log(error)
            });
        }
      }

      //אח"כ עובר על כל הסטור המעודכן ובודק האם יש עדכון לפי ההשים מול הדאטה, אם יש עדכון - משנה את הדאטה בייס
      //לפי התאריך היותר מעודכן - לעדכן את הדאטה והסטור
      Object.values(this.allStoresHashs).forEach(async (element) => {
        if (Object.values(content).find(item => item.key == element.key)) { //אם יש כזה בסטור ובדאטה בייס

          var objData = Object.values(content).find(item => item.key == element.key); //שומר את הנתונים מהדאטה כאובייקט זמני
          if (objData.hash != element.hash) {
            //אם ההשים שונים בודק מי יותר מעודכן לפי התאריך 

            if (element.lastMod > new Date(2025, 1, 1)) { //אם השינוי בסטור הוא היותר מעודכן- כלומר התאריך גדול יותר

              //מבצע קריאת שרת לעדכון הנתון בדאטה בייס
              await fetch(baseURL + '/api/Storage/UpdateStorage', {
                method: 'PUT',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  Key: element.key,
                  Value: JSON.stringify(this[element.key]),
                  Hash: element.hash,
                  LastModified: element.lastMod
                })
              }).then((response) => {
                if (response.status >= 400 && response.status < 600) {
                  throw new Error("Bad response from server");
                }
                return response;
              })
                // .then((returnedResponse) => {
                //   // Your response to manipulate
                //   this.setState({
                //     complete: true
                //   });
                // })
                .catch((error) => {
                  // Your error is here!
                  console.log(error)
                });

            }
            else { // מבצע עדכון לסטור לפי הנתונים מהדאטה
              this.allStoresHashs[element.key].hash = objData.hash;
              let object = content.find(k => k.key == element.key)
              this.allStoresHashs[element.key].lastMod = object.LastModified

              // מבצע עדכון לסטור החדש לפי הנתונים מהדאטה
              //שליפת כל הדאטה של המפתח הרצוי
              const rawResponse = await fetch(baseURL + '/api/Storage/GetDataToKey?key=' + element.key, {
                method: 'GET',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
              }).then((response) => {
                if (response.status >= 400 && response.status < 600) {
                  throw new Error("Bad response from server");
                }
                return response;
              })
                // .then((returnedResponse) => {
                //   // Your response to manipulate
                //   this.setState({
                //     complete: true
                //   });
                // })
                .catch((error) => {
                  // Your error is here!
                  console.log(error)
                });
              const data = await rawResponse.json();
              this[element.key] = JSON.parse(data.value || {});
            }
          }
        }
      }
      );
    },
    async syncOrdersFromShopifyToDB() {
      const shopifyOrdersData = await fetch(baseURL + '/api/Shopify/SyncOrdersFromShopifyToDB', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const data = await shopifyOrdersData.json();
      return data;
    },
    async getAllOrdersFromShopify() {
      const shopifyOrdersData = await fetch(baseURL + '/api/Shopify/GetOrdersFromShopify', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const data = await shopifyOrdersData.json();

      //בדיקת מחיר העיצובים
      data.orders.forEach(order => {
        var designPrice = 0;
        order.items.forEach(item => {
          try {
            // 1. פענוח ה-JSON הפנימי מתוך המחרוזת
            const designData = JSON.parse(item.embDesign);
            
            // 2. מעבר על כל ה-Variants (למשל: front_bag, back_bag וכו')
            const variants = designData.imgVariants;
            
            for (const [, data] of Object.entries(variants)) {
              // שליפת המערכים הרלוונטיים
              const allTexts = data.texts || [];
              const allArts = data.arts || [];
              const allMonograms = data.monograms || [];
              
              // שליחת הנתונים לפונקציה (כאן variantKey משמש כ-productType, למשל "front_bag")
              designPrice += this.calculateDesignPrice(allTexts, allArts, allMonograms, item.productType).totalPrice;
            }
            
          } catch (error) {
            console.error("שגיאה בפענוח ה-JSON:", error);
          }
        });
        order.designPrice = designPrice;
        // if (order.totalPrice == designPrice) {
        //   order.totalPrice = 0;
        // }
      });
      //המחיר שהלקוח שילם

      // var ordersData = data.resultOrdersList;
      // var dstDownloadFiles = data.dstDownloads;
      // console.log('ordersData = ', ordersData);
      // //מכניס לכל תמונה בכל הזמנה את הנתון האם הורדה כבר לתוך אובייקט ההזמנה
      // ordersData.forEach(order => {
      //   order.items.forEach(item => {

      //   })
      // })
      return data;
    },

    async getDstDownloadFiles() {
      const dstDownloadFile = await fetch(baseURL + '/api/DSTDownloads/GetAllDstDownloadFiles', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const dstDownloadFilesList = await dstDownloadFile.json();
      return dstDownloadFilesList;

    },
    //מוחקת את כל הפונטים הבעיתיים מהסטור
    fixFontStore() {
      Object.values(this.allFonts).forEach(f => {
        var l = Object.values(f.sizes).length;
        Object.values(f.sizes).forEach(e => {
          console.log('e = ', e);
          console.log('l = ', l);
          if (e.DictCharacters == undefined) {
            if (l == 1) {
              this.removeFont(f.fontID);
            } else {
              this.removeFontSize(f.fontID, e.sizeID)
            }
          }
        });
      })
    },
    //פעולה שרצה על הסטור של המוצרים ומוחקת את הבעיתיים
    checkProductStore() {
      Object.values(this.allProducts).forEach(product => {
        if (product.variants == undefined || product.variants.length == 0) {
          //למחוק את המוצר
          // this.allProducts[product.productID].isAvailable = false;
          delete this.allProducts[product.productID];
        } else {
          Object.values(product.variants).forEach(variant => {
            if (variant.images == undefined || variant.images.length == 0) {
              //למחוק את המוצר
              // this.allProducts[product.productID].isAvailable = false;
              delete this.allProducts[product.productID];
            } else if (Object.prototype.hasOwnProperty.call(variant.images, "null")) { //אם יש מפתח תמונה אפילו אחד עם שם תמונה שהוא ריק
              delete this.allProducts[product.productID];
            }
          })
        }
      })
    },

    async resetStore() {
      const uStore = userStore();
      this.allArtCategories = {};
      this.allColors = {};
      this.allArts = {};
      this.allFonts = {};
      this.allMonograms = {};
      this.allStoresHashs = {};
      this.allProducts = {};
      this.allMaterials = {};
      uStore.userDesigns = {};
      this.lastCopyBox = {};

      this.allColorsSVG = {};
      this.allArtsSVG = {};
      this.allFontsFiles = {};

      this.baseURL = baseURL;
      this.baseIconsURL = baseIconsURL;

      //עדכון נתוני הסטור מחדש
      const keysArray = ['allColors', 'allArts', 'allFonts', 'allMonograms', 'allProducts', 'allMaterials', 'allColorsSVG', 'allArtsSVG', 'allArtCategories', 'allSvgArtCategories', 'allFontsFiles'];
      // const keysArray = ['allColors', 'allArts', 'allFonts', 'allMonograms', 'allMaterials', 'allArtCategories'];
      const rawResponse = await fetch(baseURL + '/api/Storage/GetAllKeyHash', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });
      const content = await rawResponse.json();

      (Object.values(content)).forEach(element => {
        this.allStoresHashs[element.key] = {
          key: element.key,
          hash: element.hash,
          lastMod: element.lastModified
        }
      });

      Object.values(keysArray).forEach(async (element) => {
        const rawResponse = await fetch(baseURL + '/api/Storage/GetDataToKey?key=' + element, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });
        const data = await rawResponse.json();
        this[element] = JSON.parse(data.value || {});
      });

      //עדכון כל המוצרים
      const shopifyProductsData = await fetch(baseURL + '/api/Shopify/GetProductsFromShopify', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const productsData = await shopifyProductsData.json();
      Object.values(productsData).forEach(async (product) => {
        if (this.allProducts[product.productID] == undefined) { //אם המוצר לא קיים בסטור בינתיים - מוסיף אותו עם קופסא מאותחלת
          await this.addProductFromShopify(product);
        }
      });

      this.checkProductStore(); //מנקה את הסטור ממוצרים פגומים

    },
    async updateProductInfoBox(productInfoUpdateBox, isPending) {
      try {
        console.log(productInfoUpdateBox.productID);
        const response = await fetch(baseURL + `/api/ProductsInfo/UpdateProductInfoData?productID=${productInfoUpdateBox.productID}&isPending=${isPending}&productType=${productInfoUpdateBox.productType}`, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(JSON.stringify(productInfoUpdateBox))
        });

        // בדיקה אם התגובה לא תקינה
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Product info updated successfully:', data);
      } catch (error) {
        console.error('Error updating product info:', error);
      }
    }
    ,
    async updateProductInfo(productInfo) {
      console.log(productInfo.variants)
      let sku = Object.values(productInfo.variants).map(x => x.sku).join(' | ');
      console.log(sku)
      try {
        const response = await fetch(`${baseURL}/api/ProductsInfo/UpdateProductInfo`, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            productId: productInfo.productID,
            Data: JSON.stringify(productInfo),
            Date: new Date(),
            Sku: sku,
            ProductName: productInfo.productName,
            ProductType: productInfo.productType,
            IsPending: await this.checkIsPending(productInfo)
          })
        });

        // בדיקה אם התגובה לא תקינה
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Product info updated successfully:', data);
      } catch (error) {
        console.error('Error updating product info:', error);
      }
    },

    async syncShopifyProduct() {
      // console.log('enter syncShopifyProduct function!');
      //מייבא דרך השרת את כל המוצרים מהחנות
      const shopifyProductsData = await fetch(baseURL + '/api/Shopify/GetProductsFromShopify', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const productsData = await shopifyProductsData.json();
      // console.log('productsData = ', productsData);
      //מייבא את כל המוצרים מהסטור בשביל לעשות סנכרון
      const allDetails = await this.getAllProductsInfo(1, 0, "", "", false);
      this.allProducts = JSON.parse(allDetails.allProducts);
      this.countFilter = allDetails.countFilter;
      this.countTotal = allDetails.countTotal;
      this.pageTotal = Math.ceil(this.countFilter / 20);
      var md5 = require('md5');
      //מבצע סנכרון - אם יש מוצר שקיים בחנות ולא בסטור - מוסיף אותו לסטור
      //לא להתייחס כרגע למקרה שיש משהו בסטור ואין בשופיפי
      var prods = Object.values(productsData);
      for (let i = 0; i < prods.length; i++) {
        let isProductChange = false;
        var product = prods[i];
        if (Object.values(this.allProducts).find(x => x.productID == product.productID) == null) {
          await this.addProductToDataFromShopify(product)
        }
        //בודק האם התרחש עדכון למוצר מסויים
        //אם שם המוצר השתנה
        else {
          if (Object.values(this.allProducts).find(x => x.productID == product.productID).productName != product.productName) {
            this.allProducts[product.productID].productName = product.productName;
            isProductChange = true
          } if (Object.values(this.allProducts).find(x => x.productID == product.productID).isAvailable != product.isAvailable) {
            this.allProducts[product.productID].isAvailable = product.isAvailable;
            isProductChange = true
          }

          Object.values(product.variants).forEach((shopifyVariant) => {
            //אם יש variant שהתווספה בחנות ולא התווספה לסטור
            if (Object.values(this.allProducts[product.productID].variants).find(y => y.variantID == shopifyVariant.variantID) == null) {
              this.addVariantToProduct(product.productID, shopifyVariant)
              isProductChange = true;
            }
            //השתנו variants בודק האם הנתונים בוואריאנטים
            else {
              if (this.allProducts[product.productID].variants[shopifyVariant.variantID].variantName != shopifyVariant.variantName) {
                this.allProducts[product.productID].variants[shopifyVariant.variantID].variantName = shopifyVariant.variantName;
                isProductChange = true;
              } if (this.allProducts[product.productID].variants[shopifyVariant.variantID].sku != shopifyVariant.sku) {
                this.allProducts[product.productID].variants[shopifyVariant.variantID].sku = shopifyVariant.sku;
                isProductChange = true;
              }
              //בודק האם הנתונים בתמונות השתנו
              //עבור כל תמונה מהחנות בשופיפי בודק שקיימת והנתונים נשארו זהים
              var imagesUse = []; //שומר רשימה של שמות התמונות שעבר עליהם כבר כדי לזהות אם רץ על שם של תמונה פעם שניה
              Object.values(shopifyVariant.images).forEach((shopifyImg) => {
                //אם אין שם לתמונה - נותן שם לפי האינדקס
                // if (shopifyImg.imageName == null) {
                //   shopifyImg.imageName = shopifyVariant.images.findIndex(f => f.imagePath == shopifyImg.imagePath).toString();
                //   isProductChange=true;
                // } 
                if (shopifyImg.imageName != null) { //בודק האם צריך להוסיף לשם התמונה מספור - במידה ויש כמה תמונות באותו שם בדיוק
                  var imgName = shopifyImg.imageName; //'a_2'
                  var oldImgName = shopifyImg.imageName; //'a'
                  var index = 2;
                  while (imagesUse.includes(imgName)) { //רק אם עבר כבר על שם תמונה כזה - מוסיף לו אינדקס
                    imgName = oldImgName + '_' + index;
                    index++;
                  }
                  imagesUse.push(imgName);
                  shopifyImg.imageName = imgName;
                }
                //אם יש תמונה שהתווספה בחנות ולא התווספה לסטור
                var imgObj = Object.values(this.allProducts[product.productID].variants[shopifyVariant.variantID].images).find(y => y.imageID == shopifyImg.imageID);
                if (imgObj == null) {
                  //if (Object.values(this.allProducts[product.productID].variants[shopifyVariant.variantID].images).find(y => y.file.relativePath == shopifyImg.imagePath) == null) {
                  this.addImageToProduct(product.productID, shopifyVariant.variantID, shopifyImg);
                  isProductChange = true;
                }
                //אם שם התמונה קיים בודק האם היה שינוי בתוך התמונה
                else {
                  //אם השתנה שם התמונה
                  if (imgObj.imageName != shopifyImg.imageName) {
                    //if (this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName].imageName != shopifyImg.imageName) {
                    //מוחק את האלמנט עם המפתח השגוי ומוסיף חדש עם המפתח המעודכן
                    var copyObj = this.allProducts[product.productID].variants[shopifyVariant.variantID].images[imgObj.imageName];
                    this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName] = {
                      'imageID': copyObj.imageID,
                      'imageName': shopifyImg.imageName,
                      'isUseful': copyObj.isUseful,
                      'file': {
                        'layerCount': copyObj.file.layerCount,
                        'pixelWidth': copyObj.file.pixelWidth,
                        'pixelHeight': copyObj.file.pixelHeight,
                        'relativePath': copyObj.file.relativePath
                      },
                      'box': {
                        'widthInches': copyObj.box.widthInches,
                        'heightInches': copyObj.box.heightInches,
                        'topLeftDmm': {
                          'x': copyObj.box.topLeftDmm.x,
                          'y': copyObj.box.topLeftDmm.y
                        }
                      },
                      'imgWidthInches': copyObj.imgWidthInches,
                      'imgHeightInches': copyObj.imgHeightInches
                    };
                    //מוחק את המפתח הקודם הלא נכון
                    delete this.allProducts[product.productID].variants[shopifyVariant.variantID].images[imgObj.imageName];
                    //.imageName = shopifyImg.imageName;
                    //this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName].imageName = shopifyImg.imageName;
                    isProductChange = true;
                  }
                  //אם השתנה התמונה או הנתיב אליה
                  if (this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName]?.file.relativePath != shopifyImg.imagePath) {
                    this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName].file.relativePath = shopifyImg.imagePath;
                    isProductChange = true;
                  }
                  //אם השתנה רוחב התמונה
                  if (this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName]?.file.pixelWidth != shopifyImg.imageWidth) {
                    this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName].file.pixelWidth = shopifyImg.imageWidth;
                    isProductChange = true;
                  }
                  //אם השתנה אורך התמונה
                  if (this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName]?.file.pixelHeight != shopifyImg.imageHeight) {
                    this.allProducts[product.productID].variants[shopifyVariant.variantID].images[shopifyImg.imageName].file.pixelHeight = shopifyImg.imageHeight;
                    isProductChange = true;
                  }
                }
              })
            }
          })
        }
        if (isProductChange == true) {
          await this.updateProductInfo(this.allProducts[product.productID])
        }

      }
      this.allStoresHashs["allProducts"] = {
        key: "allProducts",
        hash: md5(JSON.stringify(this["allProducts"])),
        lastMod: new Date().toISOString()
      };
    },


    async addProductFromShopify(product) {
      if (product.variants.length > 0 && product.variants[0].images.length > 0) {

        // this.allProducts[product.productID] לא בטוח שזה טוב שבטלנו את זה , זה מתאים לנו אבל צריך לבדוק שבreset store זה לא תוקע
        var prod = {
          productID: product.productID,
          productName: product.productName,
          isAvailable: product.isAvailable,
          productMaterial: [],
          variants: {}
        };

        product.variants.forEach((variant) => {
          prod.variants[variant.variantID] = {
            variantID: variant.variantID,
            sku: variant.sku,
            variantName: variant.variantName,
            images: {}
          }

          variant.images.forEach((img) => {
            var imgName = img.imageName == null ? variant.images.findIndex(f => f.imagePath == img.imagePath).toString() : img.imageName;
            prod.variants[variant.variantID].images[imgName] = {
              imageID: img.imageID,
              imageName: imgName,
              isUseful: false,
              file: {
                layerCount: 1,
                pixelWidth: img.imageWidth,
                pixelHeight: img.imageHeight,
                relativePath: img.imagePath
              },//productResult,
              box: {
                widthInches: 1,
                heightInches: 1,
                topLeftDmm: { x: 0, y: 0 }
              },
              imgWidthInches: 1,
              imgHeightInches: 1

            }
          })

        });
      }
      return prod;
    },
    checkIsPending(product) {
      if (product.isAvailable) {
        const variants = Object.values(product.variants);
        const hasUsefulVariant = variants.every(variant => {
          const images = Object.values(variant.images);
          return images.some(image => image.isUseful);
        });

        if (!hasUsefulVariant) {
          return true;
        }

        for (const variant of variants) {
          const images = Object.values(variant.images);
          for (const image of images) {
            const { widthInches, heightInches, topLeftDmm } = image.box;
            if (image.isUseful && widthInches == 1 && heightInches == 1 && topLeftDmm.x == 0 && topLeftDmm.y == 0) {
              return true;
            }
          }
        }
      }
      return false;
    }


    ,
    async addProductToDataFromShopify(product) {
      let sku = Object.values(product.variants).map(x => x.sku).join(' | ');
      let isPending = await this.checkIsPending(product);
      const response = await fetch(`${baseURL}/api/ProductsInfo/AddProductInfo`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productId: product.productID,
          Data: JSON.stringify(this.getDataOfObjectFromShopify(product)),
          Date: new Date(),
          Sku: sku,
          ProductName: product.productName,
          IsPending: isPending
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Fetch error:', response.status, errorText);
      }
    },
    getDataOfObjectFromShopify(product) {

      // this.allProducts[product.productID] לא בטוח שזה טוב שבטלנו את זה , זה מתאים לנו אבל צריך לבדוק שבreset store זה לא תוקע
     var prod= {
        productID: product.productID,
        productName: product.productName,
        isAvailable: product.isAvailable,
        productMaterial: [],
        variants: {}
      };

      product.variants?.forEach((variant) => {
        prod.variants[variant.variantID] = {
          variantID: variant.variantID,
          sku: variant.sku,
          variantName: variant.variantName,
          images: {}
        }

        variant.images?.forEach((img) => {
          var imgName = img.imageName == null ? variant.images.findIndex(f => f.imagePath == img.imagePath).toString() : img.imageName;
         prod.variants[variant.variantID].images[imgName] = {
            imageID: img.imageID,
            imageName: imgName,
            isUseful: false,
            file: {
              layerCount: 1,
              pixelWidth: img.imageWidth,
              pixelHeight: img.imageHeight,
              relativePath: img.imagePath
            },//productResult,
            box: {
              widthInches: 1,
              heightInches: 1,
              topLeftDmm: { x: 0, y: 0 }
            },
            imgWidthInches: 1,
            imgHeightInches: 1

          }
        })

      });
    
    return prod;
  },
    // async getDataOfObjectFromShopify(product) {
    //   const shopifyProductData = await fetch(baseURL + '/api/Shopify/GetProductFromShopifyById', {
    //     method: 'GET',
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json'
    //     },
    //     body: product.sku
    //   });
    //   const data = await shopifyProductData.json();
    //   await this.addProductFromShopify(data);
    //   //this.allProducts.value[data.productID] = data;
    // },
    async checkUserDesignsStore() {
      var md5 = require('md5');
      const keysArray = this.keysArray;

      //יצירת אובייקטים חדשים של מפתח והשקוד לסטור הנוכחי
      var newHashs = []
      keysArray.forEach(element => {
        newHashs[element] = {
          key: element,
          hash: md5(JSON.stringify(this[element]))
        }
      });

      //שליפת כל הדאטה בייס
      const rawResponse = await fetch(baseURL + '/api/Storage/GetAllKeyHash', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });
      const content = await rawResponse.json();

      (Object.values(content).map(x => x.key)).forEach(element => {
        //עובר על רשימת המפתחות של הדאטה בייס ובודק האם יש מפתח שלא קיים בסטור הקודם או בסטור הנוכחי
        //אם יש כזה- מוסיף אותו לסטור הקודם ולסטור הנוכחי
        if (!this.allStoresHashs[element]) {
          this.allStoresHashs[element] = {
            key: element,
            hash: newHashs[element].hash,
            lastMod: new Date().toISOString()
          }
        }
      });

      //אח"כ עובר על כל הדאטה ובודק האם יש עדכון לפי ההשים מול הדאטה, אם יש עדכון - משנה את הסטורים
      //לפי התאריך היותר מעודכן - לעדכן את הסטור הקודם והחדש
      Object.values(content).forEach(async (element) => {
        if (element.hash != this.allStoresHashs[element.key].hash) {
          // מבצע עדכון לסטור הקודם לפי הנתונים מהדאטה
          this.allStoresHashs[element.key].hash = element.hash;
          this.allStoresHashs[element.key].lastMod = new Date().toISOString();
        }

        if (element.hash != newHashs[element.key].hash) {
          // מבצע עדכון לסטור החדש לפי הנתונים מהדאטה
          //שליפת כל הדאטה של המפתח הרצוי
          const rawResponse = await fetch(baseURL + '/api/Storage/GetDataToKey?key=' + element.key, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
          });
          const data = await rawResponse.json();
          this[element.key] = JSON.parse(data.value || {});
        }
      },
      );
    },

    removeAllStoreHashs() {
      this.allStoresHashs = {};
    },

    addTextToDesign(productID, variantID, textObj) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[textObj.imageName].texts.
        push({
          imageName: textObj.imageName,
          text: textObj.text,
          fontID: textObj.fontID,
          fontSizeID: textObj.fontSizeID,
          layersColors: textObj.layersColors,
          dragLocation: { x: 0, y: 0 },
          dragSize: { w: 0, h: 0 },
          textArc: textObj.textArc,
          location: [],
          dragTransform: {
            // 'transformString': transformString,
            'x': 0,
            'y': 0,
            'width': (this.getTextLength(textObj.text, textObj.fontID, textObj.fontSizeID) * this.currentEditingProps.dpi) / 254,
            'height': (this.getMaxTextHeight(textObj.text, textObj.fontID, textObj.fontSizeID) * this.currentEditingProps.dpi) / 254,
            'scale': {
              'scaleX': 1,
              'scaleY': 1
            },
            'rotate': 0,
            'topX': 0,
            'topY': 0,
            'dpi': this.currentEditingProps.dpi
          },
        })
    },
    addTextSVGToDesign(productID, variantID, textObj) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[textObj.imageName].texts.
        push({
          imageName: textObj.imageName,
          text: textObj.text,
          fontID: textObj.fontID,
          layersColors: textObj.layersColors,
          dragLocation: { x: 0, y: 0 },
          dragSize: { w: 0, h: 0 },
          textArc: textObj.textArc,
          // location: [],
          dragTransform: {
            // 'transformString': transformString,
            'x': 0,
            'y': 0,
            'width': 0, //(this.getTextLength(textObj.text, textObj.fontID, textObj.fontSizeID) * this.currentEditingProps.dpi) / 254,
            'height': 0, //(this.getMaxTextHeight(textObj.text, textObj.fontID, textObj.fontSizeID) * this.currentEditingProps.dpi) / 254,
            'scale': {
              'scaleX': 1,
              'scaleY': 1
            },
            'rotate': 0,
            'topX': 0,
            'topY': 0,
            'dpi': this.currentEditingProps.dpi
          },
        })
    },
    addArtToDesign(productID, variantID, artObj, scale) { //, dpi) { //imageName, art, artSizeID) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[artObj.imageName].arts.
        push({
          imageName: artObj.imageName,
          artID: artObj.artID,
          artSizeID: artObj.artSizeID,
          artArc: artObj.artArc,
          colors: artObj.colors.map(x => x),
          dragLocation: { x: 0, y: 0 },
          dragTransform: {
            // 'transformString': transformString,
            'x': 0,
            'y': 0,
            'width': (this.allArts.value[artObj.artID].sizes[artObj.artSizeID].dstfile.pixelWidth * this.currentEditingProps.dpi) / 254,
            'height': (this.allArts.value[artObj.artID].sizes[artObj.artSizeID].dstfile.pixelHeight * this.currentEditingProps.dpi) / 254,
            'scale': {
              'scaleX': scale,
              'scaleY': scale
            },
            'rotate': 0,
            'topX': 0,
            'topY': 0,
            'dpi': this.currentEditingProps.dpi
          },
          location: { x: 0, y: 0 },
          dragSize: {
            w: this.allArts.value[artObj.artID].sizes[artObj.artSizeID].dstfile.pixelWidth,
            h: this.allArts.value[artObj.artID].sizes[artObj.artSizeID].dstfile.pixelHeight
          }
        })
    },
    addUserArtToDesign(productID, variantID, imageName) { //, dpi) { //imageName, art, artSizeID) {
      const uStore = userStore();
      // var userId = this.getOrCreateUserID();
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].userArts.
        push({
          imageName: imageName,          
        //   artStatus: 0,
        //   dstSizesJson:null,
        //   imgB64Content: null,
        //   isDeleted:false,
        //   pixelHeight:0,
        //   pixelWidth:0,
        //   relativePath:null,
          userUploadedArtID:null,
          // userVisitedID:userId,

        //   artArc: 0,
          // colors: [],
          dragLocation: { x: 0, y: 0 },
          dragTransform: {
            // 'transformString': transformString,
            'x': 0,
            'y': 0,
            'width': 0,
            'height': 0,
            'scale': {
              'scaleX': 1,
              'scaleY': 1
            },
            'rotate': 0,
            'topX': 0,
            'topY': 0,
            'dpi': this.currentEditingProps.dpi
          },
          location: { x: 0, y: 0 },
          dragSize: {
            w: 0,
            h: 0
          }
        })
    },
    addArtSVGToDesign(productID, variantID, artObj, scale) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[artObj.imageName].arts.
        push({
          imageName: artObj.imageName,
          artID: artObj.artID,
          artArc: artObj.artArc,
          colors: artObj.colors.map(x => x),
          dragLocation: { x: 0, y: 0 },
          dragTransform: {
            // 'transformString': transformString,
            'x': 0,
            'y': 0,
            'width': (this.allArtsSVG.value[artObj.artID].svgFile.pixelWidth * this.currentEditingProps.dpi) / 254,
            'height': (this.allArtsSVG.value[artObj.artID].svgFile.pixelHeight * this.currentEditingProps.dpi) / 254,
            'scale': {
              'scaleX': scale,
              'scaleY': scale
            },
            'rotate': 0,
            'topX': 0,
            'topY': 0,
            'dpi': this.currentEditingProps.dpi
          },
          location: { x: 0, y: 0 },
          dragSize: {
            w: this.allArtsSVG.value[artObj.artID].svgFile.pixelWidth,
            h: this.allArtsSVG.value[artObj.artID].svgFile.pixelHeight
          }
        })
    },
    getAllArtSizesWithVirtualSizes(artId) {
      var sizesList = this.getAllArtSizes(artId);
      if (sizesList.length < 2) {
        if (sizesList.length == 0) {
          return [];
        } else {
          return [{
            "virtualSizeID": 1,
            "sizeID": sizesList[0].sizeID,
            "sizeName": sizesList[0].sizeName + '-',
            "scale": 1
          }];
        }
        //return sizesList;
      } else {
        var resultList = [];
        var first = sizesList[0];
        var id = 1;
        for (var i = 1; i < sizesList.length; i++) {
          var next = sizesList[i];
          var step = (next.dstfile.pixelWidth - first.dstfile.pixelWidth) / 3;
          //גודל אחד פחות - וירטואלי
          resultList[id] = {
            "virtualSizeID": id,
            "sizeID": first.sizeID,
            "sizeName": first.sizeName + '-',
            "scale": (first.dstfile.pixelWidth - step) / first.dstfile.pixelWidth //הגודל הוירטואלי לחלק לגודל הDST
          };
          id++;
          resultList[id] = {
            "virtualSizeID": id,
            "sizeID": first.sizeID,
            "sizeName": first.sizeName,
            "scale": 1 //first.dstfile.pixelWidth / first.dstfile.pixelWidth //הגודל הוירטואלי לחלק לגודל הDST            
          };
          id++;
          resultList[id] = {
            "virtualSizeID": id,
            "sizeID": first.sizeID,
            "sizeName": first.sizeName + '+',
            "scale": (first.dstfile.pixelWidth + step) / first.dstfile.pixelWidth //הגודל הוירטואלי לחלק לגודל הDST
          };
          first = next;
          id++;
        }
        return resultList;
      }

      // var sizesList = this.getAllArtSizes(artId);
      // if(sizesList.length < 2) {
      //   return sizesList;
      // } else {
      //   var resultList = [];
      //   var first = sizesList[0];
      //   var id = 1;
      //   for(var i = 1; i < sizesList.length; i++) {
      //     var next = sizesList[i];
      //     var step = (next.dstfile.pixelWidth - first.dstfile.pixelWidth) / 3;
      //     //גודל אחד פחות - וירטואלי
      //     resultList[id] = {
      //       "virtualSizeID": id,
      //       "sizeID": first.sizeID,
      //       "sizeName": first.sizeName + '-',
      //       "dstfile": {
      //           "layerCount": first.dstfile.layerCount,
      //           "pixelWidth": first.dstfile.pixelWidth - step,
      //           "pixelHeight": first.dstfile.pixelHeight - ((step / first.dstfile.pixelWidth) * first.dstfile.pixelHeight),
      //           "relativePath": first.dstfile.relativePath
      //         },
      //       "isAvailable": first.isAvailable,
      //       "isVirtual": true
      //     };
      //     id++;
      //     //גודל רגיל - לא וירטואלי
      //     resultList[id] = {
      //       "virtualSizeID": id,
      //       "sizeID": first.sizeID,
      //       "sizeName": first.sizeName,
      //       "dstfile": {
      //           "layerCount": first.dstfile.layerCount,
      //           "pixelWidth": first.dstfile.pixelWidth,
      //           "pixelHeight": first.dstfile.pixelHeight,
      //           "relativePath": first.dstfile.relativePath
      //         },
      //       "isAvailable": first.isAvailable,
      //       "isVirtual": false
      //     };
      //     id++;
      //     //גודל אחד יותר - וירטואלי
      //     resultList[id] = {
      //       "virtualSizeID": id,
      //       "sizeID": first.sizeID,
      //       "sizeName": first.sizeName + '+',
      //       "dstfile": {
      //           "layerCount": first.dstfile.layerCount,
      //           "pixelWidth": first.dstfile.pixelWidth + step,
      //           "pixelHeight": first.dstfile.pixelHeight + ((step / first.dstfile.pixelWidth) * first.dstfile.pixelHeight),
      //           "relativePath": first.dstfile.relativePath
      //         },
      //       "isAvailable": first.isAvailable,
      //       "isVirtual": true
      //     };
      //     first = next;
      //     id++;
      //   }
      //   return resultList;
      // }
    },
    getAllTextSizesWithVirtualSizes(fontId, text) {
      var sizesList = this.getAllFontSizesContainsText(fontId, text);
      var sizesAsArray = Object.values(sizesList);
      if (sizesAsArray.length < 2) {
        if (sizesAsArray.length == 0) {
          return [];
        } else {
          return [{
            "virtualSizeID": 1,
            "sizeID": sizesAsArray[0].sizeID,
            "sizeName": sizesAsArray[0].sizeName + '-',
            "scale": 1
          }];
        }
        //return sizesList;
      } else {
        var resultList = [];
        var first = sizesAsArray[0];
        var id = 1;
        for (var i = 1; i < sizesAsArray.length; i++) {
          var next = sizesAsArray[i];
          var step = (next.FontHeight - first.FontHeight) / 3;
          //גודל אחד פחות - וירטואלי
          resultList[id] = {
            "virtualSizeID": id,
            "sizeID": first.sizeID,
            "sizeName": first.sizeName + '-',
            "scale": (first.FontHeight - step) / first.FontHeight //הגודל הוירטואלי לחלק לגודל הDST
          };
          id++;
          resultList[id] = {
            "virtualSizeID": id,
            "sizeID": first.sizeID,
            "sizeName": first.sizeName,
            "scale": 1 //first.FontHeight / first.FontHeight //הגודל הוירטואלי לחלק לגודל הDST            
          };
          id++;
          resultList[id] = {
            "virtualSizeID": id,
            "sizeID": first.sizeID,
            "sizeName": first.sizeName + '+',
            "scale": (first.FontHeight + step) / first.FontHeight //הגודל הוירטואלי לחלק לגודל הDST
          };
          first = next;
          id++;
        }
        return resultList;
      }


    },
    // dragTransform פונקציה שמוצאת את גודל הארט הקודם הקרוב ביותר לפי ה
    findingPreviouVirtualArtSize(artDesignObj, dpi) { //מקבלת את האובייקט מהסטור של הדיזיין
      //draggableשל ה dmmשומר את הגודל ב
      var dragWidth = parseInt(artDesignObj.dragTransform.width * artDesignObj.dragTransform.scale.scaleX);
      // var dragHeight = artDesignObj.dragTransform.height * artDesignObj.dragTransform.scale.scaleY;

      //ומוצא את האחד הכי קרוב dmmלפי סדר גדלי הארט - עבור כל גודל של הארט - בודק את גודלו ב
      var artSizesList = this.getAllArtSizesWithVirtualSizes(artDesignObj.artID);
      var list = artSizesList
        .filter(f => parseInt(this.allArts.value[artDesignObj.artID].sizes[f.sizeID].dstfile.pixelWidth * f.scale * dpi / 254) <= dragWidth)
        .sort(function (a, b) {
          return b.virtualSizeID - a.virtualSizeID;
        });

      var nearestObj = null;
      if (list.length == 1) {
        nearestObj = list[0];
      } else {
        if (dragWidth == parseInt(this.allArts.value[artDesignObj.artID].sizes[list[0].sizeID].dstfile.pixelWidth * list[0].scale * dpi / 254)) {
          nearestObj = list[1];
        } else {
          nearestObj = list[0];
        }
      }

      return nearestObj;

    },
    findingNextVirtualArtSize(artDesignObj, dpi) { //מקבלת את האובייקט מהסטור של הדיזיין
      //draggableשל ה dmmשומר את הגודל ב
      var dragWidth = parseInt(artDesignObj.dragTransform.width * artDesignObj.dragTransform.scale.scaleX);
      // var dragHeight = artDesignObj.dragTransform.height * artDesignObj.dragTransform.scale.scaleY;

      //ומוצא את האחד הכי קרוב dmmלפי סדר גדלי הארט - עבור כל גודל של הארט - בודק את גודלו ב
      // var artSizesList = this.getAllArtSizesWithVirtualSizes(artDesignObj.artID).map(m => this.allArts.value[artDesignObj.artID].sizes[m.sizeID].dstfile.pixelWidth * m.scale)
      //                   .sort(function (a, b) {
      //                     return b - a;
      //                   });
      var artSizesList = this.getAllArtSizesWithVirtualSizes(artDesignObj.artID);
      var list = artSizesList
        .filter(f => parseInt(this.allArts.value[artDesignObj.artID].sizes[f.sizeID].dstfile.pixelWidth * f.scale * dpi / 254) >= dragWidth);

      var nearestObj = null;
      if (list.length == 1) {
        nearestObj = list[0];
      } else {
        if (dragWidth == parseInt(this.allArts.value[artDesignObj.artID].sizes[list[0].sizeID].dstfile.pixelWidth * list[0].scale * dpi / 254)) {
          nearestObj = list[1];
        } else {
          nearestObj = list[0];
        }
      }

      return nearestObj;
    },
    findingPreviouVirtualTextSize(textDesignObj, dpi) { //מקבלת את האובייקט מהסטור של הדיזיין
      //draggableשל ה dmmשומר את הגודל ב
      var dragWidth = parseInt(textDesignObj.dragTransform.width * textDesignObj.dragTransform.scale.scaleX);
      var textSizesList = this.getAllTextSizesWithVirtualSizes(textDesignObj.fontID, textDesignObj.text);
      var list = textSizesList
        .filter(f => parseInt(this.getTextLength(textDesignObj.text, textDesignObj.fontID, f.sizeID) * f.scale * dpi / 254) <= dragWidth)
        .sort(function (a, b) {
          return b.virtualSizeID - a.virtualSizeID;
        });


      var nearestObj = null;
      if (list.length == 1) {
        nearestObj = list[0];
      } else {
        if (dragWidth == parseInt(this.getTextLength(textDesignObj.text, textDesignObj.fontID, list[0].sizeID) * list[0].scale * dpi / 254)) {
          nearestObj = list[1];
        } else {
          nearestObj = list[0];
        }
      }


      return nearestObj;

    },
    findingNextVirtualTextSize(textDesignObj, dpi) { //מקבלת את האובייקט מהסטור של הדיזיין
      var dragWidth = parseInt(textDesignObj.dragTransform.width * textDesignObj.dragTransform.scale.scaleX);
      var textSizesList = this.getAllTextSizesWithVirtualSizes(textDesignObj.fontID, textDesignObj.text);
      var list = textSizesList.filter(f => parseInt(this.getTextLength(textDesignObj.text, textDesignObj.fontID, f.sizeID) * f.scale * dpi / 254) >= dragWidth);
      var nearestObj = null;
      if (list.length == 1) {
        nearestObj = list[0];
      } else {
        if (dragWidth == parseInt(this.getTextLength(textDesignObj.text, textDesignObj.fontID, list[0].sizeID) * list[0].scale * dpi / 254)) {
          nearestObj = list[1];
        } else {
          nearestObj = list[0];
        }
      }

      return nearestObj;
    },
    // dragTransform פונקציה שמוצאת את גודל הארט הקרוב ביותר לפי ה
    findingNearestArtSize(artDesignObj, dpi) { //מקבלת את האובייקט מהסטור של הדיזיין
      //draggableשל ה dmmשומר את הגודל ב
      var dragWidth = artDesignObj.dragTransform.width * artDesignObj.dragTransform.scale.scaleX;
      // var dragHeight = artDesignObj.dragTransform.height * artDesignObj.dragTransform.scale.scaleY;

      //ומוצא את האחד הכי קרוב dmmלפי סדר גדלי הארט - עבור כל גודל של הארט - בודק את גודלו ב
      var artSizesList = this.getAllArtSizesWithVirtualSizes(artDesignObj.artID); //this.getAllArtSizes(artDesignObj.artID);
      var nearestArtSize = null;
      var nearestArtSizeObj = null;
      artSizesList.forEach(artSizeObj => {
        var width = ((this.allArts.value[artDesignObj.artID].sizes[artSizeObj.sizeID].dstfile.pixelWidth * dpi) / 254) * artSizeObj.scale;
        var currentSizeWidth = width; // (width * dpi) / 254;
        // var currentSizeHeight = (artSizeObj.dstfile.pixelHeight * this.dpi) / 254;
        if (nearestArtSize == null) {
          nearestArtSize = currentSizeWidth;
          nearestArtSizeObj = artSizeObj;
        } else if (Math.abs(dragWidth - currentSizeWidth) <= Math.abs(dragWidth - nearestArtSize)) {
          nearestArtSize = currentSizeWidth;
          nearestArtSizeObj = artSizeObj;
        }
      });
      return nearestArtSizeObj;
    },
    findingNearestFontSize(textDesignObj, dpi) { //מקבלת את האובייקט מהסטור של הדיזיין
      //draggableשל ה dmmשומר את הגודל ב
      var dragHeight = this.allFonts.value[textDesignObj.fontID].sizes[textDesignObj.fontSizeID].FontHeight * dpi / 254 * textDesignObj.dragTransform.scale.scaleY;
      // var dragWidth = textDesignObj.dragTransform.width * textDesignObj.dragTransform.scale.scaleX; // * dpi / 254
      // var dragHeight = textDesignObj.dragTransform.height * textDesignObj.dragTransform.scale.scaleY;

      //ומוצא את האחד הכי קרוב dmmלפי סדר גדלי הארט - עבור כל גודל של הארט - בודק את גודלו ב
      var textSizesList = this.getAllTextSizesWithVirtualSizes(textDesignObj.fontID, textDesignObj.text);
      var nearestTextSize = null;
      var nearestTextSizeObj = null;
      textSizesList.forEach(textSizeObj => {
        var height = ((this.allFonts.value[textDesignObj.fontID].sizes[textSizeObj.sizeID].FontHeight * dpi) / 254) * textSizeObj.scale;
        var currentSizeHeight = height;
        if (nearestTextSize == null) {
          nearestTextSize = currentSizeHeight;
          nearestTextSizeObj = textSizeObj;
        } else if (Math.abs(dragHeight - currentSizeHeight) <= Math.abs(dragHeight - nearestTextSize)) {
          nearestTextSize = currentSizeHeight;
          nearestTextSizeObj = textSizeObj;
        }
      });
      return nearestTextSizeObj;


    },
    addMonogramToDesign(monogramObj) {
      const uStore = userStore();
      var char1 = 'A';
      var char2 = monogramObj.numOfCharacters != "2" ? 'B' : null;
      var char3 = monogramObj.numOfCharacters == "2" ? 'B' : 'C';
      var monogramDrag = this.getMonogramLocation(monogramObj, monogramObj.distance1, monogramObj.distance2, monogramObj.align, char1, char2, char3, 0, 0);
      uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId].imgVariants[this.currentEditingProps.imageToPreview].monograms.
        push({
          imageName: monogramObj.imageName,
          monogramID: monogramObj.monogramID,
          align: monogramObj.align,
          distance1: monogramObj.distance1,
          distance2: monogramObj.distance2,
          leftChar: char1,
          middleChar: char2,
          rightChar: char3,
          colorsLeftChar: monogramObj.leftChar.defaultColors.map(x => x),
          colorsMiddleChar: monogramObj.numOfCharacters != "2" ? monogramObj.middleChar.defaultColors.map(x => x) : null,
          colorsRightChar: monogramObj.rightChar.defaultColors.map(x => x),
          dragLocation: { x: 0, y: 0 },
          dragSize: monogramDrag.dragSize,
          location: monogramDrag.location,
          dragTransform: {
            // 'transformString': transformString,
            'x': 0,
            'y': 0,
            'width': (monogramDrag.dragSize.w * this.currentEditingProps.dpi) / 254,
            'height': (monogramDrag.dragSize.h * this.currentEditingProps.dpi) / 254,
            'scale': {
              'scaleX': 1,
              'scaleY': 1
            },
            'rotate': 0,
            'topX': 0,
            'topY': 0,
            'dpi': this.currentEditingProps.dpi
          },
          numOfCharacters: monogramObj.numOfCharacters,
          multiColor: monogramObj.multiColor
        });
    },

    addProductToUserDesign(productID, variantID) {
      const uStore = userStore();
      console.log('new prod');
      // var imagesList = this.getAllProductVariantUsefulImages(productID, variantID);
      // if(imagesList.length > 0) { //מוסיף את הפריט לעיצוב רק אם יש לפחות תמונה אחת בשימוש במוצר הזה
      var md5 = require('md5');
      const designIndex = productID; //this.getNextKey(uStore.userDesigns);
      if (this.getAllProductVariantUsefulImages(productID, variantID).length > 0) {
        if (uStore.userDesigns == undefined || uStore.userDesigns[designIndex] == undefined) {
          uStore.userDesigns[designIndex] = {
            designIndex: designIndex,
            designID: this.createGuid(),
            productID: productID,
            designs: {}
          };
          uStore.userDesigns[designIndex].designs[variantID] = {
            variantID: variantID,
            variantHash: md5(JSON.stringify(this.allProducts[productID].variants[variantID])),
            imgVariants: {}
          };
          //Object.values(this.allProducts[productID].variants[variantID].images).forEach(img => {
          this.getAllProductVariantUsefulImages(productID, variantID).forEach(img => {
            uStore.userDesigns[designIndex].designs[variantID].imgVariants[img.imageName] = {
              imageName: img.imageName,
              texts: [],
              monograms: [],
              arts: [],
                        userArts: []
            };
          });
        } else if (uStore.userDesigns[designIndex].designs[variantID] == undefined) {
          uStore.userDesigns[designIndex].designs[variantID] = {
            variantID: variantID,
            variantHash: md5(JSON.stringify(this.allProducts[productID].variants[variantID])),
            imgVariants: {}
          };
          this.getAllProductVariantUsefulImages(productID, variantID).forEach(img => {
            uStore.userDesigns[designIndex].designs[variantID].imgVariants[img.imageName] = {
              imageName: img.imageName,
              texts: [],
              monograms: [],
              arts: [],
                        userArts: []
            };
          });
        } else { //אם המוצר והדגמים שמורים כבר בסטור - מנסה להוסיף את כל התמונות שאין אם אין
          //עובר על כל התמונות של המוצר ומוסיף תמונות שלא קיימות
          this.getAllProductVariantUsefulImages(productID, variantID).forEach(img => {
            if (uStore.userDesigns[designIndex].designs[variantID].imgVariants[img.imageName] == undefined) {
              uStore.userDesigns[designIndex].designs[variantID].imgVariants[img.imageName] = {
                imageName: img.imageName,
                texts: [],
                monograms: [],
                arts: [],
                        userArts: []
              };
            }
          });
        }
      }


    },
    clearProductDesignFromUserDesign(productID, variantID, imageName) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName] = {
        imageName: imageName,
        texts: [],
        monograms: [],
        arts: [],
        userArts: []
      };
    },
    deleteVariantFromUserDesign(productID, variantID) {
      const uStore = userStore();
      // let newDesignStore = {};
      // Object.keys(uStore.userDesigns[productID].designs).filter(x => x.toString() != variantID.toString()).forEach(variantDesignId =>
      //   newDesignStore[variantID] = uStore.userDesigns[productID].designs[variantDesignId]
      // );
      // uStore.userDesigns[productID].designs = newDesignStore;

          this.getAllProductVariantUsefulImages(productID, variantID).forEach(img => {
            uStore.userDesigns[productID].designs[variantID].imgVariants[img.imageName] = {
              imageName: img.imageName,
              texts: [],
              monograms: [],
              arts: [],
              userArts: []
            };
          });

    },

    createGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
    },


    // fromTextToCharsObjects(text, x, y, IDFont, IDFontSize, colorID, arc) {
    //   if (arc == undefined) {
    //     arc = 0;
    //   }
    
    //   const li = [];
    
    //   // Step 1: Fix text
    //   text = this.fixText(IDFont, IDFontSize, text);
    
    //   // Step 2: Get curved Y & arc angle only
    //   const arcLocations = this.getCharsLocationsWithArc(text, x, y, arc, IDFont, IDFontSize);
    
    //   // Step 3: Get flat (non-arc) X positions
    //   const flatLocations = this.getCharsLocationsWithArc(text, x, y, 0, IDFont, IDFontSize); // arc = 0
    
    //   for (let i = 0; i < text.length; i++) {
    //     const charData = this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]];
    
    //     if (charData != null) {
    //       li.push({
    //         index: i,
    //         charFile: charData,
    //         colorID: colorID,
    
    //         // ✅ X from flat version (no arc effect on left)
    //         x: flatLocations.charsLocationsList[i]?.x || 0,
    
    //         // ✅ Y from arc version
    //         y: arcLocations.charsLocationsList[i]?.y || 0,
    
    //         // ✅ Rotation from arc version
    //         arc: arcLocations.charsLocationsList[i]?.arc || 0
    //       });
    //     }
    //   }
    
    //   return {
    //     fontID: IDFont,
    //     fontSizeID: IDFontSize,
    //     listChars: li
    //   };
    // }
    // ,
    fromTextToCharsObjects(text, x, y, IDFont, IDFontSize, colorID, arc) {
      if (arc == undefined) {
        arc = 0;
      }
      var li = [];

      text = this.fixText(IDFont, IDFontSize, text);
      var locationsList = this.getCharsLocationsWithArc(text, x, y, arc, IDFont, IDFontSize); //.charsLocationsList;

      for (var i = 0; i < text.length; i++) {
        if (this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]] != null) {
          li.push({
            index: i,
            charFile: this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]],
            colorID: colorID,
            x: locationsList.charsLocationsList[i] == null ? 0 : locationsList.charsLocationsList[i].x,
            y: locationsList.charsLocationsList[i] == null ? 0 : locationsList.charsLocationsList[i].y,
            arc: locationsList.charsLocationsList[i] == null ? 0 : locationsList.charsLocationsList[i].arc,
          });
        }
      }
      return {
        fontID: IDFont,
        fontSizeID: IDFontSize,
        listChars: li
      };
    },
    getTextToPreview(fontId, fontSizeId) {

      var allChars = this.allFonts.value[fontId].sizes[fontSizeId].DictCharacters;
      var res = "";
      Object.values(allChars).forEach(e => {
        if (e.c != " ") { res = res + e.c }
      }

      )
      return res;
    },
    fixText(fontID, fontSizeID, text) {
      var allLetters = Object.keys(this.allFonts.value[fontID].sizes[fontSizeID].DictCharacters);
      return Object.values(text).filter(ch => allLetters.includes(ch)).join("");
    },
//     getCharsLocationsWithArc(text, x, y, arc, IDFont, IDFontSize) {
//       const charsLocationsList = [];
//       const textLength = this.getTextLength(text, IDFont, IDFontSize);
//       const charsLocations = this.getCharsAbsoluteLocations(text, IDFont, IDFontSize);

//       // אין קשת – מיקום אותיות בקו ישר
//       if (arc === 0) {
//   let minX = Infinity, maxX = -Infinity;
//   let minY = Infinity, maxY = -Infinity;

//   for (let i = 0; i < text.length; i++) {
//     const char = text[i];
//     const width = this.getCharWidth(IDFont, IDFontSize, char);
//     const height = this.getCharHeight(IDFont, IDFontSize, char);
//     const dy = this.getDyChar(IDFont, IDFontSize, char);

//     const absX = charsLocations[i].x;

//     const locX = x + absX;
//     const locY = y - dy - height / 2;

//     charsLocationsList.push({
//       x: locX,
//       y: locY,
//       arc: 0
//     });

//     minX = Math.min(minX, locX);
//     maxX = Math.max(maxX, locX + width);
//     minY = Math.min(minY, locY);
//     maxY = Math.max(maxY, locY + height);
//   }

//   return {
//     charsLocationsList,
//     dragSize: {
//       w: maxX - minX,
//       h: maxY - minY
//     },
//     offset: {
//       x: minX,
//       y: minY
//     }
//   };
// }


//       // כאן המשך הפונקציה הרגילה למקרה של ARC שונה מ־0:
//       const radius = (textLength * 180) / (Math.abs(arc) * Math.PI);
//       const anglePerPixel = arc / textLength;

//       let minX = Infinity, maxX = -Infinity;
//       let minY = Infinity, maxY = -Infinity;

//       for (let i = 0; i < text.length; i++) {
//         const char = text[i];
//         const width = this.getCharWidth(IDFont, IDFontSize, char);
//         const height = this.getCharHeight(IDFont, IDFontSize, char);
//         // const dy = this.getDyChar(IDFont, IDFontSize, char);

//         const absX = charsLocations[i].x;
//         const middlePos = absX + width / 2;

//         let charAngle = anglePerPixel * (middlePos - textLength / 2);
//         let angleRad = charAngle * Math.PI / 180;

//         let r = radius;
//         let cx = x + r * Math.sin(angleRad);
//         let cy = y + (arc > 0
//           ? r * (1 - Math.cos(angleRad))
//           : -r * (1 - Math.cos(angleRad)));

//         const locX = cx - width / 2;
//         // const locY = cy - height / 2 - dy;

//         const dy = charsLocations[i].y; // במקום this.getDyChar(...)
//         const locY = cy - height / 2 - dy;


//         charsLocationsList.push({
//           x: locX,
//           y: locY,
//           arc: charAngle
//         });

//         const centerX = locX + width / 2;
//         const centerY = locY + height / 2;

//         const rotatePoint = (px, py) => {
//           const dx = px - centerX;
//           const dy = py - centerY;
//           return {
//             x: centerX + dx * Math.cos(angleRad) - dy * Math.sin(angleRad),
//             y: centerY + dx * Math.sin(angleRad) + dy * Math.cos(angleRad)
//           };
//         };

//         const corners = [
//           rotatePoint(locX, locY),
//           rotatePoint(locX + width, locY),
//           rotatePoint(locX, locY + height),
//           rotatePoint(locX + width, locY + height)
//         ];

//         for (const pt of corners) {
//           minX = Math.min(minX, pt.x);
//           maxX = Math.max(maxX, pt.x);
//           minY = Math.min(minY, pt.y);
//           maxY = Math.max(maxY, pt.y);
//         }
//       }

//       const dragSize = {
//         w: maxX - minX,
//         h: maxY - minY
//       };

//       return {
//         charsLocationsList,
//         dragSize,
//         offset: {
//           x: minX,
//           y: minY
//         }
//       };
//     },

// -------נסיון---------
// getCharsLocationsWithArc(text, x, y, arc, IDFont, IDFontSize) {
//   var charArc = 0;
//   var charsLocationsList = [];
//   var textLength = this.getTextLength(text, IDFont, IDFontSize);
//   var charsLocations = this.getCharsAbsoluteLocations(text, IDFont, IDFontSize);
//   var fontHeight = this.getTextHeight(text, IDFont, IDFontSize);
//   var radius = (textLength * 180) / (Math.abs(arc) * Math.PI);
//   var cX = Math.cos((Math.PI / 180) * (180 - Math.abs(arc)) / 2) * (fontHeight + radius);
//   var cY = y + fontHeight + radius;
//   var charAngle, textRadius, disX, disY;

//   const rotatedPoints = []; // 🆕 New: to track all rotated corners for bounding box

//   for (var i = 0; i < text.length; i++) {
//     if (this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]] != null) {
//       var locX = charsLocations[i].x;
//       var locY = charsLocations[i].y;
//       if (arc != 0) {
//         var positionMiddleChar = charsLocations[i].x + (this.getCharWidth(IDFont, IDFontSize, text[i]) / 2);
//         var charMiddle = charsLocations[i].x + (this.getCharWidth(IDFont, IDFontSize, text[i]) / 2);
//         var relativePos = (charMiddle - charsLocations[0].x) / textLength;
//         // charArc = -(arc / 2) + (relativePos * arc);

//         if (arc > 0) {
//           charArc = -(arc / 2) + (relativePos * arc);

//           // charArc = -(arc / 2) + ((positionMiddleChar / textLength) * arc);
//           charAngle = arc - ((positionMiddleChar / textLength) * arc) + ((180 - arc) / 2);
//           textRadius = fontHeight - charsLocations[i].y - (this.getCharHeight(IDFont, IDFontSize, text[i]) / 2) + radius;
//           disX = textRadius * Math.cos((Math.PI / 180) * (180 - charAngle));
//           disY = textRadius * Math.sin((Math.PI / 180) * (180 - charAngle));
//           locX = x + (cX - disX) - ((this.getCharWidth(IDFont, IDFontSize, text[i]) / 2));
//           locY = (cY - disY) - ((this.getCharHeight(IDFont, IDFontSize, text[i]) / 2));
//         } else {
//           charArc = (Math.abs(arc) / 2) - (relativePos * Math.abs(arc));
//           // charArc = (Math.abs(arc) / 2) - ((positionMiddleChar / textLength) * Math.abs(arc));
//           charAngle = ((180 - Math.abs(arc)) / 2) + ((positionMiddleChar / textLength) * Math.abs(arc));
//           textRadius = charsLocations[i].y + (this.getCharHeight(IDFont, IDFontSize, text[i]) / 2) + radius;
//           disX = textRadius * Math.cos((Math.PI / 180) * (charAngle));
//           disY = textRadius * Math.sin((Math.PI / 180) * (charAngle));
//           cY = y + (Math.cos((Math.PI / 180) * (Math.abs(arc) / 2)) * radius);
//           locX = x + (cX - disX) - ((this.getCharWidth(IDFont, IDFontSize, text[i]) / 2));
//           locY = y + disY - (this.getCharHeight(IDFont, IDFontSize, text[i]) / 2) - (cY - y);
//         }

      

//     }

//     // 🆕 Rotate 4 corners of character and add to rotatedPoints
//       const w = this.getCharWidth(IDFont, IDFontSize, text[i]);
//       const h = this.getCharHeight(IDFont, IDFontSize, text[i]);
//       const cx = locX + w / 2;
//       const cy = locY + h / 2;
//       const angleRad = (charArc || 0) * Math.PI / 180;

//       const corners = [
//         { x: locX,     y: locY     }, // top-left
//         { x: locX + w, y: locY     }, // top-right
//         { x: locX + w, y: locY + h }, // bottom-right
//         { x: locX,     y: locY + h }  // bottom-left
//       ];

//       for (const pt of corners) {
//         const dx = pt.x - cx;
//         const dy = pt.y - cy;
//         const rotatedX = cx + dx * Math.cos(angleRad) - dy * Math.sin(angleRad);
//         const rotatedY = cy + dx * Math.sin(angleRad) + dy * Math.cos(angleRad);
//         rotatedPoints.push({ x: rotatedX, y: rotatedY });
//       }


//     charsLocationsList.push({
//       x: locX,
//       y: locY,
//       arc: charArc
//     });
//   }

//       }
//   // 🆕 Compute bounding box from all rotated corners
//   let minX = Infinity, maxX = -Infinity;
//   let minY = Infinity, maxY = -Infinity;

//   for (const pt of rotatedPoints) {
//     minX = Math.min(minX, pt.x);
//     maxX = Math.max(maxX, pt.x);
//     minY = Math.min(minY, pt.y);
//     maxY = Math.max(maxY, pt.y);
//   }

//   var dragSize = {
//     w: maxX - minX,
//     h: maxY - minY
//   };

//   return {
//     charsLocationsList: charsLocationsList,
//     dragSize: dragSize
//   };
// },
// ------------------

/**
 * מחשבת מיקומים ותיבה תוחמת עבור טקסט בקו ישר (arc=0).
 * @param {string} text - הטקסט להצגה
 * @param {number} x - קואורדינטת X התחלתית
 * @param {number} y - קואורדינטת Y התחלתית
 * @param {string} IDFont - מזהה הפונט
 * @param {string} IDFontSize - מזהה גודל הפונט
 * @returns {object} - אובייקט המכיל את רשימת מיקומי האותיות ואת גודל התיבה התוחמת
 */
getCharsLocationsLinear(text, x, y, IDFont, IDFontSize) {
    const charsLocationsList = [];
    
    // הנחה: פונקציה זו מחזירה מיקומים יחסיים (כאילו הטקסט מתחיל ב-0,0)
    const initialCharsLocations = this.getCharsAbsoluteLocations(text, IDFont, IDFontSize);

    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[char] == null) {
            continue;
        }

        // המיקום הסופי הוא המיקום היחסי של האות + ההיסט ההתחלתי (x, y)
        const locX = x + initialCharsLocations[i].x;
        const locY = y + initialCharsLocations[i].y;

        charsLocationsList.push({
            x: locX,
            y: locY,
            arc: 0 // בקו ישר, סיבוב כל אות הוא 0
        });
    }

    // התיבה התוחמת בטקסט ישר היא פשוט הרוחב והגובה הכוללים של הטקסט
    const dragSize = {
        w: this.getTextLength(text, IDFont, IDFontSize),
        h: this.getTextHeight(text, IDFont, IDFontSize)
    };

    return {
        charsLocationsList,
        dragSize
    };
},
getCharsLocationsWithArc(text, x, y, arc, IDFont, IDFontSize) {
  var charArc = 0;
  var charsLocationsList = [];
  var textLength = this.getTextLength(text, IDFont, IDFontSize);
  var charsLocations = this.getCharsAbsoluteLocations(text, IDFont, IDFontSize); // מחשב את מיקומי האותיות
  var fontHeight = this.allFonts.value[IDFont].sizes[IDFontSize].FontHeight;
  // var fontHeight = Math.max.apply(Math, Object.values(text).map(s=> this.getCharHeight(IDFont, IDFontSize, s) + this.getDyChar(IDFont, IDFontSize, s)));
  var radius = (textLength * 180) / (Math.abs(arc) * Math.PI);
  var cX = Math.cos((Math.PI / 180) * (180 - Math.abs(arc)) / 2) * (fontHeight + radius);
  var cY = y + fontHeight + radius;
  var charAngle, textRadius, disX, disY;
  for (var i = 0; i < text.length; i++) {
    if (this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]] != null) {
      //שומר את מיקום האות אם אין זווית
      var locX = charsLocations[i].x;
      var locY = charsLocations[i].y;
      if (arc != 0) {
        var positionMiddleChar = charsLocations[i].x + (this.getCharWidth(IDFont, IDFontSize, text[i]) / 2);
        if (arc > 0) {
          //חישוב הזווית בצורה מתאימה לתצוגת מחשב
          charArc = -(arc / 2) + ((positionMiddleChar / textLength) * arc);
          //חישוב הזווית בצורה מתמטית
          charAngle = arc - ((positionMiddleChar / textLength) * arc) + ((180 - arc) / 2);
          textRadius = fontHeight - charsLocations[i].y - (this.getCharHeight(IDFont, IDFontSize, text[i]) / 2) + radius;
          disX = textRadius * Math.cos((Math.PI / 180) * (180 - charAngle));
          disY = textRadius * Math.sin((Math.PI / 180) * (180 - charAngle));
          locX = x + (cX - disX) - ((this.getCharWidth(IDFont, IDFontSize, text[i]) / 2));
          locY = (cY - disY) - ((this.getCharHeight(IDFont, IDFontSize, text[i]) / 2));
        } else {
          //חישוב הזווית בצורה מתאימה לתצוגת מחשב
          charArc = (Math.abs(arc) / 2) - ((positionMiddleChar / textLength) * Math.abs(arc));
          //חישוב הזווית בצורה מתמטית
          charAngle = ((180 - Math.abs(arc)) / 2) + ((positionMiddleChar / textLength) * Math.abs(arc));
          textRadius = charsLocations[i].y + (this.getCharHeight(IDFont, IDFontSize, text[i]) / 2) + radius;
          disX = textRadius * Math.cos((Math.PI / 180) * (charAngle));
          disY = textRadius * Math.sin((Math.PI / 180) * (charAngle));
          cY = y + (Math.cos((Math.PI / 180) * (Math.abs(arc) / 2)) * radius);
          locX = x + (cX - disX) - ((this.getCharWidth(IDFont, IDFontSize, text[i]) / 2));
          locY = y + disY - (this.getCharHeight(IDFont, IDFontSize, text[i]) / 2) - (cY - y);
        }
      }
      charsLocationsList.push({
        x: locX,
        y: locY,
        arc: charArc
      });
    }
  }
  var dragSize = (arc == 0 ? {
    w: textLength,
    h: fontHeight,
  } : arc > 0 ? {
    w: cX * 2,
    h: Math.abs(cY - y - (Math.cos((Math.PI / 180) * (Math.abs(arc) / 2)) * radius))
  } : {
    w: cX * 2,
    h: radius + fontHeight - (Math.cos((Math.PI / 180) * (Math.abs(arc) / 2)) * radius)
  });
  return {
    charsLocationsList: charsLocationsList,
    //צריך לחשב פה מדוייק את גודל הדראגאבל
    dragSize: dragSize
  };
},
getCharsAbsoluteLocations(text, IDFont, IDFontSize) {
  var location = 0.0;
  var charsLocationsList = [];
  for (var i = 0; i < text.length; i++) {
    if (this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]] != null) {
      charsLocationsList.push({
        x: location,
        y: (-this.allFonts.value[IDFont].sizes[IDFontSize].DictCharacters[text[i]].dyAlign)
      });
    }
    if (text.length > i) {
      var kerPair = [...this.allFonts.value[IDFont].kerning].find(x => {
        if (x.leftChars.indexOf(text[i]) >= 0 && x.rightChars.indexOf(text[i + 1]) >= 0)
          return x;
      });
      if (kerPair != null) {
        location = parseFloat(location + ((this.getCharWidth(IDFont, IDFontSize, text[i]) +
          (kerPair.distance * parseFloat(this.allFonts.value[IDFont].sizes[IDFontSize].sizeInches)))));
      } else {
        location = location + ((this.getCharWidth(IDFont, IDFontSize, text[i]) + 20));
      }
    }
  }
  return charsLocationsList;
},
getTextLength(text, IDFont, IDFontSize) {
  var length = 0.0;
  for (var i = 0; i < text.length - 1; i++) {
    if (text.length > i) {
      var kerPair = [...this.allFonts.value[IDFont].kerning].find(x => {
        if (x.leftChars.indexOf(text[i]) >= 0 && x.rightChars.indexOf(text[i + 1]) >= 0)
          return x;
      });
      if (kerPair != null) {
        length = parseFloat(length + ((this.getCharWidth(IDFont, IDFontSize, text[i]) +
          (kerPair.distance * parseFloat(this.allFonts.value[IDFont].sizes[IDFontSize].sizeInches)))));
      } else {
        length = length + (this.getCharWidth(IDFont, IDFontSize, text[i]) + 20);
      }
    }
  }

  length = text[text.length - 1] ? length + this.getCharWidth(IDFont, IDFontSize, text[text.length - 1]) : length;
  return length;
},
getMaxTextHeight(text, IDFont, IDFontSize) {
  var max = text == "" ? 0 : this.getCharHeight(IDFont, IDFontSize, text[0]);
  for (var i = 1; i < text.length; i++) {
    max = this.getCharHeight(IDFont, IDFontSize, text[i]) > max ? this.getCharHeight(IDFont, IDFontSize, text[i]) : max;
  }
  return max;
},
    getMonogramLocation(monogram, distance1, distance2, align, char1, char2, char3, x, y) {
      console.log(char1, char2);
      const old_y = y;
      const old_x = x;
      var leftFile = null;
      var rightFile = null;
      var middleFile = null;
      var location = [];
      var dragSize = {
        w: 0,
        h: 0
      }
      var filesObjects = this.createCharsFiles(monogram, char1, char2, char3);
      leftFile = filesObjects.leftFile;
      middleFile = filesObjects.middleFile;
      rightFile = filesObjects.rightFile;
      y = old_y + this.getMonogramTop("left", // שומר את הטופ של האות הראשונה, הלפט נשאר כמו שהגיע לאות הראשונה
        this.allMonograms.value[monogram.monogramID],
        align,
        leftFile,
        rightFile,
        middleFile);
      location.push({ x: x, y: y }); // דוחף את מיקום האות הראשונה      
      dragSize.h = this.getMaxMonogramHeight(monogram, char1, char2, char3);
      //מעדכן את המרחק הבא להיות אחרי האות הראשונה והמרחק הראשון
      x = x + this.getCharWidthFromCharObj(this.allMonograms.value[monogram.monogramID].leftChar, char1) + parseFloat(distance1);
      //אם יש רק שתי אותיות - מחשב את המיקום הבא בדילוג על האות האמצעית
      if (this.allMonograms.value[monogram.monogramID].numOfCharacters == "2") {
        y = old_y + this.getMonogramTop("right",
          this.allMonograms.value[monogram.monogramID],
          align,
          leftFile,
          rightFile,
          middleFile);
        location.push({ x: x, y: y });
        dragSize.w = x + this.getCharWidthFromCharObj(this.allMonograms.value[monogram.monogramID].rightChar, char3) - old_x;
      } else if (this.allMonograms.value[monogram.monogramID].numOfCharacters == "3") {
        y = old_y + this.getMonogramTop("middle",
          this.allMonograms.value[monogram.monogramID],
          align,
          leftFile,
          rightFile,
          middleFile);
        location.push({ x: x, y: y });
        x = x + this.getCharWidthFromCharObj(this.allMonograms.value[monogram.monogramID].middleChar, char2) +
          parseFloat(distance2)
        y = old_y + this.getMonogramTop("right",
          this.allMonograms.value[monogram.monogramID],
          align,
          leftFile,
          rightFile,
          middleFile);
        location.push({ x: x, y: y });
        dragSize.w = x + this.getCharWidthFromCharObj(this.allMonograms.value[monogram.monogramID].rightChar, char3) - old_x;
      }
      return {
        location: location,
        dragSize: dragSize
      };
    },
    getCharWidthFromCharObj(charObj, char) {
      return (this.allFonts.value[charObj.fontID].sizes[charObj.fontSizeID].DictCharacters[char].dstfile.pixelWidth);
    },
    getCharWidth(fontID, fontSizeID, char) {
      return this.allFonts.value[fontID].sizes[fontSizeID].DictCharacters[char] ?
        this.allFonts.value[fontID].sizes[fontSizeID].DictCharacters[char].dstfile.pixelWidth : 0;
    },
    getCharHeight(fontID, fontSizeID, char) {
      return this.allFonts.value[fontID].sizes[fontSizeID].DictCharacters[char] ?
        this.allFonts.value[fontID].sizes[fontSizeID].DictCharacters[char].dstfile.pixelHeight : 0;
    },
    getDyChar(fontID, fontSizeID, char) {
      return -(this.allFonts.value[fontID].sizes[fontSizeID].DictCharacters[char].dyAlign);
    },
    getCharDst(charObj, char) {
      return (this.allFonts.value[charObj.fontID].sizes[charObj.fontSizeID].DictCharacters[char].dstfile);
    },
    getMonogramTop(char, monogramObj, align, leftFile, rightFile, middleFile) {
      console.log(leftFile, middleFile);
      if (align == "top") {
        return 0;
      } else if (align == "center") {
        return (
          (this.getMaxMonogramHeight(monogramObj,
            leftFile.c, middleFile != null ? middleFile.c : null, rightFile.c) / 2 -
            (char == "left"
              ? leftFile.dstfile.pixelHeight
              : char == "right"
                ? rightFile.dstfile.pixelHeight
                : middleFile.dstfile.pixelHeight) / 2)
        );
      } else {
        return (
          (this.getMaxMonogramHeight(monogramObj,
            leftFile.c, middleFile != null ? middleFile.c : null, rightFile.c) -
            (char == "left"
              ? leftFile.dstfile.pixelHeight
              : char == "right"
                ? rightFile.dstfile.pixelHeight
                : middleFile.dstfile.pixelHeight))
        );
      }
    },
    createCharsFiles(monogramObj, char1, char2, char3) {
      console.log(monogramObj, char1, char2);
      console.log(this.allFonts.value[monogramObj.leftChar.fontID].sizes);
      console.log(this.allFonts.value[monogramObj.leftChar.fontID].sizes[
        monogramObj.leftChar.fontSizeID]);
      console.log(this.allFonts.value[monogramObj.leftChar.fontID].sizes[
        monogramObj.leftChar.fontSizeID].DictCharacters[char1]);
      var leftFile = null;
      var middleFile = null;
      var rightFile = null;
      leftFile =
        this.allFonts.value[monogramObj.leftChar.fontID].sizes[
          monogramObj.leftChar.fontSizeID
        ].DictCharacters[char1] ?
          this.allFonts.value[monogramObj.leftChar.fontID].sizes[
            monogramObj.leftChar.fontSizeID
          ].DictCharacters[char1] :
          this.allFonts.value[monogramObj.leftChar.fontID].sizes[
            monogramObj.leftChar.fontSizeID
          ].DictCharacters[char1.toUpperCase()];

      rightFile =
        (this.allFonts.value[monogramObj.rightChar.fontID].sizes[
          monogramObj.rightChar.fontSizeID
        ].DictCharacters[char3] ?
          this.allFonts.value[monogramObj.rightChar.fontID].sizes[
            monogramObj.rightChar.fontSizeID
          ].DictCharacters[char3] :
          this.allFonts.value[monogramObj.rightChar.fontID].sizes[
            monogramObj.rightChar.fontSizeID
          ].DictCharacters[char3.toUpperCase()]);
      if (
        monogramObj.numOfCharacters != "2" &&
        monogramObj.middleChar.fontID > 0
      ) {
        middleFile = this.allFonts.value[
          monogramObj.middleChar.fontID
        ].sizes[monogramObj.middleChar.fontSizeID].DictCharacters[char2] ?
          this.allFonts.value[monogramObj.middleChar.fontID].sizes[
            monogramObj.middleChar.fontSizeID
          ].DictCharacters[char2] :
          this.allFonts.value[monogramObj.middleChar.fontID].sizes[
            monogramObj.middleChar.fontSizeID
          ].DictCharacters[char2.toUpperCase()];
      }
      console.log(leftFile, middleFile);
      return { leftFile: leftFile, middleFile: middleFile, rightFile: rightFile };
    },
    updateTextLocation(productID, variantID, imageName, index, text, x, y, textArc, IDFont, IDFontSize) {
      const uStore = userStore();
      text = this.fixText(IDFont, IDFontSize, text);
      var result = this.getCharsLocationsWithArc(text, x, y, textArc, IDFont, IDFontSize);
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].location = result.charsLocationsList;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragSize = result.dragSize;
      
      //update drag transform
      // uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.dpi = this.currentEditingProps.dpi;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.width = result.dragSize.w * this.currentEditingProps.dpi / 254;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.height = result.dragSize.h * this.currentEditingProps.dpi / 254;

      // uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.rotate = textArc;

      // uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.x = x;
      // uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.y = y;
    },
    updateTextSVGLocation(productID, variantID, imageName, index, text, x, y, textArc, IDFont) {
      const uStore = userStore();
      // text = this.fixText(IDFont, IDFontSize, text);
      var result = this.getTextSVGDragSize(text, IDFont, uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].layersColors[0], textArc);
      // uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].location = result.charsLocationsList;
      // uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragSize = result.drag;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].svgContent = result.newSVGContent;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.width = result.drag.w;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts[index].dragTransform.height = result.drag.h;
    },
    getTextSVGDragSize(text, IDFont, colorID, textArc) { //}, IDFont, colorId) {
      var newSVGContent = "";
      var result = this.loadText(textArc, text, 20, colorID, IDFont);
      var drag = {
        w: result.width,
        h: result.height
      };
      newSVGContent = result.svg;
      // await this.loadText(this.allFontsFiles.value[IDFont].relativeFontPath, text, colorId)
      // .then(({ svg, width, height }) => {
      //   console.log('Generated SVG:', svg);
      //   console.log('Width:', width, 'Height:', height);
      //   newSVGContent = svg;
      //   drag = {
      //     w: width,
      //     h: height
      //   }
      //   // Insert the SVG into your app
      //   // document.getElementById('svg-container').innerHTML = svgTag;
      // })
      // .catch(err => {
      //   console.error('Error loading text:', err);
      // });
      console.log('newSVGContent = ', newSVGContent);
      
      return {newSVGContent: newSVGContent, drag: drag};
    },
    updateArtLocation(productID, variantID, imageName, index, arc) {
      const uStore = userStore();
      var result = this.getArtDragSize(
        this.allArts.value[uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].arts[index].artID].sizes[
        uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].arts[index].artSizeID],
        uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].arts[index].dragLocation, arc);
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].arts[index].location = result.location;
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].arts[index].dragSize = result.dragSize;
    },
    getArtDragSize(artObj, dragLocation, arc) {
      arc = Math.abs(arc) > 90 ? Math.abs(arc) - 90 : Math.abs(arc);
      var artWidth = artObj.dstfile.pixelWidth;
      var artHeight = artObj.dstfile.pixelHeight;
      var dragWidth = (Math.cos((Math.PI / 180) * Math.abs(arc)) * artWidth) + (Math.sin((Math.PI / 180) * Math.abs(arc)) * artHeight);
      var dragHeight = (Math.cos((Math.PI / 180) * Math.abs(arc)) * artHeight) + (Math.sin((Math.PI / 180) * Math.abs(arc)) * artWidth);
      return {
        location: {
          x: dragLocation.x + ((dragWidth - artWidth) / 2),
          y: dragLocation.y + ((dragHeight - artHeight) / 2)
        },
        dragSize: {
          w: dragWidth,
          h: dragHeight
        }
      }
    },
    delText(productID, variantID, imageName, index) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].texts.splice(index, 1);
    },
    delArt(productID, variantID, imageName, index) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].arts.splice(index, 1);
    },
    delUserArt(productID, variantID, imageName, index) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].userArts.splice(index, 1);
    },
    delMonogram(productID, variantID, imageName, index) {
      const uStore = userStore();
      uStore.userDesigns[productID].designs[variantID].imgVariants[imageName].monograms.splice(index, 1);
    },
    getMonogramDst(charObj, char) {
      var monogramDst = null;
          monogramDst = this.allFonts.value[charObj.fontID]
                .sizes[charObj.fontSizeID].DictCharacters[char].dstfile;
      return monogramDst;

    },
    //    saveToLocalStorageWithCompression(key, object) {

    //     // ממירים את האובייקט למחרוזת JSON
    //     const jsonString = JSON.stringify(object);

    //     // מכווצים את המחרוזת
    //     const compressedString = LZString.compressToBase64(jsonString);

    //     // שומרים את המחרוזת המכווצת ב-Local Storage
    //     localStorage.setItem(key, compressedString);
    // }
    // ,

    async loadAppAdmin() {
      const keysArray = this.keysArray;
      // Fetch all data from the database
      const rawResponse = await fetch(baseURL + '/api/Storage/GetAllKeyHash', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response.json();
      }).catch((error) => {
        console.error('Error fetching key hashes:', error);
        return null;
      });

      if (rawResponse) {
        var content = rawResponse;
        // Loop through each key and fetch the corresponding data
        for (const element of keysArray) {
          let localStore = JSON.parse(localStorage.getItem(element))
          // if (localStore!=null){
          //  localStore = LZString.decompressFromBase64(localStore)

          // // ממירים חזרה לאובייקט
          // JSON.parse(localStore);}

          var contentIndex = content.findIndex(d => d.key == element);
          if(contentIndex > -1) {
            if (localStore?.hash != content[contentIndex]?.hash) {
              const dataResponse = await fetch(baseURL + '/api/Storage/GetDataToKey?key=' + element, {
                method: 'GET',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
              });
              const data = await dataResponse.json();
              console.log(data)
              if (data.value.startsWith("{\"value"))
                this[element] = JSON.parse(data.value || {})
              else
                this[element] = { value: JSON.parse(data.value || {}) }
            }
          }
          else {
            await fetch(baseURL + '/api/Storage/AddStorage', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              Key: element,
              Value: JSON.stringify(localStore ? localStore.value : {}),
              Hash: md5(JSON.stringify(localStore ? localStore.value : {})),
              LastModified: new Date().toISOString()
            })
          }).then((response) => {
            if (response.status >= 400 && response.status < 600) {
              throw new Error("Bad response from server");
            }
            return response;
          });
            // this[element] = { value: localStore ? localStore.value : {} };
            const dataResponse = await fetch(baseURL + '/api/Storage/GetDataToKey?key=' + element, {
                method: 'GET',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
              });
              const data = await dataResponse.json();
              console.log(data)
              if (data.value.startsWith("{\"value"))
                this[element] = JSON.parse(data.value || {})
              else
                this[element] = { value: JSON.parse(data.value || {}) }
          }

          // Insert values into allStoreHashes
          // if (!this.allStoresHashs[element]) {
          this.allStoresHashs[element] = {
            key: element,
            hash: content.find(obj => obj.key == element)?.hash,
            lastMod: content.find(obj => obj.key == element)?.lastModified
            // };
          }

        }
      }
      const allDetails = await this.getAllProductsInfo(1, 20, "", "", "", false);
      this.allProducts = JSON.parse(allDetails.allProducts);
      this.countFilter = allDetails.countFilter;
      this.countTotal = allDetails.countTotal;
      this.pageTotal = Math.ceil(this.countFilter / 20);
      // Handle conflicts
      this.isConflict = false;
      this.conflictArray = keysArray.filter(key => {
        const thisStore = JSON.parse(localStorage.getItem(key));
        return thisStore && thisStore.lastSaveInServerDate && this.allStoresHashs[key]?.hash !== thisStore.hash &&
          thisStore.lastSaveInServerDate != this.allStoresHashs[key]?.lastMod;
      }).map(key => {
        return {
          key: key,
          preference: ""
        }
      });

      if (this.conflictArray.length > 0) {
        this.isConflict = true;
      }

      //הוספת הארטים של המשתמש לסטור הארטים
    //let userId = this.getOrCreateUserID();
    const userArtsRes = await fetch(baseURL + `/api/UserUploadArt/GetAllUserArts`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response.json();
      }).catch((error) => {
        console.error('Error fetching key hashes:', error);
        return null;
      });

      this.allUserArts = {value: {}};
      this.allUserArtsSvg = {value: {}};
      const userArtsList = Array.isArray(userArtsRes)
        ? userArtsRes
        : Object.values(userArtsRes || {});
      userArtsList.forEach(userArt => {
        console.log('userArt = ', userArt);
        // נוודא ש-dstSizesJson הוא מחרוזת ונפרש אותו
        if (userArt.dstSizesJson && typeof userArt.dstSizesJson === 'string') {
          try {
            userArt.dstSizesJson = JSON.parse(userArt.dstSizesJson);
          } catch (e) {
            console.error("Failed to parse dstSizesJson", e);
            userArt.dstSizesJson = {}; // או תשאירי כמו שהוא, תלוי בצורך
          }
        }

        if(userArt.imgB64Content && typeof userArt.imgB64Content === 'string') {
          this.allUserArts.value[userArt.userUploadedArtID] = {
            ...userArt,
            dstSizesJson: userArt.dstSizesJson || {},
          }
        } else if(userArt.svgB64Content && typeof userArt.svgB64Content === 'string') {
          this.allUserArtsSvg.value[userArt.userUploadedArtID] = {
            ...userArt
          }
        }
      });

      this.saveChangesFromDesignStoreToLocalStorage();
      this.isLoadingComplete = true;


    },
    async GetProductInfoByID(productID) {
      const response = await fetch(`${baseURL}/api/ProductsInfo/GetProductInfoByID?productID=${productID}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      });

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad response from server");
      }

      const productsInfoDetails = await response.json();

      return productsInfoDetails;
    },
    async saveDstToUserArts() {
      const userArts = Object.values(this.allUserArts.value).map(art => {
        return {
          userUploadedArtID: art.userUploadedArtID,
          dstSizesJson: JSON.stringify(art.dstSizesJson),
        }
      });
      //UpdateAllUserArtsDst
      const updateDstJsonResponse = await fetch(baseURL + `/api/UserUploadArt/UpdateAllUserArtsDst`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userArts)
      }).catch(err => console.log('Fetch error:', err));
      console.log('updateDstJsonResponse = ', updateDstJsonResponse);
    },
    async saveAdminChanges() {
      const newHashes = {};

      // Calculate hashes for each key in keysArray
      this.keysArray.forEach(key => {
        newHashes[key] = {
          key: key,
          hash: md5(JSON.stringify(this[key])),
        };
      });

      let newStores = [];
      for (const key of this.keysArray) {
        if (!this.allStoresHashs[key] || !this.allStoresHashs[key].hash || this.allStoresHashs[key].hash !== newHashes[key].hash) {
          if (!this.allStoresHashs[key] || !this.allStoresHashs[key].hash) {
            newStores.push(key);
            this.allStoresHashs[key] = {};
          }
          // this.allStoresHashs[key].hash = newHashes[key].hash;
          this.allStoresHashs[key].lastMod = new Date().toISOString();
        }
      }

      for (const key of newStores) {
        try {
          const response = await fetch(`${baseURL}/api/Storage/AddStorage`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              Key: key,
              Value: JSON.stringify(this[key]),
              Hash: newHashes[key].hash,
              LastModified: this.allStoresHashs[key].lastMod
            })
          });

          if (response.status >= 400 && response.status < 600) {
            throw new Error("Bad response from server");
          }
        } catch (error) {
          console.log(error);
        }
      }

      var localDate = new Date().toISOString();

      for (const key of this.keysArray) {
        const storedHash = this.allStoresHashs[key]?.hash;
        if (storedHash && storedHash !== newHashes[key].hash) {
          try {
            const response = await fetch(`${baseURL}/api/Storage/UpdateStorage`, {
              method: 'PUT',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                Key: key,
                Value: JSON.stringify(this[key]),
                Hash: newHashes[key].hash,
                LastModified: localDate
              })
            });

            if (response.status >= 400 && response.status < 600) {
              throw new Error("Bad response from server");
            }

            // Update after a successful server response
            this.allStoresHashs[key] = {
              key: key,
              hash: md5(JSON.stringify(this[key])), // עדכון מחדש של ה-hash
              lastMod: localDate // עדכון מחדש של הזמן האחרון לשינוי
            };

          } catch (error) {
            console.log(error);
          }
        } else if(storedHash == undefined) {
          // Update after a successful server response
          this.allStoresHashs[key] = {
            key: key,
            hash: md5(JSON.stringify(this[key])), // עדכון מחדש של ה-hash
            lastMod: localDate // עדכון מחדש של הזמן האחרון לשינוי
          };
        }
      }
    }

    ,
    async loadAppUser() {
      // const uStore = userStore();

      const keysArray = this.keysArray;
      // Fetch all data from the database
      const rawResponse = await fetch(baseURL + '/api/Storage/GetAllKeyHash', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response.json();
      }).catch((error) => {
        console.error('Error fetching key hashes:', error);
        return null;
      });

      if (rawResponse) {
        var content = rawResponse;
    
        // Loop through each key and fetch the corresponding data
        for (const element of keysArray) {
            const localStoreData = localStorage.getItem(element);
            const localStore = localStoreData ? JSON.parse(localStoreData) : null;
    
            // Ensure `content` is defined and contains `element`
            const foundItem = content ? Object.values(content).find(x => x.key == element) : null;
    
            if (foundItem && foundItem.hash && localStore?.hash !== foundItem.hash) {
                try {
                    const dataResponse = await fetch(baseURL + '/api/Storage/GetDataToKey?key=' + element, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                    });
    
                    const data = await dataResponse.json();
                    console.log(data);
    
                    if (data?.value && typeof data.value === "string") {
                        if (data.value.startsWith("{\"value")) {
                            this[element] = JSON.parse(data.value || "{}");
                        } else {
                            this[element] = { value: JSON.parse(data.value || "{}").value };
                        }
                    } else {
                        console.warn(`Invalid data.value for ${element}:`, data);
                        this[element] = {};
                    }
                } catch (error) {
                    console.error(`Error fetching data for ${element}:`, error);
                    this[element] = {};
                }
            } else {
                this[element] = localStore ? localStore.value : {};
            }
  


            // Ensure content[element] exists before accessing properties
            if (content && content[element]) {
                this.allStoresHashs[element] = {
                    key: element,
                    hash: content[element]?.hash || null,
                    lastMod: content[element]?.lastModified || null
                };
            } else {
                console.warn(`content[element] is undefined for key: ${element}`);
            }
        }

    }
    //הוספת הארטים של המשתמש לסטור הארטים
    let userId = this.getOrCreateUserID();
    const userArtsRes = await fetch(baseURL + `/api/UserUploadArt/GetAllUserArts?userId=${encodeURIComponent(userId)}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response.json();
      }).catch((error) => {
        console.error('Error fetching key hashes:', error);
        return null;
      });


this.allUserArts = {value: {}};
      this.allUserArtsSvg = {value: {}};
      const userArtsList = Array.isArray(userArtsRes)
        ? userArtsRes
        : Object.values(userArtsRes || {});
      userArtsList.forEach(userArt => {
        console.log('userArt = ', userArt);
        // נוודא ש-dstSizesJson הוא מחרוזת ונפרש אותו
        if (userArt.dstSizesJson && typeof userArt.dstSizesJson === 'string') {
          try {
            userArt.dstSizesJson = JSON.parse(userArt.dstSizesJson);
          } catch (e) {
            console.error("Failed to parse dstSizesJson", e);
            userArt.dstSizesJson = {}; // או תשאירי כמו שהוא, תלוי בצורך
          }
        }

        if(userArt.imgB64Content && typeof userArt.imgB64Content === 'string') {
          this.allUserArts.value[userArt.userUploadedArtID] = {
            ...userArt,
            dstSizesJson: userArt.dstSizesJson || {},
          }
        } else if(userArt.svgB64Content && typeof userArt.svgB64Content === 'string') {
          this.allUserArtsSvg.value[userArt.userUploadedArtID] = {
            ...userArt
          }
        }
      });


//קוד קודם
    //   if(!this.allUserArts.value){
    //     this.allUserArts.value = {};
    //   }

    //   Object.values(userArtsRes).forEach(userArt => {
    //     console.log('userArt = ', userArt);
    //     //בדיקה האם צריך להיטען סטור הארטים הרגילים או לסטור נפרד כי אים דיאסטי
    //     if(userArt.dstSizesJson != null && userArt.dstSizesJson != undefined && userArt.dstSizesJson != "" && userArt.dstSizesJson != '{}') {
    //     var dstSizesObj = JSON.parse(userArt.dstSizesJson);
    //     var isAvailableSizes = Object.values(dstSizesObj.sizes).filter(artSize => artSize.isAvailable == true);
    //     if(isAvailableSizes) {
    //       this.allArts.value[userArt.userUploadedArtID] = dstSizesObj;
    //       this.allArts.value[userArt.userUploadedArtID].artID = userArt.userUploadedArtID;
    //     } else { //אם אין גדלים זמינים
    //       this.allUserArts.value[userArt.userUploadedArtID] = userArt;
    //     }
    //   } else { //אם אין דיאסטי בכלל
    //     this.allUserArts.value[userArt.userUploadedArtID] = userArt;
    //   }
    // });


    console.log(this.allFonts);
    this.isLoadingComplete = true;
    
    },


    saveChangesFromDesignStoreToLocalStorage() {
      var md5 = require('md5');
      // var countTry = 0;
      setInterval(() => {
        if (!this.isConflict) {
          this.keysArray.forEach(keyStore => {
            if(localStorage.getItem(keyStore) != null) {
              if (keyStore.length < 1000) {
                let hash = md5(JSON.stringify(this[keyStore] != undefined ? this[keyStore] : ""));
                if (hash != JSON.parse(localStorage.getItem(keyStore))?.hash) {
                  let obj = JSON.stringify({
                    value: this[keyStore], lastSaveInServerDate: this.allStoresHashs[keyStore].lastMod,
                    hash: hash, lastMyUpdate: new Date().toISOString()
                  });
                  localStorage.setItem(keyStore, obj);
                  // this.saveToLocalStorageWithCompression(keyStore, obj);
                }
              }
            }
            // else {
            //   // if(countTry < 3) {
            //   //   countTry++;
            //   //   let obj = JSON.stringify({
            //   //     value: this[keyStore], lastSaveInServerDate: this.allStoresHashs[keyStore]?.lastMod,
            //   //     hash: md5(JSON.stringify(this[keyStore] != undefined ? this[keyStore] : "")), lastMyUpdate: new Date().toISOString()
            //   //   });
            //   //   localStorage.setItem(keyStore, obj);
            //   //   // this.saveToLocalStorageWithCompression(keyStore, obj);
            //   // } else {
            //   //   console.warn(`Failed to save ${keyStore} to localStorage after 3 attempts.`);
            //     clearInterval(this);
            //   // }
            // }
          });
        }
      }, 5000)
    },
//     saveChangesFromDesignStoreToLocalStorage() {
//   const md5 = require('md5');

//   const intervalId = setInterval(() => {
//     // אם יש קונפליקט, לא נוגעים בכלום
//     if (this.isConflict) return;

//     this.keysArray.forEach(keyStore => {
//       // הגנה: אם המפתח ארוך מדי או שהערך ב-Store עדיין לא נטען (undefined)
//       if (keyStore.length >= 1000 || this[keyStore] === undefined) return;

//       const currentStoreValue = this[keyStore];
//       const localDataRaw = localStorage.getItem(keyStore);
      
//       // חישוב Hash לערך הנוכחי ב-Store
//       const currentHash = md5(JSON.stringify(currentStoreValue || ""));
      
//       let needsUpdate = false;

//       if (localDataRaw === null) {
//         // מקרה א': המפתח חדש לחלוטין - חייבים לשמור!
//         needsUpdate = true;
//       } else {
//         // מקרה ב': המפתח קיים, נבדוק אם ה-Hash השתנה
//         try {
//           const localObj = JSON.parse(localDataRaw);
//           if (localObj.hash !== currentHash) {
//             needsUpdate = true;
//           }
//         } catch (e) {
//           needsUpdate = true; // אם ה-JSON ב-Local משובש
//         }
//       }

//       if (needsUpdate) {
//         const lastMod = this.allStoresHashs[keyStore]?.lastMod || new Date().toISOString();
        
//         const objToSave = JSON.stringify({
//           value: currentStoreValue,
//           lastSaveInServerDate: lastMod,
//           hash: currentHash,
//           lastMyUpdate: new Date().toISOString()
//         });

//         localStorage.setItem(keyStore, objToSave);
//         console.log(`✅ מפתח ${keyStore} עודכן בהצלחה ב-LocalStorage`);
//       }
//     });
//   }, 5000);

//   // שמירת ה-ID כדי שתוכל לעצור אותו ב-unmounted אם תרצה
//   this.syncIntervalId = intervalId;
// },

    calculateDesignPriceNew() {
      const uStore = userStore();
      if(uStore.userDesigns[this.currentEditingProps.productId] != undefined && this.currentEditingProps.productType == 'Embroidery') {
      let desObj = uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId].imgVariants;
      let allTexts = desObj[this.currentEditingProps.imageToPreview].texts;
      let allArts = desObj[this.currentEditingProps.imageToPreview].arts;
      var allMonograms = desObj[this.currentEditingProps.imageToPreview].monograms;
      return this.calculateDesignPrice(allTexts, allArts, allMonograms, this.currentEditingProps.productType);
    } else {
      return 0;
    }
    },

    calculateDesignPrice(allTexts, allArts, allMonograms, productType) {
      if(productType == 'Embroidery') {
   
      let totalPrice = 0;
      let designsExplains = [];

      // Each design includes 2 lines of text, an additional line $8
      if(allTexts.length > 2) {
        totalPrice += (allTexts.length - 2) * 8;
        designsExplains.push({
          'qty': allTexts.length - 2,
          'linePrice': (allTexts.length - 2) * 8,
          'explain': `${allTexts.length - 2} extras texts`
        });
      }
      // For text with special font (2 color) + 5$
      let sumSpecialFonts = allTexts.filter(text => text.layersColors.length > 1).length;
      if(sumSpecialFonts > 0) {
        totalPrice += sumSpecialFonts * 5;
        designsExplains.push({
          'qty': sumSpecialFonts,
          'linePrice':sumSpecialFonts * 5,
          'explain': `${sumSpecialFonts} special fonts`
        });
      }
      // For each art $7 extra (with small arts for free)
      let bigArts = allArts.filter(art => this.allArts.value[art.artID].sizes[art.artSizeID].dstfile.pixelWidth / 254.0 > 1).length;
      if(bigArts > 0) {
        totalPrice += bigArts * 7;
        designsExplains.push({
          'qty': bigArts,
          'linePrice': bigArts * 7,
          'explain': `${bigArts} big arts`
        });
      }
      // Font >=2.5  inch 10$ (if it is 3 characters or more)
      let bigFontsChars = allTexts.filter(text => text.text.length >= 3 && this.allFonts.value[text.fontID].sizes[text.fontSizeID].sizeInches >= 2.5).length;
      if(bigFontsChars > 0) {
        totalPrice += bigFontsChars * 10;
        designsExplains.push({
          'qty': bigFontsChars,
          'linePrice': bigFontsChars * 10,
          'explain': `${bigFontsChars} long and big fonts`
        });
      }
      // Font >=2.5  inch 10$ (if it is 3 characters or more)
      let monograms = allMonograms.length;
      if(monograms > 0) {
        totalPrice += monograms * 10;
        designsExplains.push({
          'qty': monograms,
          'linePrice': monograms * 10,
          'explain': `${monograms} monograms`
        });
      }
      console.log('totalPrice = ', totalPrice);
      return {
        'totalPrice': totalPrice,
        'designsExplains': designsExplains
      };
    } return 0;
    },
    // calculateDesignPrice() {
    //   //sumStiches
    //   const uStore = userStore();
    //   var desObj = uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId].imgVariants;
    //   var allTexts = uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId].imgVariants[
    //     this.currentEditingProps.imageToPreview].texts;
    //   var allArts = uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId].imgVariants[
    //     this.currentEditingProps.imageToPreview].arts;
    //   // var allMonograms = uStore.userDesigns[this.currentEditingProps.productId].designs[this.currentEditingProps.variantId].imgVariants[
    //   //   this.currentEditingProps.imageToPreview].monograms;
      
    //     var merge = this.getColorsList(this.currentEditingProps.productId, this.currentEditingProps.variantId, this.currentEditingProps.imageToPreview, desObj);
    //     var colorsList = merge.colorsList;
        
    //     var sumStiches = 0;
    //     var sumLayers = colorsList;
    //     var sumSeconds = 0;

    //     allTexts.forEach(text => {
    //       //עבור כל אות סוכם את מספר המתיחות לפי גופן גודל ואות
    //       Object.values(text.text).forEach(char => {
    //         var stichesToChar = this.allFonts.value[text.fontID].sizes[text.fontSizeID].DictCharacters[char].dstfile.sumStiches; //כמות החלפות - שכבות
    //         sumStiches += stichesToChar;//כמות מתיחות
    //         // var layersToChar = this.allFonts[text.fontID].sizes[text.fontSizeID].DictCharacters[text].dstfile.layerCount; //כמות החלפות - שכבות
    //         // sumLayers += layers;
    //       })
    //     });
    //     allArts.forEach(art => {
    //       //עבור כל אות סוכם את מספר המתיחות לפי גופן גודל ואות
    //       var stichesToArt = this.allArts.value[art.artID].sizes[art.artSizeID].dstfile.sumStiches; //כמות החלפות - שכבות
    //       sumStiches += stichesToArt;//כמות מתיחות
    //       // var layersToChar = this.allFonts[text.fontID].sizes[text.fontSizeID].DictCharacters[text].dstfile.layerCount; //כמות החלפות - שכבות
    //       // sumLayers += layers;
    //     });

    //     //חישוב מתיחות למונוגרם
    //     // allMonograms.forEach(monogram => {
    //     //   //עבור כל אות סוכם את מספר המתיחות לפי גופן גודל ואות
    //     //   var monoObj = this.allMonograms[monogram.monogramID];
    //     //   var stichesToChar = this.allMonograms[monoObj.monogramID].sizes[text.fontSizeID].DictCharacters[text].dstfile.sumStiches; //כמות החלפות - שכבות
    //     //   sumStiches += stiches;//כמות מתיחות
    //     //   // var layersToChar = this.allFonts[text.fontID].sizes[text.fontSizeID].DictCharacters[text].dstfile.layerCount; //כמות החלפות - שכבות
    //     //   // sumLayers += layers;
          
    //     // });
        




    //     // imageName
    //     // monogramID
    //     // align
    //     // distance1
    //     // distance2
    //     // leftChar
    //     // middleChar
    //     // rightChar
    //     // colorsLeftChar
    //     // colorsMiddleChar
    //     // colorsRightChar
    //     // dragLocation
    //     // dragSize
    //     // location
    //     // dragTransform
    //     // numOfCharacters




        
    //     //   var sumStiches = 0;
    //   //   var sumLayers = 0;
    //   //   var sumSeconds = 0;

    //   // allTexts.forEach(text => {
    //   //   var stiches = text.sumStiches; //כמות מתיחות
    //   //   var layers = text.text; //כמות החלפות - שכבות
    //   //   sumStiches += stiches;
    //   //   sumLayers += layers;
    //   // });
    //   // allArts.forEach(art => {
    //   //   var stiches = art.sumStiches; //כמות מתיחות
    //   //   var layers = art.text; //כמות החלפות - שכבות
    //   //   sumStiches += stiches;
    //   //   sumLayers += layers;
    //   // });
    //   // allMonograms.forEach(monogram => {
    //   //   var stiches = monogram.sumStiches; //כמות מתיחות
    //   //   var layers = monogram.text; //כמות החלפות - שכבות
    //   //   sumStiches += stiches;
    //   //   sumLayers += layers;
    //   // });

    //   // const changeLayerBySeconds = 4; //מספר שניות לכל החלפת צבע/שכבה
    //   // const sumStichesToSeconds = 4; //מספר מתיחות לשניה
    //   // const priceTillOneM = 10; //מספר מתיחות לשניה
    //   // const priceTillOneHalfM = 15; //מספר מתיחות לשניה
    //   // const priceTillTwoM = 20; //מספר מתיחות לשניה

    //   sumSeconds += sumLayers * changeLayerBySeconds;
    //   sumSeconds += (sumStiches / sumStichesToSeconds);
    //   // var totalPrice = getTotalPriceFromSecondsRecursive(sumSeconds);
    //   var totalPrice = this.getTotalPriceFromSeconds(sumSeconds);
    //   return {
    //     sumSeconds: sumSeconds,
    //     totalPrice: totalPrice
    //   };
    // },
    // getTotalPriceFromSeconds(sumSeconds) {
    //   var price = 0;
    //   price += ((sumSeconds % 120) * priceTillTwoM);
    //   price += ((sumSeconds % 90) * priceTillOneHalfM);
    //   price += ((sumSeconds % 60) * priceTillOneM);
    //   return price;
    // },
    // getTotalPriceFromSecondsRecursive(sumSeconds) {
    //   if(sumSeconds <= 60) {
    //     return priceTillOneM;
    //   } else {
    //     if(sumSeconds <= 90) {
    //       return priceTillOneHalfM;
    //     } else {
    //       if(sumSeconds <= 120) {
    //         return priceTillTwoM;
    //       } else {
    //         return this.getTotalPriceFromSeconds(sumSeconds - 120) + priceTillTwoM; //מחזיר מחיר ל2 דקות ומזמן שוב את שאר הזמן שנשאר
    //       }
    //     }
    //   }
    // }
  },

  // Using lodash debounce to create a debounced version of persistData
  debouncedPersistData: debounce(function () {
    this.persistData();
  }, 2000),


  persist: false,

}
);

// // Ensure the persistence happens on initial load as well
// const store = designStore();
// const savedState = localStorage.getItem('storeData');
// if (savedState) {
//   store.$patch(JSON.parse(savedState));
// }
